import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React, { useState, useEffect, useContext, createContext, useMemo, useRef, cloneElement, isValidElement, useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var fails$m = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$l = fails$m;

var functionBindNative = !fails$l(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$b = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$b, call$b);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$b.apply(fn, arguments);
  };
};

var uncurryThis$l = functionUncurryThis;

var toString$a = uncurryThis$l({}.toString);
var stringSlice$6 = uncurryThis$l(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$6(toString$a(it), 8, -1);
};

var uncurryThis$k = functionUncurryThis;
var fails$k = fails$m;
var classof$5 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$k(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$k(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$5(it) == 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$3 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$2 = isNullOrUndefined$3;

var $TypeError$9 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$7 = function (it) {
  if (isNullOrUndefined$2(it)) throw $TypeError$9("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$6 = requireObjectCoercible$7;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$6(it));
};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$h =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var shared$4 = {exports: {}};

var global$g = global$h;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(global$g, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$g[key] = value;
  } return value;
};

var global$f = global$h;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$f[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.27.1',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.27.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$5 = requireObjectCoercible$7;

var $Object$3 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$5 = function (argument) {
  return $Object$3(requireObjectCoercible$5(argument));
};

var uncurryThis$j = functionUncurryThis;
var toObject$4 = toObject$5;

var hasOwnProperty = uncurryThis$j({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$4(it), key);
};

var uncurryThis$i = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$9 = uncurryThis$i(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$9(++id + postfix, 36);
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$i = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var global$e = global$h;
var isCallable$h = isCallable$i;

var aFunction = function (argument) {
  return isCallable$h(argument) ? argument : undefined;
};

var getBuiltIn$4 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$e[namespace]) : global$e[namespace] && global$e[namespace][method];
};

var getBuiltIn$3 = getBuiltIn$4;

var engineUserAgent = getBuiltIn$3('navigator', 'userAgent') || '';

var global$d = global$h;
var userAgent = engineUserAgent;

var process$1 = global$d.process;
var Deno = global$d.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$j = fails$m;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$j(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$c = global$h;
var shared$3 = shared$4.exports;
var hasOwn$a = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var WellKnownSymbolsStore = shared$3('wks');
var Symbol$2 = global$c.Symbol;
var symbolFor = Symbol$2 && Symbol$2['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$c = function (name) {
  if (!hasOwn$a(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL$1 || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL$1 && hasOwn$a(Symbol$2, name)) {
      WellKnownSymbolsStore[name] = Symbol$2[name];
    } else if (USE_SYMBOL_AS_UID$1 && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var isCallable$g = isCallable$i;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$7 = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$g(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$g(it);
};

var isObject$6 = isObject$7;

var $String$4 = String;
var $TypeError$8 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$9 = function (argument) {
  if (isObject$6(argument)) return argument;
  throw $TypeError$8($String$4(argument) + ' is not an object');
};

var objectDefineProperties = {};

var fails$i = fails$m;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$i(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var DESCRIPTORS$a = descriptors;
var fails$h = fails$m;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$a && fails$h(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var objectDefineProperty = {};

var global$b = global$h;
var isObject$5 = isObject$7;

var document$1 = global$b.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$5(document$1) && isObject$5(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$9 = descriptors;
var fails$g = fails$m;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$9 && !fails$g(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var NATIVE_BIND$1 = functionBindNative;

var call$a = Function.prototype.call;

var functionCall = NATIVE_BIND$1 ? call$a.bind(call$a) : function () {
  return call$a.apply(call$a, arguments);
};

var uncurryThis$h = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$h({}.isPrototypeOf);

var getBuiltIn$2 = getBuiltIn$4;
var isCallable$f = isCallable$i;
var isPrototypeOf$2 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var $Object$2 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$f($Symbol) && isPrototypeOf$2($Symbol.prototype, $Object$2(it));
};

var $String$3 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$e = isCallable$i;
var tryToString = tryToString$1;

var $TypeError$7 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$2 = function (argument) {
  if (isCallable$e(argument)) return argument;
  throw $TypeError$7(tryToString(argument) + ' is not a function');
};

var aCallable$1 = aCallable$2;
var isNullOrUndefined$1 = isNullOrUndefined$3;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$2 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$1(func) ? undefined : aCallable$1(func);
};

var call$9 = functionCall;
var isCallable$d = isCallable$i;
var isObject$4 = isObject$7;

var $TypeError$6 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$d(fn = input.toString) && !isObject$4(val = call$9(fn, input))) return val;
  if (isCallable$d(fn = input.valueOf) && !isObject$4(val = call$9(fn, input))) return val;
  if (pref !== 'string' && isCallable$d(fn = input.toString) && !isObject$4(val = call$9(fn, input))) return val;
  throw $TypeError$6("Can't convert object to primitive value");
};

var call$8 = functionCall;
var isObject$3 = isObject$7;
var isSymbol$1 = isSymbol$2;
var getMethod$1 = getMethod$2;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$b = wellKnownSymbol$c;

var $TypeError$5 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$b('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$3(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$1(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$8(exoticToPrim, input, pref);
    if (!isObject$3(result) || isSymbol$1(result)) return result;
    throw $TypeError$5("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var DESCRIPTORS$8 = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$8 = anObject$9;
var toPropertyKey$1 = toPropertyKey$2;

var $TypeError$4 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$8 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$8(O);
  P = toPropertyKey$1(P);
  anObject$8(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$8(O);
  P = toPropertyKey$1(P);
  anObject$8(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$4('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var ceil = Math.ceil;
var floor$2 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$2 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$6 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$5 = toIntegerOrInfinity$6;

var max$1 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$5(index);
  return integer < 0 ? max$1(integer + length, 0) : min$2(integer, length);
};

var toIntegerOrInfinity$4 = toIntegerOrInfinity$6;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$2 = function (argument) {
  return argument > 0 ? min$1(toIntegerOrInfinity$4(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$1 = toLength$2;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$2 = function (obj) {
  return toLength$1(obj.length);
};

var toIndexedObject$4 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$2;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$4($this);
    var length = lengthOfArrayLike$1(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$3(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};

var hiddenKeys$4 = {};

var uncurryThis$g = functionUncurryThis;
var hasOwn$9 = hasOwnProperty_1;
var toIndexedObject$3 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$4;

var push$1 = uncurryThis$g([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$3(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$9(hiddenKeys$3, key) && hasOwn$9(O, key) && push$1(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$9(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$1(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys$1(O, enumBugKeys$2);
};

var DESCRIPTORS$7 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$3 = objectDefineProperty;
var anObject$7 = anObject$9;
var toIndexedObject$2 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$7 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$7(O);
  var props = toIndexedObject$2(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$3.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$1 = getBuiltIn$4;

var html$1 = getBuiltIn$1('document', 'documentElement');

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

/* global ActiveXObject -- old IE, WSH */

var anObject$6 = anObject$9;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys$1 = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$2 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys$1.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys$1[length]];
  return NullProtoObject();
};

hiddenKeys$2[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$6(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$a = wellKnownSymbol$c;
var create$2 = objectCreate;
var defineProperty$5 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$a('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty$5(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var global$a = global$h;
var isCallable$c = isCallable$i;

var WeakMap$1 = global$a.WeakMap;

var weakMapBasicDetection = isCallable$c(WeakMap$1) && /native code/.test(String(WeakMap$1));

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$6 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;

var createNonEnumerableProperty$5 = DESCRIPTORS$6 ? function (object, key, value) {
  return definePropertyModule$2.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$9 = global$h;
var isObject$2 = isObject$7;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$8 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$1 = sharedKey$3;
var hiddenKeys$1 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$9.TypeError;
var WeakMap = global$9.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store$1 = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store$1.get = store$1.get;
  store$1.has = store$1.has;
  store$1.set = store$1.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store$1.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store$1.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store$1.get(it) || {};
  };
  has = function (it) {
    return store$1.has(it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$1[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$8(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$8(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$8(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var DESCRIPTORS$5 = descriptors;
var call$7 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;
var toIndexedObject$1 = toIndexedObject$5;
var toPropertyKey = toPropertyKey$2;
var hasOwn$7 = hasOwnProperty_1;
var IE8_DOM_DEFINE = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$5 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$1(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$7(O, P)) return createPropertyDescriptor$1(!call$7(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$4 = descriptors;
var hasOwn$6 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$4 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$6(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$4 || (DESCRIPTORS$4 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$f = functionUncurryThis;
var isCallable$b = isCallable$i;
var store = sharedStore;

var functionToString = uncurryThis$f(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$b(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store.inspectSource;

var fails$f = fails$m;
var isCallable$a = isCallable$i;
var hasOwn$5 = hasOwnProperty_1;
var DESCRIPTORS$3 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule$1 = internalState;

var enforceInternalState = InternalStateModule$1.enforce;
var getInternalState$2 = InternalStateModule$1.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$4 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$3 && !fails$f(function () {
  return defineProperty$4(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$5(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$3) defineProperty$4(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$5(options, 'arity') && value.length !== options.arity) {
    defineProperty$4(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$5(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$3) defineProperty$4(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$5(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$a(this) && getInternalState$2(this).source || inspectSource(this);
}, 'toString');

var isCallable$9 = isCallable$i;
var definePropertyModule$1 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$5 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$9(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$1.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$3;

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn = getBuiltIn$4;
var uncurryThis$e = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$5 = anObject$9;

var concat$2 = uncurryThis$e([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$5(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$4 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$4(target, key) && !(exceptions && hasOwn$4(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$e = fails$m;
var isCallable$8 = isCallable$i;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$8(detection) ? fails$e(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$8 = global$h;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var defineBuiltIn$4 = defineBuiltIn$5;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$8;
  } else if (STATIC) {
    target = global$8[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$8[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    defineBuiltIn$4(target, key, sourceProperty, options);
  }
};

var fails$d = fails$m;

var correctPrototypeGetter = !fails$d(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$3 = hasOwnProperty_1;
var isCallable$7 = isCallable$i;
var toObject$3 = toObject$5;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$3(O);
  if (hasOwn$3(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$7(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$c = fails$m;
var isCallable$6 = isCallable$i;
var isObject$1 = isObject$7;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$3 = defineBuiltIn$5;
var wellKnownSymbol$9 = wellKnownSymbol$c;

var ITERATOR$3 = wellKnownSymbol$9('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$1(IteratorPrototype$2) || fails$c(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$3].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$6(IteratorPrototype$2[ITERATOR$3])) {
  defineBuiltIn$3(IteratorPrototype$2, ITERATOR$3, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$3 = objectDefineProperty.f;
var hasOwn$2 = hasOwnProperty_1;
var wellKnownSymbol$8 = wellKnownSymbol$c;

var TO_STRING_TAG$3 = wellKnownSymbol$8('toStringTag');

var setToStringTag$2 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$2(target, TO_STRING_TAG$3)) {
    defineProperty$3(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$1 = setToStringTag$2;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isCallable$5 = isCallable$i;

var $String$2 = String;
var $TypeError$3 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$5(argument)) return argument;
  throw $TypeError$3("Can't set " + $String$2(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$d = functionUncurryThis;
var anObject$4 = anObject$9;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$d(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$4(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$9 = _export;
var call$6 = functionCall;
var FunctionName = functionName;
var isCallable$4 = isCallable$i;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$2;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var defineBuiltIn$2 = defineBuiltIn$5;
var wellKnownSymbol$7 = wellKnownSymbol$c;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$2 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$2 = wellKnownSymbol$7('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$2]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$4(CurrentIteratorPrototype[ITERATOR$2])) {
          defineBuiltIn$2(CurrentIteratorPrototype, ITERATOR$2, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$2 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$6(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$2(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$9({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$2] !== defaultIterator) {
    defineBuiltIn$2(IterablePrototype, ITERATOR$2, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineProperty$2 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS$2 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState$1 = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$2 && values.name !== 'values') try {
  defineProperty$2(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$7 = global$h;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var wellKnownSymbol$6 = wellKnownSymbol$c;

var ITERATOR$1 = wellKnownSymbol$6('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$6('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$1] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$1, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$1] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty$1(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$7[COLLECTION_NAME] && global$7[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var wellKnownSymbol$5 = wellKnownSymbol$c;

var TO_STRING_TAG$1 = wellKnownSymbol$5('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$3 = isCallable$i;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$4 = wellKnownSymbol$c;

var TO_STRING_TAG = wellKnownSymbol$4('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$4 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) == 'Object' && isCallable$3(O.callee) ? 'Arguments' : result;
};

var classof$3 = classof$4;

var $String$1 = String;

var toString$8 = function (argument) {
  if (classof$3(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

var anObject$3 = anObject$9;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$3(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call$5 = functionCall;
var hasOwn$1 = hasOwnProperty_1;
var isPrototypeOf$1 = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$2 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$2) && !hasOwn$1(R, 'flags') && isPrototypeOf$1(RegExpPrototype$2, R)
    ? call$5(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var defineBuiltIn$1 = defineBuiltIn$5;
var anObject$2 = anObject$9;
var $toString = toString$8;
var fails$b = fails$m;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$b(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$1(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$2(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

var $$8 = _export;
var $includes = arrayIncludes.includes;
var fails$a = fails$m;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$a(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$8({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var isObject = isObject$7;
var classof$2 = classofRaw$2;
var wellKnownSymbol$3 = wellKnownSymbol$c;

var MATCH$1 = wellKnownSymbol$3('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$2(it) == 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError$2 = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw $TypeError$2("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$2 = wellKnownSymbol$c;

var MATCH = wellKnownSymbol$2('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$7 = _export;
var uncurryThis$c = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible$4 = requireObjectCoercible$7;
var toString$7 = toString$8;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf$1 = uncurryThis$c(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$7({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$1(
      toString$7(requireObjectCoercible$4(this)),
      toString$7(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

var DESCRIPTORS$1 = descriptors;
var uncurryThis$b = functionUncurryThis;
var call$4 = functionCall;
var fails$9 = fails$m;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$5;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$1 = Object.defineProperty;
var concat$1 = uncurryThis$b([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$9(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$1 && $assign({ b: 1 }, $assign(defineProperty$1({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$1 || call$4(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$6 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$6({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

const TextConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'TextComponent',
  // Class name to apply to the component when variant is error.
  ERROR_CLASSNAME: 'error'
};

/**
 * Text component
 * @description A component that renders a text tag based on the variant property
 * @param {TextProperties} properties
 * @returns A text component
 */
function TextComponent(properties) {
  /**
   * Definition of parent tag based on the variant property
   */
  const Parent = properties.variant === 'error' ? 'label' : properties.variant || 'p';
  /**
   * Class names definition for the text component based on the properties provided
   */
  const classNames = [
  // Default class
  TextConstants.BASE_CLASSNAME,
  // Class if the variant is provided is error
  ...(properties.variant === TextConstants.ERROR_CLASSNAME ? [TextConstants.ERROR_CLASSNAME] : [])].join(' ');
  const renderText = typeof properties.children === 'string' && jsx(ReactMarkdown, {
    children: properties.children
  });
  return jsx(Parent, Object.assign({
    id: properties.id,
    className: classNames,
    htmlFor: properties.for,
    style: {
      opacity: properties.opacity
    }
  }, {
    children: typeof properties.children === 'number' ? properties.children : typeof properties.children === 'string' ? renderText && renderText.props.children : properties.children
  }));
}

const AutocompleteConstants = {
  BASE_CLASSNAME: 'AutocompleteComponent',
  OPEN_CLASSNAME: 'open'
};

/**
 * Constants for the Icon component
 */
const IconConstants = {
  CLASSNAME: 'IconComponent',
  CLICKABLE: 'clickable' // Class name to apply to the component when it is clickable.
};

var IconNames;
(function (IconNames) {
  IconNames["MENU"] = "las la-bars";
  IconNames["SEARCH"] = "las la-search";
  IconNames["CLOSE"] = "las la-times";
  IconNames["CLEAN"] = "las la-times-circle";
  IconNames["BAG"] = "las la-shopping-bag";
  IconNames["LEFT"] = "las la-arrow-left";
  IconNames["RIGHT"] = "las la-arrow-right";
  IconNames["BACK"] = "las la-angle-left";
  IconNames["NEXT"] = "las la-angle-right";
  IconNames["ELLIPSIS"] = "las la-ellipsis-h";
  IconNames["USER"] = "las la-user-circle";
  IconNames["MINUS"] = "las la-minus";
  IconNames["PLUS"] = "las la-plus";
  IconNames["CHECK"] = "las la-check";
  IconNames["EQUIS"] = "las la-times";
  IconNames["RELOAD"] = "las la-sync";
  IconNames["SKIP"] = "las la-forward";
  IconNames["DASHBOARD"] = "las la-tachometer-alt";
  IconNames["SETTINGS"] = "las la-cog";
  IconNames["COMMENT"] = "las la-comment";
  IconNames["FOLDER"] = "las la-folder";
  IconNames["ARTICLE"] = "las la-book";
  IconNames["EDIT"] = "las la-edit";
  IconNames["ADD"] = "las la-plus";
  IconNames["DELETE"] = "las la-minus";
  IconNames["DOWN"] = "las la-angle-down";
})(IconNames || (IconNames = {}));

/**
 * Icon component
 * @description Component to render icon from Line Awesome
 * @param {Buttonproperties} properties
 * @returns {JSX.Element}
 */
function IconComponent(properties) {
  // Dinamically ClassNames
  const classNames = [IconConstants.CLASSNAME, ...(properties.onClick ? [IconConstants.CLICKABLE] : []), ...((properties === null || properties === void 0 ? void 0 : properties.variant) ? [properties === null || properties === void 0 ? void 0 : properties.variant] : []), properties.name // Icon ClassName of Line Awesome
  ];

  return jsx("i", {
    className: classNames.join(' '),
    onClick: properties === null || properties === void 0 ? void 0 : properties.onClick,
    style: {
      fontSize: (properties === null || properties === void 0 ? void 0 : properties.size) || 24
    }
  });
}

const ButtonConsntants = {
  CLASSNAME: 'ButtonComponent',
  ICON: 'icon',
  ACTIVE: 'active',
  ICON_AND_CHILDREN: 'iconAndChildren',
  ADAPTATIVE: 'adaptative',
  EXPAND: 'expand'
};

/**
 * # Button
 *
 * A button component that admits a variety of properties to customize its behaviour,
 * such as variant, active state, disabled state, icon, etc.
 *
 * Some variants paint icons automatically. These variants are:
 * - important
 * - back
 * - delete
 * - reset
 * - submit
 *
 * The rest of variants can have an icon passed through the icon property.
 * @component Button component
 *
 * @property {string} label
 *
 * @description Button component
 *
 * @returns A custom button component
 */
function ButtonComponent(properties) {
  // Class names definition for the button component based on the properties provided
  const classNames = [ButtonConsntants.CLASSNAME,
  // Default class
  ...(properties.variant ? [properties.variant] : []),
  // Dimensiones of layout
  ...(properties.size ? [properties.size] : []),
  // Default class
  ...(properties.active ? [ButtonConsntants.ACTIVE] : []),
  // Status class
  ...(properties.icon ? [ButtonConsntants.ICON] : []),
  // Icons & childrens
  ...(properties.icon && properties.children ? [ButtonConsntants.ICON_AND_CHILDREN] : []),
  // Class when the button is adaptive
  ...(properties.adaptative ? [ButtonConsntants.ADAPTATIVE] : []),
  // Class when the button should applied a space among the children
  ...(properties.expand ? [ButtonConsntants.EXPAND] : []),
  // Class applied from properties
  ...(properties.className ? [properties.className] : [])].join(' ');
  return jsxs("button", Object.assign({
    id: properties.id,
    type: properties.type,
    className: classNames || undefined,
    title: properties.title,
    onClick: properties.onClick,
    disabled: properties.disabled
  }, {
    children: [properties.icon && jsx(IconComponent, {
      name: properties.icon
    }), properties.children, properties.bubble && jsx("b", {
      children: properties.bubble
    }), properties.detail && jsx("em", {
      children: properties.detail
    })]
  }));
}

/**
 * @component AutoComplete component
 *
 * @property {string} [label] - The label to be displayed
 * @property {string} [placeholder] - The placeholder of the input
 * @property {string} [defaultValue] - The default value of the input
 * @property {function} onChange - The function to be called when the input changes
 * @property {Promise<AutocompleteComponentOption[]>} autocomplete - This function receives a string as parameter and returns a promise with the options to be displayed
 * @property {boolean} [open=false] - Whether the autocomplete is open or not
 *
 * @description A component that renders an autocomplete input
 *
 * @returns An autocomplete component
 */
function AutocompleteComponent(properties) {
  // State hook to handle the value of the input
  const [randomId, setRandomId] = useState('');
  // State hook to handle the text the user writes in the input
  const [text, setText] = useState();
  // State hook to handle the value of the input
  const [value, setValue] = useState(properties === null || properties === void 0 ? void 0 : properties.value);
  /**
   * State hook to handle the open of the autocomplete
   */
  const [open, setOpen] = useState(false);
  /**
   * State hook to handle the options of the autocomplete
   */
  const [options, setOptions] = useState(properties.options || []);
  // Generate a random id for the input
  useEffect(() => {
    setRandomId(Math.random().toString(36).substring(7));
  }, []);
  useEffect(() => {
    if (properties.value) {
      setValue(properties.value);
    }
  }, [properties.value]);
  /**
   *
   */
  const getAsyncOptions = () => {
    if (properties.autocomplete && text) {
      properties.autocomplete(text, properties.dependencyInput, properties.dependencyValue).then(options => {
        setOpen(true);
        setOptions(options);
      });
    }
  };
  /**
   *
   */
  const getOptions = () => {
    if (properties.options && text) {
      setOpen(true);
      setOptions(properties.options.filter(option => option.label.toLowerCase().includes(text.toLowerCase())));
    }
    return [];
  };
  // Class names definition for the autocomplete component based on the properties provided
  const classNames = [
  // Default class
  AutocompleteConstants.BASE_CLASSNAME,
  // Class when is open
  ...(properties.open ? [AutocompleteConstants.OPEN_CLASSNAME] : [])].join(' ');
  return jsxs("div", Object.assign({
    className: classNames
  }, {
    children: [jsx("input", {
      value: typeof text === 'string' ? text : value === null || value === void 0 ? void 0 : value['label'],
      onKeyUp: () => properties.autocomplete ? getAsyncOptions() : getOptions(),
      onBlur: () => setTimeout(() => setOpen(false), 200),
      onChange: event => setText(event.target.value),
      placeholder: properties.placeholder || ''
    }), properties.label && jsx(TextComponent, Object.assign({
      variant: "label",
      for: randomId,
      "data-title": properties.placeholder
    }, {
      children: jsx("div", {
        children: properties.label
      })
    })), (text || value) && jsx(ButtonComponent, {
      size: "small",
      icon: IconNames.CLOSE,
      onClick: () => {
        setText('');
        setValue(undefined);
        properties.onChange('');
      }
    }), open && text && options && (options === null || options === void 0 ? void 0 : options.length) > 0 && jsx("ul", {
      children: options === null || options === void 0 ? void 0 : options.map(option => {
        return jsx("li", Object.assign({
          onClick: () => {
            setText(null);
            setValue(option);
            if (option.value) properties.onChange(option.value);
            setOpen(false);
          }
        }, {
          children: option.label
        }), option.label);
      })
    })]
  }));
}

const BreadcrumbsConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'BreadcrumbsComponent'
};

/**
 * BreadCrumbs Component
 * @description This component is used to show the path of the current page
 * @param {BreadcrumbsProperties} props
 * @returns {JSX.Element} The breadcrumbs component
 */
function BreadcrumbsComponent(properties) {
  const pages = typeof properties.path === 'string' ? properties.path.split('/').splice(1) : properties.path;
  /**
   * This function capitalizes the first letter of a string.
   * Taken from https://stackoverflow.com/a/1026087/1015046
   * @param text The text to capitalize
   * @returns The capitalized text
   */
  function capitalize(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
  return jsx("div", Object.assign({
    className: BreadcrumbsConstants.BASE_CLASSNAME
  }, {
    children: jsx(RowComponent, {
      children: pages.map(page => jsx(TextComponent, Object.assign({
        variant: "h1"
      }, {
        children: capitalize(page)
      }), page))
    })
  }));
}

var uncurryThis$a = functionUncurryThis;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
var thisNumberValue$1 = uncurryThis$a(1.0.valueOf);

var toIntegerOrInfinity$3 = toIntegerOrInfinity$6;
var toString$6 = toString$8;
var requireObjectCoercible$3 = requireObjectCoercible$7;

var $RangeError$1 = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = toString$6(requireObjectCoercible$3(this));
  var result = '';
  var n = toIntegerOrInfinity$3(count);
  if (n < 0 || n == Infinity) throw $RangeError$1('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

var $$5 = _export;
var uncurryThis$9 = functionUncurryThis;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$6;
var thisNumberValue = thisNumberValue$1;
var $repeat = stringRepeat;
var fails$8 = fails$m;

var $RangeError = RangeError;
var $String = String;
var floor$1 = Math.floor;
var repeat = uncurryThis$9($repeat);
var stringSlice$5 = uncurryThis$9(''.slice);
var nativeToFixed = uncurryThis$9(1.0.toFixed);

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor$1(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor$1(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED$1 = fails$8(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' ||
    nativeToFixed(0.9, 0) !== '1' ||
    nativeToFixed(1.255, 2) !== '1.25' ||
    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails$8(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$$5({ target: 'Number', proto: true, forced: FORCED$1 }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity$2(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw $RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice$5(result, 0, k - fractDigits) + '.' + stringSlice$5(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

var $$4 = _export;
var DESCRIPTORS = descriptors;
var global$6 = global$h;
var uncurryThis$8 = functionUncurryThis;
var hasOwn = hasOwnProperty_1;
var isCallable$2 = isCallable$i;
var isPrototypeOf = objectIsPrototypeOf;
var toString$5 = toString$8;
var defineProperty = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$6.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable$2(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$5(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis$8(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$8(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$3 = uncurryThis$8(''.replace);
  var stringSlice$4 = uncurryThis$8(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice$4(string, 7, -1) : replace$3(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$4({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

/**
 * Constants for the Pie Component
 */
const PieConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'PieComponent'
};

/**
 * Pie component
 * @description A component to render a content (total and description text)
 *              inside a circular card
 * @param {PieProperties} properties
 * @returns A pie component
 */
function PieComponent(properties) {
  return jsxs("div", Object.assign({
    className: PieConstants.BASE_CLASSNAME
  }, {
    children: [jsx(TextComponent, {
      children: typeof properties.total === 'number' ? properties.total.toFixed(2) : properties.total
    }), jsx(TextComponent, {
      children: properties.description
    })]
  }));
}

/**
 * Constants definition for the editor component
 */
const EditorConstants = {
  BASE_CLASSNAME: "EditorComponent" // Default class name to apply to the component.
};

/**
 * Editor component
 * @param {EditorProperties} properties
 * @returns {JSX.Element} A text editor component
 */
function EditorComponent(properties) {
  // State hook to handle the value of the input
  const [randomId, setRandomId] = React.useState('');
  // State hook to handle the value of the input
  const [value, setValue] = React.useState((properties === null || properties === void 0 ? void 0 : properties.placeholder) || (properties === null || properties === void 0 ? void 0 : properties.defaultValue));
  // Generate a random id for the input
  useEffect(() => {
    setRandomId(Math.random().toString(36).substring(7));
  }, []);
  function handleChange(event) {
    var _a;
    setValue(event.target.value);
    (_a = properties.onChange) === null || _a === void 0 ? void 0 : _a.call(properties, event.target.value);
  }
  return jsxs("div", Object.assign({
    className: EditorConstants.BASE_CLASSNAME
  }, {
    children: [jsx("input", {
      id: randomId,
      required: properties.required,
      placeholder: properties.placeholder || '',
      value: value,
      name: randomId,
      onChange: handleChange
    }), properties.label && jsx(TextComponent, Object.assign({
      variant: "label",
      for: randomId,
      "data-title": properties.placeholder
    }, {
      children: jsx("div", {
        children: properties.label
      })
    }))]
  }));
}

var aCallable = aCallable$2;
var toObject$1 = toObject$5;
var IndexedObject = indexedObject;
var lengthOfArrayLike = lengthOfArrayLike$2;

var $TypeError$1 = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$2 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject$1(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError$1('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$2(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$2(true)
};

var fails$7 = fails$m;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$7(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var classof$1 = classofRaw$2;
var global$5 = global$h;

var engineIsNode = classof$1(global$5.process) == 'process';

var $$3 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$3({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const DonutChartContext = /*#__PURE__*/createContext(undefined);
const DonutChart = ({
  className: _className = 'donutchart',
  colorFunction: _colorFunction = (colors, index) => colors[index % colors.length],
  colors: _colors = ['#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4caf50', '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800', '#ff5722', '#795548', '#607d8b'],
  data: _data = [{
    className: '',
    value: 100,
    isEmpty: true
  }],
  emptyColor: _emptyColor = '#e0e0e0',
  emptyOffset: _emptyOffset = 4,
  formatValues: _formatValues = (value, total) => Number.isNaN(value / total) ? '--' : `${(value / total * 100).toFixed(2)}%`,
  height: _height = 24,
  interactive: _interactive = true,
  innerRadius: _innerRadius = 0.4,
  legend: _legend = true,
  onMouseEnter: _onMouseEnter = item => item,
  onMouseLeave: _onMouseLeave = item => item,
  onClick: _onClick = (item, toggled) => toggled ? item : null,
  outerRadius: _outerRadius = 0.9,
  selectedOffset: _selectedOffset = 0.03,
  strokeColor: _strokeColor = '#fff',
  toggledOffset: _toggledOffset = 0.04,
  width: _width = 24
}) => {
  const [selected, setSelected] = useState(_interactive ? _data[0] : null);
  const [toggleSelect, setToggleSelect] = useState(false);
  useEffect(() => {
    if (_interactive) {
      setSelected(_data[0]);
      setToggleSelect(false);
    }
  }, [_interactive, _data]);
  const graphWidth = _width;
  const total = _data.reduce((sum, {
    value
  }) => sum + value, 0);
  const {
    dataWithRenderProps
  } = _data.reduce(({
    angle,
    dataWithRenderProps
  }, item, index) => {
    const {
      className,
      isEmpty,
      value
    } = item;
    return {
      angle: angle + value / total * 360,
      dataWithRenderProps: [...dataWithRenderProps, Object.assign(Object.assign({
        angle,
        index
      }, item), {
        classNames: '',
        fill: isEmpty ? _emptyColor : _colorFunction(_colors, index),
        opacity: 1,
        stroke: isEmpty ? _emptyColor : _strokeColor,
        clickHandlers: undefined
      })],
      total: total + value
    };
  }, {
    angle: 0,
    dataWithRenderProps: []
  });
  return jsx("div", Object.assign({
    className: "DonutComponent"
  }, {
    children: jsx(DonutChartContext.Provider, Object.assign({
      value: {
        className: _className,
        emptyOffset: _emptyOffset,
        graphWidth,
        innerRadius: _innerRadius,
        outerRadius: _outerRadius,
        selected,
        selectedOffset: _selectedOffset,
        toggledOffset: _toggledOffset,
        toggleSelect,
        total,
        width: _width
      }
    }, {
      children: jsx("svg", Object.assign({
        className: _className,
        style: {
          height: _height,
          width: _width
        },
        viewBox: `0 0 ${_width} ${_height}`
      }, {
        children: jsx("g", Object.assign({
          className: `${_className}-arcs`
        }, {
          children: dataWithRenderProps.map(item => jsx(ArcPath, {
            item: item
          }, `arcpath${item.index}`))
        }))
      }))
    }))
  }));
};
function coordinates(half, radius, startAngle, endAngle) {
  const startAngleDegrees = Math.PI * startAngle / 180;
  const endAngleDegrees = Math.PI * endAngle / 180;
  return {
    x1: half + half * radius * Math.cos(startAngleDegrees),
    y1: half + half * radius * Math.sin(startAngleDegrees),
    x2: half + half * radius * Math.cos(endAngleDegrees),
    y2: half + half * radius * Math.sin(endAngleDegrees)
  };
}
// eslint-disable-next-line id-length
function arc(width, radius, largeArcFlag,
// eslint-disable-next-line id-length
x,
// eslint-disable-next-line id-length
y) {
  const z = width / 2 * radius;
  return `A${z}, ${z} 22 ${largeArcFlag} ${x}, ${y}`;
}
function path(activeAngle, startAngle, width, innerRadius, outerRadius) {
  const endAngle = startAngle + activeAngle;
  const largeArcFlagOuter = activeAngle > 180 ? '1 1' : '0 1';
  const largeArcFlagInner = activeAngle > 180 ? '1 0' : '0 0';
  const half = width / 2;
  const outerCoords = coordinates(half, outerRadius, startAngle, endAngle);
  const innerCoords = coordinates(half, innerRadius, startAngle, endAngle);
  const outerArc = arc(width, outerRadius, largeArcFlagOuter, outerCoords.x2, outerCoords.y2);
  const innerArc = arc(width, innerRadius, largeArcFlagInner, innerCoords.x1, innerCoords.y1);
  return `M${outerCoords.x1},${outerCoords.y1}
  ${outerArc}
  L${innerCoords.x2},${innerCoords.y2}
  ${innerArc} z`;
}
const ArcPath = ({
  item
}) => {
  const {
    className,
    emptyOffset,
    graphWidth,
    innerRadius,
    outerRadius,
    total
  } = useContext(DonutChartContext);
  const {
      angle,
      classNames,
      index,
      isEmpty,
      value
    } = item,
    restItemRenderrops = __rest(item, ["angle", "classNames", "index", "isEmpty", "value"]);
  const activeAngle = Number.isNaN(value / total) || total / value === 1 ? 359.99 : value / total * 360;
  let [inner, outer] = [innerRadius, outerRadius];
  if (isEmpty) {
    inner += emptyOffset;
    outer -= emptyOffset;
  }
  return jsx("path", Object.assign({}, Object.assign({}, restItemRenderrops), {
    strokeWidth: 0.5,
    className: `${className}-arcs-path ${classNames}`,
    d: path(activeAngle, angle, graphWidth, inner, outer)
  }));
};

const HolderConstants = {
  CLASSNAME: 'HolderComponent' // Default class name to apply to the component.
};

/**
 * Holder component
 * @description This is the holder to make semantic holders
 * @param {Holderproperties} properties
 * @returns {JSX.Element} A holder component
 */
function HolderComponent(properties) {
  return jsxs("div", Object.assign({
    className: HolderConstants.CLASSNAME,
    title: properties === null || properties === void 0 ? void 0 : properties.title
  }, {
    children: [properties.icon && jsx(IconComponent, {
      name: properties.icon.name
    }), jsx("b", {
      children: properties.title
    })]
  }));
}

const WIDGET_CONSTANTS = {
  BASE_CLASSNAME: 'WidgetComponent'
};

/**
 * Widget component
 * @description A component that renders a widget with more components inside
 * @param {WidgetProperties} properties
 * @returns A widget component
 */
function WidgetComponent(properties) {
  // Class constructor
  const classNames = [
  // Default class
  WIDGET_CONSTANTS.BASE_CLASSNAME,
  // Status class
  ...(properties.variant ? [properties.variant] : [])].join(' ');
  return jsxs("div", Object.assign({
    className: classNames,
    style: {
      background: properties === null || properties === void 0 ? void 0 : properties.background,
      maxWidth: properties.width
    }
  }, {
    children: [properties.title && jsx("div", Object.assign({
      className: 'title'
    }, {
      children: properties.title
    })), properties.children]
  }));
}

// Logotype of Variants of Size (default: TEXT)
const MeterConstants = {
  CLASSNAME: 'MeterComponent'
};

function MeterComponent(properties) {
  const renderItem = (item, index) => {
    return jsxs("li", {
      children: [jsx(IconComponent, {
        name: item.icon
      }), jsx("strong", {
        children: item.value
      }), jsx("span", Object.assign({
        className: "label"
      }, {
        children: item.label
      }))]
    }, index);
  };
  return jsx("div", Object.assign({
    className: MeterConstants.CLASSNAME
  }, {
    children: properties.items && jsx("ul", {
      children: properties.items.map((item, index) => renderItem(item, index))
    })
  }));
}

const BoxConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'BoxComponent'
};

/**
 * Box component
 * @description Box component is a container that can be used to group elements inside it
 *              defining direction and spacing between them
 * @param {BoxProperties} properties
 * @returns A box component
 */
function BoxComponent(properties) {
  /**
   * Class names definition for the box component based on the properties provided
   */
  const classNames = [
  // Default class
  BoxConstants.BASE_CLASSNAME,
  // Class when a direction is passed as a property
  ...(properties.direction ? [properties.direction] : []),
  // Class when spacing is passed as a property
  ...(properties.space ? [properties.space] : []),
  // Class when align is passed as a property
  ...(properties.align ? [properties.align] : [])].join(' ');
  return jsx("div", Object.assign({
    id: properties === null || properties === void 0 ? void 0 : properties.id,
    className: classNames
  }, {
    children: properties.children
  }));
}

const ZoneConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'ZoneComponent'
};

/**
 * Zone component
 * @description Zone component is a container that can be used to group elements inside it
 *              defining direction and spacing between them
 * @param {ZoneProperties} properties
 * @returns A zone component
 */
function ZoneComponent(properties) {
  /**
   * Class names definition for the zone component based on the properties provided
   */
  const classNames = [
  // Default class
  ZoneConstants.BASE_CLASSNAME,
  // Class when a direction is passed as a property
  ...(properties.direction ? [properties.direction] : []),
  // Class when spacing is passed as a property
  ...(properties.space ? [properties.space] : [])].join(' ');
  return jsx("div", Object.assign({
    className: classNames
  }, {
    children: properties.children
  }));
}

const BlurConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'BlurComponent'
};

/**
 * Blur component
 * @description A component that renders a blur effect
 * @param {BlurProperties} properties
 * @returns A blur component
 */
function BlurComponent(properties) {
  return jsx("div", Object.assign({
    className: BlurConstants.BASE_CLASSNAME
  }, {
    children: properties.children
  }));
}

/**
 * Constants for the Card component
 */
const CardConstants = {
  // Default class name to apply to the component.
  BASE_CLASS_NAME: 'CardComponent'
};

/**
 * Constants for the Column component
 */
const ColumnConstants = {
  BASE_CLASSNAME: 'ColumnComponent',
  WRAP_CLASSNAME: 'wrap' // Class name for the component when wrap is passed as a property
};

/**
 * Column Component to render multiple elements in flex column
 * @param properties
 * @returns A column component
 */
function ColumnComponent(properties) {
  /**
   * Class names definition for the row component based on the properties provided
   */
  const classNames = [
  // Default class
  ColumnConstants.BASE_CLASSNAME,
  // Class when an alignment is passed as a property
  ...(properties.align ? [properties.align] : []),
  // Class when wrap is passed as a property
  ...(properties.wrap ? [ColumnConstants.WRAP_CLASSNAME] : [])].join(' ');
  return jsx("div", Object.assign({
    className: classNames,
    style: {
      height: properties.height || '100%'
    }
  }, {
    children: properties.children
  }));
}

/**
 * @component Card
 * @param properties
 * @returns A card component
 */
function CardComponent(properties) {
  return jsx("div", Object.assign({
    className: CardConstants.BASE_CLASS_NAME,
    onClick: properties.onClick
  }, {
    children: jsxs(ColumnComponent, Object.assign({
      align: "start"
    }, {
      children: [properties.icon && jsx(IconComponent, {
        name: properties.icon,
        size: 32
      }), jsx(TextComponent, Object.assign({
        variant: "h3"
      }, {
        children: properties.title
      })), jsx(TextComponent, Object.assign({
        variant: "p",
        opacity: 0.6
      }, {
        children: properties.description
      }))]
    }))
  }));
}

/**
 * Accordion constants
 */
const AccordionConstants = {
  BASE_CLASSNAME: 'AccordionComponent',
  DISABLED_CLASSNAME: 'disabled',
  OPENED_CLASSNAME: 'opened'
};

/**
 * Accordion
 * @component Accordion
 *
 * @property {string} title - The title of the accordion
 * @property {string} description - The description of the accordion
 * @property {(number | boolean | undefined)} index - An index to identify the accordion
 * @property {boolean} [open=false] - Whether the accordion is open or not
 *
 * @description Accordion component
 *
 * @returns An accordion component
 */
function AccordionComponent(properties) {
  /**
   * State hook to handle open/close state of accordion. Default value is
   * either provided from properties or false.
   */
  const [open, setOpen] = useState(properties.open || false);
  useEffect(() => {
    setOpen(properties.open || false);
  }, [properties.open]);
  // Memoized value of the bubble number to be displayed
  const notifications = useMemo(() => properties.bubbles ? properties.bubbles.map((bubble, index) => typeof bubble.content === 'number' ? jsx("b", Object.assign({
    onClick: bubble.onClick
  }, {
    children: bubble.content
  }), index) : jsx(ButtonComponent, {
    onClick: bubble.onClick,
    icon: bubble.content
  }, index)) : null, [properties.bubbles]);
  // Class names definition for the accordion component based on the properties provided
  const classNames = [
  // Default class
  AccordionConstants.BASE_CLASSNAME,
  // Class when is disabled
  ...(properties.disabled ? [AccordionConstants.DISABLED_CLASSNAME] : []),
  // Class when is open
  ...(open ? [AccordionConstants.OPENED_CLASSNAME] : []),
  // Custom class passed as property
  ...(properties.className ? [properties.className] : [])].join(' ');
  return jsxs("div", Object.assign({
    className: classNames
  }, {
    children: [jsxs("span", Object.assign({
      onClick: () => !properties.disabled && setOpen(prev => !prev)
    }, {
      children: [properties.index ? jsx("div", {
        children: typeof properties.index === 'boolean' ? jsx(IconComponent, {
          name: properties.index ? IconNames.CHECK : IconNames.EQUIS
        }) : properties.index
      }) : null, jsx(TextComponent, {
        children: properties.title
      }), notifications]
    })), properties.description && jsx("div", Object.assign({
      className: "description"
    }, {
      children: jsx(TextComponent, Object.assign({
        variant: "p"
      }, {
        children: properties.description
      }))
    })), jsx("div", {
      children: open && properties.children
    })]
  }));
}
AccordionComponent.propTypes = {
  /**
   * Accordion bubbles
   */
  title: PropTypes.string.isRequired
};

/**
 * Constants for the Select component
 */
const SelectConstants = {
  BASE_CLASSNAME: 'SelectComponent',
  DOTS: '...',
  OPEN_CLASSNAME: 'opened',
  UP_CLASSNAME: 'up',
  HEIGHT_OFFSET: 24 // Height offset to calculate the position of the options
};

function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0
  });
  useEffect(() => {
    // Only execute all the code below in client side
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    // Add event listener
    window.addEventListener('resize', handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}

/**
 * Select component
 * @description A simple select component
 * @param {SelectProperties} properties
 * @returns A select component
 */
function SelectComponent(properties) {
  const {
    height
  } = useWindowSize();
  /**
   * Ref to the container of the select
   */
  const containerRef = useRef(null);
  /**
   * Ref to the options list of the select
   */
  const optionsRef = useRef(null);
  /**
   * State handler for the height of the options list
   */
  const [optionsHeight, setOptionsHeight] = useState(0);
  /**
   * State handler for the position of the select
   */
  const [position, setPosition] = useState(0);
  /**
   * State handler for the selected value
   */
  const [value, setValue] = React.useState(properties === null || properties === void 0 ? void 0 : properties.defaultValue);
  /**
   * Hook to control the open state of the select
   */
  const [open, setOpen] = React.useState(false);
  useEffect(() => {
    if (optionsRef.current && containerRef.current) {
      setPosition(containerRef.current.getBoundingClientRect().y);
      setOptionsHeight(optionsRef.current.offsetHeight);
    }
    const handleClickOutside = event => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [height, open]);
  /**
   * Function to control how the text shown in the select is rendered can be either
   * the placeholder or the selected value
   *
   * @returns The placeholder of the select
   */
  const renderPlaceholder = () => {
    let placeholder = properties.placeholder || SelectConstants.DOTS;
    if (value) {
      // Search option with value and get label of option
      const option = properties.options.find(option => option.value === value);
      if (option) placeholder = option.label;
    }
    return placeholder;
  };
  // Class names definition for the select component based on the properties provided
  const classNames = [SelectConstants.BASE_CLASSNAME, ...(open ? [SelectConstants.OPEN_CLASSNAME] : []), position + optionsHeight + SelectConstants.HEIGHT_OFFSET >= height ? [SelectConstants.UP_CLASSNAME] : []].join(' ');
  const handleClick = (event, option) => {
    event.stopPropagation();
    setValue(option.value);
    setOpen(!open);
    properties.onChange(option.value);
  };
  return jsxs("div", Object.assign({
    ref: containerRef,
    className: classNames,
    onClick: () => setOpen(!open)
  }, {
    children: [jsx(TextComponent, {
      children: renderPlaceholder()
    }), open && jsx("ul", Object.assign({
      ref: optionsRef
    }, {
      children: properties.options.map(option => jsx("li", Object.assign({
        onClick: event => handleClick(event, option)
      }, {
        children: option.label
      }), option.label))
    }))]
  }));
}

var fails$6 = fails$m;
var global$4 = global$h;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$4.RegExp;

var UNSUPPORTED_Y$1 = fails$6(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$6(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$6(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

var fails$5 = fails$m;
var global$3 = global$h;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$3.RegExp;

var regexpUnsupportedDotAll = fails$5(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$4 = fails$m;
var global$2 = global$h;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$2.RegExp;

var regexpUnsupportedNcg = fails$4(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$3 = functionCall;
var uncurryThis$7 = functionUncurryThis;
var toString$4 = toString$8;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4.exports;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$4 = uncurryThis$7(''.charAt);
var indexOf = uncurryThis$7(''.indexOf);
var replace$2 = uncurryThis$7(''.replace);
var stringSlice$3 = uncurryThis$7(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$3(nativeExec, re1, 'a');
  call$3(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$4(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$3(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$3(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$2(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$3(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$4(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$3(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$3(match.input, charsAdded);
        match[0] = stringSlice$3(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$3(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$2 = _export;
var exec = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$2({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

var NATIVE_BIND = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$2 = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call$2.bind(apply$1) : function () {
  return call$2.apply(apply$1, arguments);
});

var classofRaw = classofRaw$2;
var uncurryThis$6 = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$6(fn);
};

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$5 = functionUncurryThisClause;
var defineBuiltIn = defineBuiltIn$5;
var regexpExec$1 = regexpExec$2;
var fails$3 = fails$m;
var wellKnownSymbol$1 = wellKnownSymbol$c;
var createNonEnumerableProperty = createNonEnumerableProperty$5;

var SPECIES = wellKnownSymbol$1('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$1(KEY);

  var DELEGATES_TO_SYMBOL = !fails$3(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$3(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$5(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$5(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var uncurryThis$4 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$6;
var toString$3 = toString$8;
var requireObjectCoercible$2 = requireObjectCoercible$7;

var charAt$3 = uncurryThis$4(''.charAt);
var charCodeAt = uncurryThis$4(''.charCodeAt);
var stringSlice$2 = uncurryThis$4(''.slice);

var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$3(requireObjectCoercible$2($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$3(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$2(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt$2 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$2(S, index).length : 1);
};

var uncurryThis$3 = functionUncurryThis;
var toObject = toObject$5;

var floor = Math.floor;
var charAt$1 = uncurryThis$3(''.charAt);
var replace$1 = uncurryThis$3(''.replace);
var stringSlice$1 = uncurryThis$3(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$1(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$1(str, 0, position);
      case "'": return stringSlice$1(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$1(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$1(ch, 1) : captures[f - 1] + charAt$1(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var call$1 = functionCall;
var anObject$1 = anObject$9;
var isCallable$1 = isCallable$i;
var classof = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$1(exec)) {
    var result = call$1(exec, R, S);
    if (result !== null) anObject$1(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call$1(regexpExec, R, S);
  throw $TypeError('RegExp#exec called on incompatible receiver');
};

var apply = functionApply;
var call = functionCall;
var uncurryThis$2 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var fails$2 = fails$m;
var anObject = anObject$9;
var isCallable = isCallable$i;
var isNullOrUndefined = isNullOrUndefined$3;
var toIntegerOrInfinity = toIntegerOrInfinity$6;
var toLength = toLength$2;
var toString$2 = toString$8;
var requireObjectCoercible$1 = requireObjectCoercible$7;
var advanceStringIndex = advanceStringIndex$1;
var getMethod = getMethod$2;
var getSubstitution = getSubstitution$1;
var regExpExec = regexpExecAbstract;
var wellKnownSymbol = wellKnownSymbol$c;

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis$2([].concat);
var push = uncurryThis$2([].push);
var stringIndexOf = uncurryThis$2(''.indexOf);
var stringSlice = uncurryThis$2(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$2(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$1(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString$2(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString$2(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString$2(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString$2(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$2(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString$2(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

// a string of all valid unicode whitespaces
var whitespaces$3 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$1 = functionUncurryThis;
var requireObjectCoercible = requireObjectCoercible$7;
var toString$1 = toString$8;
var whitespaces$2 = whitespaces$3;

var replace = uncurryThis$1(''.replace);
var whitespace = '[' + whitespaces$2 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$1(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var global$1 = global$h;
var fails$1 = fails$m;
var uncurryThis = functionUncurryThis;
var toString = toString$8;
var trim = stringTrim.trim;
var whitespaces$1 = whitespaces$3;

var charAt = uncurryThis(''.charAt);
var $parseFloat$1 = global$1.parseFloat;
var Symbol$1 = global$1.Symbol;
var ITERATOR = Symbol$1 && Symbol$1.iterator;
var FORCED = 1 / $parseFloat$1(whitespaces$1 + '-0') !== -Infinity
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails$1(function () { $parseFloat$1(Object(ITERATOR)); }));

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
var numberParseFloat = FORCED ? function parseFloat(string) {
  var trimmedString = trim(toString(string));
  var result = $parseFloat$1(trimmedString);
  return result === 0 && charAt(trimmedString, 0) == '-' ? -0 : result;
} : $parseFloat$1;

var $$1 = _export;
var $parseFloat = numberParseFloat;

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$$1({ global: true, forced: parseFloat != $parseFloat }, {
  parseFloat: $parseFloat
});

/**
 * Constants for the Number component
 */
const NumberConstants = {
  BASE_CLASSNAME: 'NumberComponent',
  INPUT_TYPE: 'number',
  INCREMENT: 'increment',
  DECREMENT: 'decrement' // Action to decrement the value
};

/**
 * Number Component
 * @description - Numeric type input with incremental and decremental controllers
 * @param {CalculatorNumberProperties}
 * @return {JSX.Element}
 */
function NumberComponent(properties) {
  // Input value
  const [value, setValue] = useState((properties === null || properties === void 0 ? void 0 : properties.defaultValue) || 0);
  const intervalRef = useRef(null);
  const inputRef = useRef(null);
  const expasinbleRef = useRef(null);
  useEffect(() => {
    properties.onChange(properties.defaultValue || 0);
  }, []);
  /**
   * When the component is unmounted we should stop the counter
   */
  useEffect(() => {
    return () => stopCounter();
  }, []);
  /**
   * This function is used to start the counter when the user clicks and hold the increment or decrement button
   * @param {string} action - Action to be performed (increment or decrement)
   */
  const startCounter = action => {
    if (intervalRef.current) return;
    intervalRef.current = setInterval(() => {
      action === NumberConstants.INCREMENT ? setIncrement() : setDecrement();
    }, 150);
  };
  /**
   * This function is used to stop the counter when the user releases the increment or decrement button.
   * Is also called when the user moves the mouse out of the button.
   */
  const stopCounter = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };
  const increment = prevState => {
    if (prevState) {
      properties.onChange(prevState + 1);
      return prevState + 1;
    }
    return 1;
  };
  // Handler for the increment button
  const setIncrement = () => {
    setValue(prevState => {
      if (properties === null || properties === void 0 ? void 0 : properties.maxValue) {
        if (prevState !== null && prevState < properties.maxValue) {
          return increment(prevState);
        }
      } else {
        return increment(prevState);
      }
      return prevState;
    });
  };
  const decrement = prevState => {
    if (prevState) {
      properties.onChange(prevState - 1);
      return prevState - 1;
    }
    return 0;
  };
  // Handler for the decrement button
  const setDecrement = () => {
    setValue(prevState => {
      if (properties === null || properties === void 0 ? void 0 : properties.minValue) {
        if (prevState !== null && prevState > properties.minValue) {
          return decrement(prevState);
        }
      } else {
        return decrement(prevState);
      }
      return prevState;
    });
  };
  const renderMeasureTag = () => {
    return jsx("div", Object.assign({
      className: "measureTag"
    }, {
      children: properties.measureTag
    }));
  };
  // This useEffect is used to expand input on content change
  useEffect(() => {
    // Check if the refs are defined
    if (expasinbleRef.current && inputRef.current) {
      // Set the inner html of the span to the value of the input and replace the spaces with &nbsp; to avoid the span to shrink
      expasinbleRef.current.innerHTML = value ? value.toString().replace(/\s/g, '&nbsp;') : '';
      // Set the width of the input to the width of the span + 12px to make the input grow as the content grows
      // The extra 4px are used to avoid hidden characters at the end of the input due to the overflow hidden property
      inputRef.current.style.width = expasinbleRef.current.offsetWidth + 12 + 'px';
    }
  }, [value]);
  // Render input number based on the properties received
  const renderInput = () => {
    return jsxs("div", {
      children: [jsx("input", {
        ref: inputRef,
        type: NumberConstants.INPUT_TYPE,
        value: (value === null || value === void 0 ? void 0 : value.toString()) || '',
        onChange: event => {
          // Get the value of the input entered by the user (string by default) and convert it to a number
          let inputValue = parseFloat(event.target.value);
          // Check if value is bigger than max value and if so reset to max value
          if (properties.maxValue && inputValue > properties.maxValue) {
            inputValue = properties.maxValue;
          }
          // Check if value is smaller than min value and if so reset to min value
          if (properties.minValue && inputValue < properties.minValue) {
            inputValue = properties.minValue;
          }
          // Set value in component
          setValue(inputValue);
          // Set value in parent component (for make request body)
          properties.onChange(inputValue);
        },
        disabled: properties.disabled
      }), jsx("span", {
        ref: expasinbleRef
      }), properties.measureTag && renderMeasureTag()]
    });
  };
  // Button for increment and decrement controls
  const renderControl = (icon, action) => {
    // Add event listeners to the button if it is not disabled
    const controlProperties = !properties.disabled ? {
      // Start counter when user clicks and hold the button
      onMouseDown: () => startCounter(action),
      // Stop counter when user releases the button
      onMouseUp: stopCounter,
      // Stop counter when user moves the mouse out of the button
      onMouseLeave: stopCounter,
      // Increment or decrement value when user clicks the button
      onClick: () => action === NumberConstants.INCREMENT ? setIncrement() : setDecrement()
    } : {};
    return jsx("i", Object.assign({
      className: [icon, properties.disabled ? ['disabled'] : []].join(' ')
    }, controlProperties));
  };
  const classNames = [NumberConstants.BASE_CLASSNAME, ...(properties.disabled ? ['disabled'] : []), ...(properties.measureTag ? ['tag'] : [])].join(' ');
  return jsxs("div", Object.assign({
    className: classNames
  }, {
    children: [renderControl(IconNames.MINUS, NumberConstants.DECREMENT), renderInput(), renderControl(IconNames.PLUS, NumberConstants.INCREMENT)]
  }));
}

// Logotype of Variants of Size (default: TEXT)
var LogotypeVariants;
(function (LogotypeVariants) {
  LogotypeVariants["ICON"] = "icon";
  LogotypeVariants["TEXT"] = "text";
  LogotypeVariants["ANIMATED"] = "animated";
})(LogotypeVariants || (LogotypeVariants = {}));

/**
 * Brand Constants
 * @description - Set of trademark constants
 */
const BrandConstants = {
  name: 'ClimateTrade',
  description: 'Carbon Library',
  website: 'https://climatetrade.com',
  contact: 'https://climatetrade.com/contact',
  docs: 'https://api.calculators.climatetrade.net/docs',
  slogan: ['Become carbon neutral', 'with automated calculations.'],
  quote: ['It is time to take action', 'against climate change.']
};

// Constants
/**
 * Logotype Menu Component
 * @description - Application menu rendering
 * @return {JSX.Element}
 */
function LogotypeMenuComponent() {
  // Menu visibility status
  const [menuStatus, setMenuStatus] = useState(false);
  // Navigation system
  const navigate = useNavigate();
  // Rendering of the button to display the menu
  const renderBurger = () => {
    // Conditional icon
    const icon = menuStatus ? 'las la-times' : 'las la-bars';
    // Button Rendering
    return jsx("i", {
      className: icon,
      onClick: () => {
        setMenuStatus(!menuStatus);
      }
    }, 'burger');
  };
  // Rendering a natural HTML link
  const renderLink = (icon, url, label) => {
    // Link rendering in a new tab ('_blank') with phishing limitation ('noopener noreferrer')
    return jsxs("a", Object.assign({
      target: '_blank',
      rel: "noopener noreferrer",
      href: url,
      className: "item"
    }, {
      children: [jsx("i", {
        className: icon
      }), label]
    }), url);
  };
  // Rendering a button with a click event
  const renderButton = (icon, label, action) => {
    return jsxs("div", Object.assign({
      className: "item",
      onClick: action
    }, {
      children: [jsx("i", {
        className: icon
      }), " ", label]
    }), 'item');
  };
  return jsx("div", {
    className: "burger",
    children: [
    // Button to display the menu
    renderBurger(),
    // Drop down menu
    menuStatus && jsx("div", {
      className: "menu",
      children: [renderButton('las la-calculator', `${BrandConstants.name} ${BrandConstants.name}`, () => {
        navigate('/');
      }), renderButton('las la-bug', 'Testing System', () => {
        navigate('/testing');
      }), renderLink('las la-book', BrandConstants.docs, `Documentation`), renderLink('las la-globe', BrandConstants.website, `${BrandConstants.name} Website`), renderLink('las la-sms', BrandConstants.contact, 'Contact Sales')]
    }, 'menu')]
  });
}

/**
 * Version Constants
 */
const VersionConstants = {
  buildMajor: 1,
  buildMinor: 2,
  buildRevision: 1,
  buildTag: "PRO",
  release: "2022-08-31"
};

// Versioning of the application generated by the continuous integration system
/**
 * Logotype Version Component
 * @description - Rendering of the version generated in the application build
 * @return {JSX.Element}
*/
function LogotypeVersionComponent() {
  // Version number rendering
  const renderVersion = () => {
    return jsxs("div", Object.assign({
      className: 'box'
    }, {
      children: [jsxs("div", Object.assign({
        className: 'number'
      }, {
        children: ["V.", jsx("b", {
          children: VersionConstants.buildTag
        }), ".", VersionConstants.buildMajor, ".", VersionConstants.buildMinor, ".", VersionConstants.buildRevision]
      })), jsx("div", {
        className: 'release',
        children: VersionConstants.release
      })]
    }), 'version');
  };
  // Version date rendering
  const renderSince = () => {
    return jsx("div", Object.assign({
      className: 'since'
    }, {
      children: "2022"
    }), 'since');
  };
  return jsx("div", {
    className: 'version',
    children: [renderVersion(), renderSince()]
  });
}

var img$9 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='39.2' height='39.2' viewBox='0 0 39.2 39.2'%3e %3cg id='Grupo_5' data-name='Grupo 5' transform='translate(-873 -639.9)'%3e %3cpath id='Trazado_6' data-name='Trazado 6' d='M19.6%2c0A19.6%2c19.6%2c0%2c1%2c1%2c0%2c19.6%2c19.6%2c19.6%2c0%2c0%2c1%2c19.6%2c0Z' transform='translate(873 639.9)' fill='%231d1313' opacity='0'/%3e %3cg id='Layer_1' transform='translate(807.688 568.522)'%3e %3cg id='Grupo_1' data-name='Grupo 1' transform='translate(65.313 72.078)'%3e %3cpath id='Trazado_1' fill='white' data-name='Trazado 1' d='M100.758%2c99.3a1.72%2c1.72%2c0%2c0%2c1%2c1.678-1.659V98.81a.581.581%2c0%2c0%2c1-.1.39l-.3.585a1.6%2c1.6%2c0%2c0%2c1-1.284.585V99.3M65.313%2c90.712a9.354%2c9.354%2c0%2c0%2c1%2c.1-1.659l.691.78h2.37a2.065%2c2.065%2c0%2c0%2c1%2c1.185.488l1.777%2c1.659h.691a1.263%2c1.263%2c0%2c0%2c1%2c1.284%2c1.366V95l-5.624%2c5.5a21.21%2c21.21%2c0%2c0%2c1-2.472-9.795M85.454%2c79.688a1.083%2c1.083%2c0%2c0%2c1%2c1.481%2c0h0a1.081%2c1.081%2c0%2c0%2c1-1.481%2c0M66.5%2c84.371a18.051%2c18.051%2c0%2c0%2c1%2c3.752-6.341A1.253%2c1.253%2c0%2c0%2c1%2c71.335%2c79.2v.39L66.5%2c84.371m21.129-6.439a.927.927%2c0%2c0%2c1%2c.987.976v1.659a1.076%2c1.076%2c0%2c0%2c1-1.086-.976h0l.1-1.659Zm-7.6-.1a1.385%2c1.385%2c0%2c0%2c1%2c1.876%2c0h0a1.385%2c1.385%2c0%2c0%2c1-1.876%2c0m15.508-3.219h.113A19.658%2c19.658%2c0%2c0%2c1%2c104.2%2c87.688h-.874l-1.284-1.268-.592.585%2c2.567%2c2.537-.691.683a1.925%2c1.925%2c0%2c0%2c1-2.765%2c0h0l-2.073-2.049-.691.683%2c3.456%2c3.415a1.344%2c1.344%2c0%2c0%2c1%2c0%2c1.854l-1.975%2c1.951v5.658l-2.567%2c2.537h-.889a2.073%2c2.073%2c0%2c0%2c1-2.073-2.049V99.3l-.592-.585a2.707%2c2.707%2c0%2c0%2c1-.79-1.951V94.224H89.107l-2.765-2.732V88.566l2.765-2.732h2.271a1.8%2c1.8%2c0%2c0%2c1%2c1.382.585l.592.585h3.653l1.382-1.366L97.1%2c84.371l-.592-.585H95.328l-.79.78H92.464L91.082%2c83.2H89.9l-1.678%2c1.756-.395-.39a1.4%2c1.4%2c0%2c0%2c1%2c0-2.049l.889-.78H89.9V80.566L91.082%2c79.4h2.863V78.42l1.382-1.366-.79-.78-2.073%2c1.951-.1-.2a1.226%2c1.226%2c0%2c0%2c1%2c0-1.756h0l1.678-1.659h1.488ZM73.5%2c75.05A17.968%2c17.968%2c0%2c0%2c1%2c79.671%2c72.1a1.254%2c1.254%2c0%2c0%2c1%2c.452.952v1.854L75.877%2c79.2l-.987-.878a2.336%2c2.336%2c0%2c0%2c1-.691-1.756v-.78l-.57-.488' transform='translate(-65.313 -72.078)'/%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$8 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='88.203' height='88.2' viewBox='0 0 88.203 88.2'%3e %3cg id='Grupo_2' data-name='Grupo 2' transform='translate(-925 -579)'%3e %3cpath id='Trazado_2' data-name='Trazado 2' d='M101.913%2c108.5l12.9%2c13.032a1.781%2c1.781%2c0%2c0%2c1%2c0%2c2.526l-.1.1c-21.1%2c19.6-56.7%2c14.346-70-15.76a41.654%2c41.654%2c0%2c0%2c1%2c0-33.54c13.4-30.105%2c48.9-35.258%2c70.1-15.76a1.784%2c1.784%2c0%2c0%2c1%2c.1%2c2.526l-.1.1-13%2c13.133a1.81%2c1.81%2c0%2c0%2c1-2.4.1c-10.6-9.193-27.7-6.466-34.4%2c8.082a20.833%2c20.833%2c0%2c0%2c0%2c0%2c17.275c6.7%2c14.548%2c23.9%2c17.275%2c34.4%2c8.082a2.081%2c2.081%2c0%2c0%2c1%2c2.5.1Z' transform='translate(883.813 531.453)' fill='white'/%3e %3cpath id='Trazado_3' data-name='Trazado 3' d='M60.725%2c60.949l12.9%2c13.032a1.781%2c1.781%2c0%2c0%2c1%2c0%2c2.526l-.1.1c-21.1%2c19.6-56.7%2c14.346-70-15.76a41.654%2c41.654%2c0%2c0%2c1%2c0-33.54c13.4-30.105%2c48.9-35.258%2c70.1-15.76a1.784%2c1.784%2c0%2c0%2c1%2c.1%2c2.526l-.1.1-13%2c13.133a1.81%2c1.81%2c0%2c0%2c1-2.4.1c-10.6-9.193-27.7-6.466-34.4%2c8.082a20.833%2c20.833%2c0%2c0%2c0%2c0%2c17.275c6.7%2c14.548%2c23.9%2c17.275%2c34.4%2c8.082a2.081%2c2.081%2c0%2c0%2c1%2c2.5.1Z' transform='translate(1013.203 667.2) rotate(180)' opacity='0'/%3e %3c/g%3e%3c/svg%3e";

/**
 * Logotype Icon Component
 * @description - CSS animated SVG app logo rendering
 * @return {JSX.Element}
*/
function LogotypeIconComponent() {
  return jsx("div", Object.assign({
    className: "LogotypeIconComponent"
  }, {
    children: jsxs("div", Object.assign({
      className: 'shapes'
    }, {
      children: [jsx("img", {
        src: img$9,
        alt: BrandConstants.name
      }), jsx("img", {
        src: img$8,
        alt: BrandConstants.name
      })]
    }))
  }));
}

var img$7 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='306.8' height='47.2' viewBox='0 0 306.8 47.2'%3e %3cg id='Layer_1' transform='translate(-127 -68.2)'%3e %3cg id='Grupo_2' data-name='Grupo 2'%3e %3cpath id='Trazado_2' fill='white' data-name='Trazado 2' d='M138.5%2c115.4c-5.4%2c0-9.1-2.5-10.6-7.2-.6-2-.9-4-.9-16.4s.3-14.4.9-16.4c1.5-4.7%2c5.2-7.2%2c10.6-7.2%2c7%2c0%2c10.9%2c3.9%2c11.3%2c11.2a1.068%2c1.068%2c0%2c0%2c1-.9%2c1.3l-5.4.9a.959.959%2c0%2c0%2c1-.9-.2%2c1.234%2c1.234%2c0%2c0%2c1-.4-.8c-.2-4.4-2-5-3.6-5a2.784%2c2.784%2c0%2c0%2c0-3.1%2c2.2c-.3%2c1-.4%2c1.9-.4%2c14s.1%2c13%2c.4%2c14a2.845%2c2.845%2c0%2c0%2c0%2c3.1%2c2.2c1.7%2c0%2c3.4-.6%2c3.6-5.1a.91.91%2c0%2c0%2c1%2c.4-.8%2c1.02%2c1.02%2c0%2c0%2c1%2c.9-.2l5.4.9a1.172%2c1.172%2c0%2c0%2c1%2c.9%2c1.1v.2C149.4%2c111.5%2c145.5%2c115.4%2c138.5%2c115.4Zm34.2-.6H154.2a1.028%2c1.028%2c0%2c0%2c1-1.1-1V69.9a1.028%2c1.028%2c0%2c0%2c1%2c1-1.1H160a1.11%2c1.11%2c0%2c0%2c1%2c1.1%2c1.1v37.6h11.6a1.11%2c1.11%2c0%2c0%2c1%2c1.1%2c1.1v5.2a1.028%2c1.028%2c0%2c0%2c1-1%2c1.1.1.1%2c0%2c0%2c0-.1-.1h0Zm11.6%2c0h-5.8a1.028%2c1.028%2c0%2c0%2c1-1.1-1V69.9a1.028%2c1.028%2c0%2c0%2c1%2c1-1.1h5.9a1.11%2c1.11%2c0%2c0%2c1%2c1.1%2c1.1v43.8a1.269%2c1.269%2c0%2c0%2c1-1.1%2c1.1h0Zm36.6%2c0h-5.1a1.028%2c1.028%2c0%2c0%2c1-1.1-1V87.1l-5.3%2c18.7a1.3%2c1.3%2c0%2c0%2c1-1.3%2c1h-2.9a1.3%2c1.3%2c0%2c0%2c1-1.3-1l-5.3-18.7v26.6a1.028%2c1.028%2c0%2c0%2c1-1%2c1.1h-5.2a1.028%2c1.028%2c0%2c0%2c1-1.1-1V69.9a1.028%2c1.028%2c0%2c0%2c1%2c1-1.1h5.8a1.326%2c1.326%2c0%2c0%2c1%2c1.5%2c1l7.2%2c24.3%2c7-24.3a1.326%2c1.326%2c0%2c0%2c1%2c1.5-1H221a1.028%2c1.028%2c0%2c0%2c1%2c1.1%2c1v43.8a1.379%2c1.379%2c0%2c0%2c1-1.2%2c1.2h0Zm30.4%2c0h-5.6a1.193%2c1.193%2c0%2c0%2c1-1.2-1.1l-1.7-8.7h-8.2l-1.7%2c8.7a1.188%2c1.188%2c0%2c0%2c1-1.2%2c1H226a1.135%2c1.135%2c0%2c0%2c1-.8-.3.959.959%2c0%2c0%2c1-.2-.9l9.7-43.7h0a1.188%2c1.188%2c0%2c0%2c1%2c1.2-1h5.6a1.188%2c1.188%2c0%2c0%2c1%2c1.2%2c1l9.5%2c43.7a1.02%2c1.02%2c0%2c0%2c1-.2.9c-.1.2-.4.3-.7.4ZM235.9%2c98.1h5.6l-2.7-14.4-2.9%2c14.4Zm28.8%2c16.7h-5.8a1.028%2c1.028%2c0%2c0%2c1-1.1-1V76.1H251a1.188%2c1.188%2c0%2c0%2c1-1.2-1V69.9a1.11%2c1.11%2c0%2c0%2c1%2c1.1-1.1h21.8a1.11%2c1.11%2c0%2c0%2c1%2c1.1%2c1.1V75a1.028%2c1.028%2c0%2c0%2c1-1%2c1.1h-7v37.5a1.028%2c1.028%2c0%2c0%2c1-1%2c1.1l-.1.1Zm31.8%2c0H278a1.028%2c1.028%2c0%2c0%2c1-1.1-1V69.9a1.028%2c1.028%2c0%2c0%2c1%2c1-1.1h18.6a1.11%2c1.11%2c0%2c0%2c1%2c1.1%2c1.1V75a1.028%2c1.028%2c0%2c0%2c1-1%2c1.1H284.9V87.9h10a1.028%2c1.028%2c0%2c0%2c1%2c1.1%2c1v5.2a1.028%2c1.028%2c0%2c0%2c1-1%2c1.1H284.9v12.2h11.6a1.11%2c1.11%2c0%2c0%2c1%2c1.1%2c1.1v5.2c.1.5-.4%2c1-1.1%2c1.1h0Zm19.2%2c0h-5.8a1.028%2c1.028%2c0%2c0%2c1-1.1-1V76.1H302a1.188%2c1.188%2c0%2c0%2c1-1.2-1V69.9a1.11%2c1.11%2c0%2c0%2c1%2c1.1-1.1h21.8a1.028%2c1.028%2c0%2c0%2c1%2c1.1%2c1V75a1.028%2c1.028%2c0%2c0%2c1-1%2c1.1h-7v37.5a1.028%2c1.028%2c0%2c0%2c1-1%2c1.1l-.1.1h0Zm36%2c0h-6.2a1.3%2c1.3%2c0%2c0%2c1-1.2-.8l-5.4-17.7h-3v17.3a1.028%2c1.028%2c0%2c0%2c1-1%2c1.1H329a1.028%2c1.028%2c0%2c0%2c1-1.1-1V69.9a1.028%2c1.028%2c0%2c0%2c1%2c1-1.1h9.2c9%2c0%2c13.3%2c4.5%2c13.3%2c13.8%2c0%2c5.6-1.8%2c9.6-5.3%2c11.7l6.2%2c19.1a.972.972%2c0%2c0%2c1-.1.9.536.536%2c0%2c0%2c1-.5.5h0ZM335.9%2c89.1h2.3c3.4%2c0%2c5.2-1%2c5.2-6.5s-1.8-6.5-5.2-6.5H336l-.1%2c13ZM380%2c114.8h-5.6a1.193%2c1.193%2c0%2c0%2c1-1.2-1.1l-1.7-8.7h-8.2l-1.7%2c8.7a1.188%2c1.188%2c0%2c0%2c1-1.2%2c1h-5.6a1.135%2c1.135%2c0%2c0%2c1-.8-.3.959.959%2c0%2c0%2c1-.2-.9l9.8-43.7h0a1.188%2c1.188%2c0%2c0%2c1%2c1.2-1h5.6a1.188%2c1.188%2c0%2c0%2c1%2c1.2%2c1l9.5%2c43.7a1.02%2c1.02%2c0%2c0%2c1-.2.9%2c3.552%2c3.552%2c0%2c0%2c1-.9.4ZM364.6%2c98.1h5.6l-2.7-14.4Zm31%2c16.7H385.2a1.028%2c1.028%2c0%2c0%2c1-1.1-1V69.9a1.028%2c1.028%2c0%2c0%2c1%2c1-1.1h10.5c6%2c0%2c9.7%2c2.5%2c11.4%2c7.5.8%2c2.4%2c1.1%2c5.3%2c1.1%2c15.4s-.4%2c13-1.1%2c15.4c-1.8%2c5.2-5.5%2c7.7-11.4%2c7.7h0Zm-3.6-7.4h2.8c2.3%2c0%2c3.6-.9%2c4.3-2.9.5-1.6.8-4%2c.8-12.7s-.2-11.1-.8-12.7c-.7-2-2-2.9-4.3-2.9H392v31.2Zm40.6%2c7.4H414.2a1.028%2c1.028%2c0%2c0%2c1-1.1-1V69.9a1.028%2c1.028%2c0%2c0%2c1%2c1-1.1h18.6a1.028%2c1.028%2c0%2c0%2c1%2c1.1%2c1V75a1.028%2c1.028%2c0%2c0%2c1-1%2c1.1H421V87.9h10a1.028%2c1.028%2c0%2c0%2c1%2c1.1%2c1v5.2a1.028%2c1.028%2c0%2c0%2c1-1%2c1.1H421v12.2h11.6a1.028%2c1.028%2c0%2c0%2c1%2c1.1%2c1v5.2a1.028%2c1.028%2c0%2c0%2c1-1%2c1.1c0%2c.1%2c0%2c.1-.1.1h0Z'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

/**
 * Logotype Component
 * @description - Animated App Logo Rendering
 * @return {JSX.Element}
*/
function LogotypeAnimatedComponent(properties) {
  // Logo image loader to trigger component animation
  const [loading, setLoading] = useState(true);
  // Render text logo
  const renderTextLogo = () => {
    // The logo must control its load time so that the animation is smooth
    return jsxs(Fragment, {
      children: [jsx("div", Object.assign({
        className: 'title'
      }, {
        children: jsx("img", {
          src: img$7,
          alt: BrandConstants.name,
          onLoad: () => {
            setLoading(false);
          }
        })
      })), jsxs("div", Object.assign({
        className: 'description'
      }, {
        children: [BrandConstants.description, " \u00B7 ", new Date().getFullYear(), " \u00A9"]
      }))]
    });
  };
  return jsxs("div", Object.assign({
    className: "LogotypeComponent"
  }, {
    children: [jsxs("div", Object.assign({
      className: `layout ${loading ? 'loading' : 'success'}`
    }, {
      children: [jsx(LogotypeIconComponent, {}), jsxs("div", Object.assign({
        className: 'text'
      }, {
        children: [renderTextLogo(), jsx(LogotypeVersionComponent, {})]
      }))]
    })), properties.burger && jsx(LogotypeMenuComponent, {})]
  }));
}

const LinkConstants = {
  CLASSNAME: 'LinkComponent' // Default class name to apply to the component.
};

/**
 * Link component
 * @description This is the link to make semantic links
 * @param {Linkproperties} properties
 * @returns {JSX.Element}
 */
function LinkComponent(properties) {
  return jsx("a", {
    className: LinkConstants.CLASSNAME,
    title: properties === null || properties === void 0 ? void 0 : properties.title,
    href: properties.url,
    children: properties.label || properties.children
  });
}

const LogotypeConstants = {
  CLASSNAME: 'LogotypeComponent',
  PATH: '/',
  IMAGES: {
    ICON: '/assets/graphics/logotype/icon.svg',
    TEXT: '/assets/graphics/logotype/text.svg'
  }
};

var img$6 = "data:image/svg+xml,%3csvg width='76' height='40' viewBox='0 0 76 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M39.1559 19.3285C37.8996 19.3285 37.0441 18.7668 36.7117 17.7052C36.5651 17.2625 36.5064 16.8056 36.5064 14.0161C36.5064 11.2266 36.5651 10.7649 36.7117 10.327C37.0637 9.26068 37.9192 8.69898 39.1559 8.69898C40.7789 8.69898 41.6881 9.57485 41.7761 11.2314C41.7907 11.3005 41.7767 11.3723 41.737 11.4313C41.6982 11.4785 41.6422 11.5093 41.5806 11.517L40.3389 11.7265C40.3024 11.734 40.2647 11.7337 40.2284 11.7255C40.1921 11.7172 40.158 11.7013 40.1287 11.6789C40.1014 11.656 40.0798 11.6274 40.0654 11.5953C40.051 11.5631 40.0443 11.5282 40.0456 11.4932C39.9918 10.4936 39.591 10.3555 39.1999 10.3555C39.0405 10.3354 38.879 10.3727 38.7458 10.4604C38.6126 10.548 38.5168 10.68 38.4764 10.8315C38.4031 11.0553 38.3738 11.2647 38.3738 13.9971C38.3738 16.7294 38.4031 16.9389 38.4764 17.1626C38.5177 17.3136 38.6137 17.445 38.7467 17.5325C38.8797 17.6199 39.0406 17.6576 39.1999 17.6386C39.591 17.6386 39.9918 17.5006 40.0456 16.4962C40.045 16.4619 40.0521 16.428 40.0665 16.3967C40.0808 16.3654 40.1021 16.3376 40.1287 16.3153C40.1576 16.292 40.1915 16.2752 40.2278 16.2661C40.2641 16.2571 40.3021 16.256 40.3389 16.2629L41.5806 16.4724C41.6142 16.4785 41.6462 16.4913 41.6746 16.5099C41.7029 16.5286 41.727 16.5527 41.7453 16.5809C41.7637 16.609 41.7759 16.6405 41.7812 16.6734C41.7865 16.7064 41.7847 16.74 41.7761 16.7722C41.6881 18.4526 40.7789 19.3285 39.1559 19.3285ZM47.0702 19.1952H42.788C42.7538 19.1958 42.7198 19.1897 42.6881 19.1773C42.6563 19.1648 42.6275 19.1463 42.6033 19.1227C42.5791 19.0992 42.5601 19.0711 42.5473 19.0402C42.5345 19.0093 42.5283 18.9762 42.5289 18.9429V9.08932C42.5276 9.05561 42.5333 9.022 42.5458 8.99054C42.5583 8.95907 42.5773 8.93043 42.6015 8.90636C42.6258 8.88229 42.6548 8.8633 42.6869 8.85056C42.719 8.83782 42.7534 8.83159 42.788 8.83227H44.1225C44.1572 8.83159 44.1916 8.83782 44.2237 8.85056C44.2557 8.8633 44.2848 8.88229 44.309 8.90636C44.3333 8.93043 44.3523 8.95907 44.3647 8.99054C44.3772 9.022 44.383 9.05561 44.3816 9.08932V17.5386H47.0702C47.1045 17.538 47.1384 17.5441 47.1702 17.5565C47.2019 17.569 47.2307 17.5875 47.2549 17.6111C47.2791 17.6346 47.2982 17.6627 47.311 17.6936C47.3238 17.7245 47.33 17.7576 47.3293 17.7909V18.9429C47.33 18.9762 47.3238 19.0093 47.311 19.0402C47.2982 19.0711 47.2791 19.0992 47.2549 19.1227C47.2307 19.1463 47.2019 19.1648 47.1702 19.1773C47.1384 19.1897 47.1045 19.1958 47.0702 19.1952ZM49.7491 19.1952H48.4146C48.3804 19.1958 48.3464 19.1897 48.3146 19.1773C48.2829 19.1648 48.2541 19.1463 48.2299 19.1227C48.2057 19.0992 48.1866 19.0711 48.1738 19.0402C48.1611 19.0093 48.1548 18.9762 48.1555 18.9429V9.08932C48.1541 9.05561 48.1599 9.022 48.1724 8.99054C48.1849 8.95907 48.2038 8.93043 48.2281 8.90636C48.2523 8.88229 48.2814 8.8633 48.3135 8.85056C48.3455 8.83782 48.3799 8.83159 48.4146 8.83227H49.7491C49.7839 8.83162 49.8186 8.83783 49.8509 8.85052C49.8832 8.8632 49.9126 8.88211 49.9372 8.90611C49.9619 8.93011 49.9813 8.95871 49.9943 8.99019C50.0074 9.02167 50.0137 9.05538 50.0131 9.08932V18.9429C50.0138 18.9766 50.0074 19.0101 49.9943 19.0413C49.9812 19.0726 49.9617 19.1009 49.937 19.1245C49.9123 19.1481 49.8828 19.1666 49.8505 19.1787C49.8182 19.1909 49.7837 19.1965 49.7491 19.1952ZM58.2305 19.1952H57.0524C57.0177 19.1965 56.9832 19.1909 56.9509 19.1787C56.9186 19.1666 56.8892 19.1481 56.8645 19.1245C56.8398 19.1009 56.8203 19.0726 56.8072 19.0413C56.7941 19.0101 56.7877 18.9766 56.7884 18.9429V12.9498L55.5565 17.1626C55.5399 17.2284 55.501 17.2868 55.4459 17.3283C55.3909 17.3698 55.323 17.3919 55.2534 17.3911H54.5788C54.5105 17.392 54.4439 17.3704 54.3897 17.3297C54.3356 17.2891 54.2972 17.2319 54.2806 17.1673L53.0488 12.9498V18.9429C53.0494 18.9766 53.0431 19.0101 53.03 19.0413C53.0169 19.0726 52.9974 19.1009 52.9727 19.1245C52.948 19.1481 52.9185 19.1666 52.8862 19.1787C52.8539 19.1909 52.8194 19.1965 52.7848 19.1952H51.6165C51.5821 19.1965 51.5478 19.1909 51.5157 19.1787C51.4836 19.1665 51.4545 19.148 51.4302 19.1243C51.4059 19.1006 51.3868 19.0722 51.3743 19.041C51.3618 19.0098 51.356 18.9764 51.3574 18.9429V9.08932C51.356 9.05561 51.3618 9.022 51.3743 8.99054C51.3868 8.95907 51.4057 8.93043 51.43 8.90636C51.4542 8.88229 51.4833 8.8633 51.5154 8.85056C51.5474 8.83782 51.5818 8.83159 51.6165 8.83227H52.951C53.0275 8.82288 53.1048 8.84089 53.1687 8.88292C53.2325 8.92496 53.2785 8.98816 53.2981 9.06076L54.9601 14.5397L56.5733 9.06076C56.5928 8.98816 56.6388 8.92496 56.7027 8.88292C56.7665 8.84089 56.8439 8.82288 56.9204 8.83227H58.2402C58.2749 8.83159 58.3093 8.83782 58.3413 8.85056C58.3734 8.8633 58.4025 8.88229 58.4267 8.90636C58.451 8.93043 58.47 8.95907 58.4824 8.99054C58.4949 9.022 58.5007 9.05561 58.4993 9.08932V18.9429C58.5008 18.9772 58.4948 19.0115 58.4817 19.0434C58.4686 19.0753 58.4487 19.1041 58.4232 19.128C58.3978 19.1518 58.3675 19.1702 58.3343 19.1817C58.301 19.1933 58.2656 19.1979 58.2305 19.1952ZM65.2698 19.1952H63.9646C63.8966 19.1991 63.8298 19.1768 63.7786 19.1332C63.7274 19.0896 63.6958 19.028 63.6908 18.9619L63.2949 17.0007H61.3933L60.9973 18.9619C60.9923 19.028 60.9608 19.0896 60.9095 19.1332C60.8583 19.1768 60.7915 19.1991 60.7235 19.1952H59.4379C59.4037 19.1978 59.3693 19.1923 59.3377 19.179C59.3062 19.1657 59.2785 19.1451 59.257 19.119C59.2341 19.0923 59.2178 19.0608 59.2094 19.0269C59.2009 18.9931 59.2005 18.9579 59.2081 18.9238L61.4617 9.06551C61.473 9.00368 61.506 8.94759 61.555 8.90679C61.604 8.86599 61.6661 8.84302 61.7306 8.84178H63.0211C63.0889 8.8414 63.1544 8.86554 63.205 8.9095C63.2556 8.95347 63.2876 9.01415 63.2949 9.07979L65.4995 18.9286C65.5083 18.963 65.5088 18.9989 65.5012 19.0335C65.4936 19.0682 65.478 19.1006 65.4555 19.1285C65.4318 19.1527 65.4028 19.1713 65.3706 19.1828C65.3384 19.1944 65.3039 19.1986 65.2698 19.1952ZM61.7012 15.4489H62.9918L62.3709 12.2072L61.7012 15.4489ZM68.3641 19.1952H67.0296C66.9954 19.1958 66.9614 19.1897 66.9297 19.1773C66.8979 19.1648 66.8691 19.1463 66.8449 19.1227C66.8207 19.0992 66.8016 19.0711 66.7889 19.0402C66.7761 19.0093 66.7698 18.9762 66.7705 18.9429V10.4888H65.1915C65.1572 10.4902 65.1229 10.4845 65.0908 10.4723C65.0587 10.4601 65.0296 10.4416 65.0053 10.4179C64.9809 10.3942 64.9619 10.3658 64.9494 10.3346C64.9368 10.3034 64.9311 10.27 64.9325 10.2365V9.08932C64.9311 9.05561 64.9369 9.022 64.9494 8.99054C64.9618 8.95907 64.9808 8.93043 65.0051 8.90636C65.0293 8.88229 65.0584 8.8633 65.0904 8.85056C65.1225 8.83782 65.1569 8.83159 65.1915 8.83227H70.1924C70.227 8.83159 70.2614 8.83782 70.2935 8.85056C70.3255 8.8633 70.3546 8.88229 70.3789 8.90636C70.4031 8.93043 70.4221 8.95907 70.4346 8.99054C70.4471 9.022 70.4528 9.05561 70.4515 9.08932V10.2603C70.4528 10.2938 70.4471 10.3272 70.4345 10.3584C70.422 10.3896 70.403 10.418 70.3786 10.4417C70.3543 10.4654 70.3252 10.4839 70.2931 10.4961C70.2611 10.5083 70.2268 10.5139 70.1924 10.5126H68.6281V18.9667C68.6262 18.9986 68.6179 19.0298 68.6036 19.0586C68.5893 19.0873 68.5694 19.1131 68.5448 19.1343C68.5203 19.1555 68.4917 19.1718 68.4607 19.1823C68.4297 19.1927 68.3969 19.1971 68.3641 19.1952ZM75.7407 19.1952H71.4634C71.429 19.1965 71.3947 19.1909 71.3626 19.1787C71.3306 19.1665 71.3014 19.148 71.2771 19.1243C71.2528 19.1006 71.2337 19.0722 71.2212 19.041C71.2087 19.0098 71.2029 18.9764 71.2043 18.9429V9.08932C71.2029 9.05561 71.2087 9.022 71.2212 8.99054C71.2337 8.95907 71.2526 8.93043 71.2769 8.90636C71.3011 8.88229 71.3302 8.8633 71.3623 8.85056C71.3943 8.83782 71.4287 8.83159 71.4634 8.83227H75.7407C75.7753 8.83159 75.8097 8.83782 75.8418 8.85056C75.8739 8.8633 75.9029 8.88229 75.9272 8.90636C75.9515 8.93043 75.9704 8.95907 75.9829 8.99054C75.9954 9.022 76.0011 9.05561 75.9998 9.08932V10.2603C76.0012 10.2938 75.9954 10.3272 75.9829 10.3584C75.9703 10.3896 75.9513 10.418 75.927 10.4417C75.9026 10.4654 75.8735 10.4839 75.8415 10.4961C75.8094 10.5083 75.7751 10.5139 75.7407 10.5126H73.057V13.1164H75.3741C75.4085 13.1151 75.4428 13.1207 75.4748 13.1329C75.5069 13.1451 75.536 13.1636 75.5603 13.1873C75.5847 13.211 75.6037 13.2394 75.6162 13.2706C75.6288 13.3018 75.6345 13.3352 75.6332 13.3687V14.5445C75.6338 14.5778 75.6276 14.6109 75.6148 14.6418C75.602 14.6727 75.5829 14.7008 75.5588 14.7243C75.5346 14.7479 75.5057 14.7664 75.474 14.7789C75.4423 14.7913 75.4083 14.7974 75.3741 14.7968H73.057V17.5434H75.7407C75.7749 17.5427 75.8089 17.5488 75.8406 17.5613C75.8724 17.5737 75.9012 17.5923 75.9254 17.6158C75.9496 17.6394 75.9687 17.6675 75.9814 17.6984C75.9942 17.7293 76.0005 17.7624 75.9998 17.7957V18.9476C76.0005 18.9807 75.9942 19.0136 75.9814 19.0443C75.9686 19.0749 75.9494 19.1027 75.9251 19.1259C75.9009 19.1491 75.872 19.1672 75.8403 19.1791C75.8086 19.191 75.7747 19.1965 75.7407 19.1952ZM39.9234 31.3336H38.5889C38.5545 31.335 38.5202 31.3294 38.4881 31.3172C38.4561 31.305 38.427 31.2864 38.4026 31.2627C38.3783 31.239 38.3592 31.2107 38.3467 31.1795C38.3342 31.1482 38.3284 31.1148 38.3298 31.0813V22.6368H36.7508C36.7162 22.6381 36.6817 22.6325 36.6494 22.6203C36.6171 22.6082 36.5877 22.5897 36.563 22.5661C36.5382 22.5425 36.5187 22.5142 36.5056 22.4829C36.4926 22.4517 36.4862 22.4182 36.4869 22.3845V21.2087C36.4862 21.175 36.4926 21.1415 36.5056 21.1103C36.5187 21.0791 36.5382 21.0508 36.563 21.0271C36.5877 21.0035 36.6171 20.985 36.6494 20.9729C36.6817 20.9607 36.7162 20.9551 36.7508 20.9564H41.7614C41.7957 20.9558 41.8296 20.9619 41.8614 20.9743C41.8931 20.9868 41.9219 21.0053 41.9461 21.0289C41.9703 21.0525 41.9894 21.0805 42.0022 21.1114C42.015 21.1423 42.0212 21.1754 42.0205 21.2087V22.3607C42.0219 22.3942 42.0162 22.4276 42.0036 22.4588C41.9911 22.49 41.9721 22.5184 41.9477 22.5421C41.9234 22.5658 41.8943 22.5843 41.8622 22.5965C41.8301 22.6087 41.7958 22.6143 41.7614 22.613H40.1825V31.0671C40.186 31.1017 40.1819 31.1367 40.1703 31.1696C40.1588 31.2026 40.1401 31.2327 40.1155 31.258C40.0909 31.2833 40.061 31.3031 40.0279 31.3162C39.9948 31.3292 39.9591 31.3352 39.9234 31.3336ZM48.2337 31.3336H46.8063C46.7487 31.3394 46.6908 31.3254 46.6427 31.2941C46.5945 31.2628 46.559 31.2162 46.5423 31.1623L45.286 27.1828H44.6016V31.0813C44.603 31.1148 44.5972 31.1482 44.5847 31.1795C44.5722 31.2107 44.5531 31.239 44.5288 31.2627C44.5045 31.2864 44.4753 31.305 44.4433 31.3172C44.4112 31.3294 44.3769 31.335 44.3425 31.3336H43.008C42.9738 31.3343 42.9398 31.3282 42.9081 31.3157C42.8763 31.3033 42.8475 31.2847 42.8233 31.2612C42.7991 31.2376 42.7801 31.2095 42.7673 31.1786C42.7545 31.1477 42.7482 31.1147 42.7489 31.0813V21.2087C42.7482 21.1754 42.7545 21.1423 42.7673 21.1114C42.7801 21.0805 42.7991 21.0525 42.8233 21.0289C42.8475 21.0053 42.8763 20.9868 42.9081 20.9743C42.9398 20.9619 42.9738 20.9558 43.008 20.9564H45.11C47.1827 20.9564 48.1946 21.9799 48.1946 24.0791C48.1946 25.3453 47.784 26.2355 46.9725 26.721L48.4146 31.0337C48.4313 31.0654 48.44 31.1005 48.44 31.1361C48.44 31.1717 48.4313 31.2068 48.4146 31.2384C48.3985 31.2676 48.3744 31.2919 48.3451 31.3087C48.3158 31.3255 48.2824 31.3341 48.2484 31.3336H48.2337ZM44.5967 25.5548H45.1198C45.9068 25.5548 46.3321 25.3215 46.3321 24.0934C46.3321 22.8653 45.9068 22.6273 45.1198 22.6273H44.6016L44.5967 25.5548ZM54.7988 31.3336H53.4936C53.4252 31.3363 53.3584 31.3129 53.3073 31.2685C53.2562 31.2241 53.2249 31.1621 53.2199 31.0956L52.8239 29.1392H50.9272L50.5312 31.1004C50.5262 31.1665 50.4947 31.228 50.4435 31.2717C50.3922 31.3153 50.3254 31.3376 50.2575 31.3336H48.9523C48.9183 31.3342 48.8846 31.3276 48.8534 31.3145C48.8222 31.3014 48.7943 31.2819 48.7714 31.2575C48.7503 31.2298 48.7354 31.1981 48.7278 31.1645C48.7203 31.1308 48.7201 31.096 48.7274 31.0623L50.9956 21.2087C51.0069 21.1469 51.0399 21.0908 51.0889 21.05C51.138 21.0092 51.2 20.9862 51.2645 20.985H52.555C52.6223 20.9847 52.6872 21.009 52.737 21.0531C52.7868 21.0971 52.8178 21.1578 52.8239 21.223L55.0383 31.0575C55.0461 31.092 55.0461 31.1277 55.0385 31.1621C55.0309 31.1966 55.0159 31.2291 54.9943 31.2575C54.9715 31.2819 54.9435 31.3014 54.9123 31.3145C54.8811 31.3276 54.8474 31.3342 54.8135 31.3336H54.7988ZM51.2303 27.5874H52.5208L51.8902 24.3409L51.2303 27.5874ZM58.4016 31.3336H56.016C55.9816 31.335 55.9473 31.3294 55.9153 31.3172C55.8832 31.305 55.8541 31.2864 55.8298 31.2627C55.8054 31.239 55.7864 31.2107 55.7739 31.1795C55.7613 31.1482 55.7556 31.1148 55.7569 31.0813V21.2087C55.7563 21.1754 55.7625 21.1423 55.7753 21.1114C55.7881 21.0805 55.8071 21.0525 55.8313 21.0289C55.8555 21.0053 55.8844 20.9868 55.9161 20.9743C55.9478 20.9619 55.9818 20.9558 56.016 20.9564H58.426C59.8094 20.9564 60.6698 21.5134 61.056 22.6558C61.2368 23.1985 61.3199 23.8554 61.3199 26.1403C61.3199 28.4252 61.2368 29.0773 61.056 29.62C60.66 30.7767 59.7996 31.3336 58.4162 31.3336H58.4016ZM57.5852 29.6771H58.2305C58.4513 29.7027 58.6743 29.6499 58.8583 29.5284C59.0424 29.4068 59.1753 29.2247 59.2326 29.0154C59.3548 28.6489 59.4135 28.1253 59.4135 26.1593C59.4135 24.1934 59.3548 23.6602 59.2326 23.3032C59.1753 23.0939 59.0424 22.9118 58.8583 22.7903C58.6743 22.6687 58.4513 22.6159 58.2305 22.6415H57.5852V29.6771ZM66.9856 31.3336H62.7082C62.6738 31.335 62.6395 31.3294 62.6075 31.3172C62.5754 31.305 62.5463 31.2864 62.522 31.2627C62.4976 31.239 62.4786 31.2107 62.4661 31.1795C62.4535 31.1482 62.4478 31.1148 62.4492 31.0813V21.2087C62.4485 21.1754 62.4547 21.1423 62.4675 21.1114C62.4803 21.0805 62.4994 21.0525 62.5236 21.0289C62.5477 21.0053 62.5766 20.9868 62.6083 20.9743C62.6401 20.9619 62.674 20.9558 62.7082 20.9564H66.9856C67.0198 20.9558 67.0538 20.9619 67.0855 20.9743C67.1172 20.9868 67.1461 21.0053 67.1703 21.0289C67.1945 21.0525 67.2135 21.0805 67.2263 21.1114C67.2391 21.1423 67.2453 21.1754 67.2447 21.2087V22.3607C67.246 22.3942 67.2403 22.4276 67.2278 22.4588C67.2152 22.49 67.1962 22.5184 67.1719 22.5421C67.1475 22.5658 67.1184 22.5843 67.0863 22.5965C67.0543 22.6087 67.02 22.6143 66.9856 22.613H64.3263V25.2596H66.6434C66.6778 25.2583 66.7121 25.2639 66.7442 25.2761C66.7762 25.2883 66.8053 25.3069 66.8297 25.3306C66.854 25.3543 66.873 25.3826 66.8856 25.4138C66.8981 25.445 66.9039 25.4784 66.9025 25.5119V26.6591C66.9039 26.6926 66.8981 26.726 66.8856 26.7572C66.873 26.7885 66.854 26.8168 66.8297 26.8405C66.8053 26.8642 66.7762 26.8828 66.7442 26.895C66.7121 26.9072 66.6778 26.9128 66.6434 26.9114H64.3263V29.6628H67.01C67.0444 29.6615 67.0787 29.6671 67.1108 29.6793C67.1428 29.6915 67.172 29.71 67.1963 29.7337C67.2206 29.7574 67.2397 29.7858 67.2522 29.817C67.2647 29.8482 67.2705 29.8816 67.2691 29.9151V31.0671C67.2728 31.1026 67.2685 31.1384 67.2564 31.1721C67.2442 31.2057 67.2246 31.2364 67.199 31.2618C67.1733 31.2873 67.1422 31.3069 67.1078 31.3193C67.0735 31.3317 67.0368 31.3366 67.0003 31.3336H66.9856ZM28.5774 27.6255C29.9071 28.925 33.2752 32.2047 34.6635 33.5519C34.7441 33.6318 34.8073 33.7267 34.8494 33.831C34.8915 33.9353 34.9115 34.0468 34.9083 34.1587C34.9051 34.2707 34.8788 34.3809 34.8308 34.4828C34.7829 34.5846 34.7143 34.676 34.6293 34.7514C24.696 43.6244 7.96795 41.2491 1.67169 27.6112C0.569676 25.2154 0 22.62 0 19.9949C0 17.3698 0.569676 14.7743 1.67169 12.3786C7.96795 -1.24504 24.7009 -3.62036 34.6342 5.23833C34.7191 5.31335 34.7875 5.40432 34.8354 5.50576C34.8833 5.6072 34.9096 5.71703 34.9128 5.82863C34.916 5.94023 34.896 6.05131 34.854 6.1552C34.812 6.25908 34.7489 6.35362 34.6684 6.43314L28.5725 12.3738C28.4257 12.516 28.2289 12.5985 28.022 12.6047C27.8151 12.6109 27.6135 12.5403 27.458 12.4072C22.4963 8.242 14.4109 9.45585 11.2725 16.0582C10.6903 17.2898 10.3888 18.6296 10.3888 19.9854C10.3888 21.3412 10.6903 22.6809 11.2725 23.9125C14.4109 30.5149 22.5158 31.7287 27.4629 27.5588C27.6235 27.4257 27.8308 27.3584 28.0413 27.3708C28.2518 27.3832 28.4492 27.4745 28.5921 27.6255H28.5774ZM28.2695 24.022C28.2695 23.9191 28.2904 23.8172 28.331 23.7221C28.3715 23.6271 28.431 23.5408 28.506 23.4683C28.581 23.3957 28.6699 23.3383 28.7678 23.2994C28.8656 23.2604 28.9704 23.2407 29.0761 23.2413V23.8078C29.0742 23.8757 29.0627 23.9429 29.0418 24.0077C28.993 24.1029 28.9441 24.2029 28.8903 24.2981C28.8159 24.3889 28.7215 24.4622 28.614 24.5124C28.5065 24.5627 28.3887 24.5887 28.2695 24.5885V24.022ZM11.3801 19.9616C11.3801 19.7093 11.3801 19.457 11.4192 19.2047L11.7662 19.5474H12.8808C12.9817 19.5464 13.0818 19.5652 13.1751 19.6029C13.2683 19.6405 13.3528 19.6961 13.4234 19.7664L14.2593 20.5804H14.582C14.7509 20.5804 14.9131 20.6454 15.033 20.7613C15.153 20.8773 15.221 21.0347 15.2223 21.1992V21.9942L12.6364 24.5123C11.812 23.1301 11.3785 21.5599 11.3801 19.9616ZM20.9222 14.8158C20.9678 14.7697 21.0225 14.7331 21.083 14.7081C21.1434 14.683 21.2085 14.6701 21.2742 14.6701C21.3399 14.6701 21.4049 14.683 21.4654 14.7081C21.5259 14.7331 21.5805 14.7697 21.6261 14.8158C21.5805 14.8619 21.5259 14.8985 21.4654 14.9236C21.4049 14.9486 21.3399 14.9615 21.2742 14.9615C21.2085 14.9615 21.1434 14.9486 21.083 14.9236C21.0225 14.8985 20.9678 14.8619 20.9222 14.8158ZM11.8933 16.996C12.2818 15.9005 12.8843 14.8885 13.6678 14.0161C13.8096 14.0302 13.941 14.0949 14.0366 14.1978C14.1323 14.3006 14.1855 14.4343 14.186 14.573V14.7682L11.8933 16.996ZM21.9634 13.9875C22.0931 13.9875 22.2174 14.0377 22.3091 14.127C22.4008 14.2162 22.4523 14.3373 22.4523 14.4636V15.249C22.3226 15.249 22.1983 15.1988 22.1066 15.1096C22.0149 15.0203 21.9634 14.8992 21.9634 14.773V14.0066V13.9875ZM18.3509 13.9304C18.4716 13.815 18.6339 13.7503 18.8031 13.7503C18.9722 13.7503 19.1346 13.815 19.2553 13.9304C19.1352 14.047 18.9726 14.1124 18.8031 14.1124C18.6336 14.1124 18.4709 14.047 18.3509 13.9304ZM25.8106 12.4024H25.8595C26.9373 13.0982 27.8541 14.0054 28.5511 15.0661C29.2481 16.1268 29.7099 17.3175 29.9071 18.5621H29.4573L28.8561 17.9718L28.5823 18.2384L29.8191 19.4379L29.4769 19.7664C29.3891 19.8532 29.2845 19.9221 29.1691 19.9691C29.0537 20.0162 28.9298 20.0404 28.8048 20.0404C28.6797 20.0404 28.5558 20.0162 28.4404 19.9691C28.325 19.9221 28.2204 19.8532 28.1326 19.7664L27.1549 18.8144L26.8372 19.119L28.4797 20.7137C28.5952 20.8269 28.66 20.9801 28.66 21.1397C28.66 21.2993 28.5952 21.4525 28.4797 21.5657L27.546 22.4749V25.1406L26.3288 26.3259H25.8986C25.6393 26.3259 25.3906 26.2256 25.2073 26.0471C25.0239 25.8685 24.9209 25.6264 24.9209 25.3739V24.0172L24.6472 23.7507C24.401 23.5086 24.2624 23.1821 24.261 22.8415V21.6847H22.7162L21.4062 20.409V19.0476L22.7162 17.7719H23.8064C24.0611 17.7742 24.305 17.8732 24.4858 18.048L24.7694 18.3241H26.495L27.1745 17.6576L26.5536 17.0579L26.2506 16.7627H25.6591L25.2973 17.115H24.3196L23.6597 16.4676H23.1171L22.2958 17.2721L22.0856 17.0674C22.0212 17.005 21.9701 16.9308 21.9352 16.8491C21.9003 16.7674 21.8823 16.6798 21.8823 16.5914C21.8823 16.5029 21.9003 16.4153 21.9352 16.3336C21.9701 16.2519 22.0212 16.1777 22.0856 16.1153L22.4865 15.725H23.0487V15.1776L23.601 14.6444H24.9845V14.1161L25.6444 13.4687L25.2827 13.1212L24.305 14.0732L24.2365 14.0066C24.1287 13.899 24.0684 13.7547 24.0684 13.6043C24.0684 13.454 24.1287 13.3097 24.2365 13.2021L25.0578 12.4024H25.8106ZM15.2468 12.6071C16.147 11.9722 17.157 11.4998 18.2287 11.2124C18.3534 11.3412 18.4232 11.5113 18.4242 11.6884V12.5595L16.376 14.5445L15.936 14.1161C15.7113 13.8978 15.5847 13.6016 15.5841 13.2926V12.9117L15.2614 12.5976' fill='%23003E6F' /%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3csvg width='35' height='40' viewBox='0 0 35 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M27.8386 27.6326L33.7659 33.5599C33.8449 33.6392 33.9069 33.7338 33.9482 33.8379C33.9895 33.9419 34.0092 34.0533 34.0062 34.1653C34.0031 34.2772 33.9772 34.3873 33.9303 34.489C33.8833 34.5906 33.8161 34.6816 33.7328 34.7565C24.0607 43.6182 7.77281 41.2528 1.63214 27.6199C0.556241 25.2229 0 22.6254 0 19.998C0 17.3707 0.556241 14.7731 1.63214 12.3762C7.76265 -1.24914 24.0556 -3.6297 33.7278 5.26246C33.811 5.33733 33.8782 5.42835 33.9252 5.52998C33.9722 5.63162 33.998 5.74176 34.0011 5.85369C34.0042 5.96562 33.9845 6.07701 33.9431 6.18108C33.9018 6.28516 33.8398 6.37975 33.7608 6.45909L27.8234 12.3965C27.6808 12.538 27.49 12.6204 27.2892 12.627C27.0884 12.6336 26.8926 12.564 26.7411 12.4321C21.9139 8.26547 14.038 9.48242 10.9892 16.0829C10.4218 17.3137 10.1279 18.6529 10.1279 20.0082C10.1279 21.3635 10.4218 22.7027 10.9892 23.9335C14.038 30.5391 21.9139 31.7535 26.7411 27.5818C26.8936 27.4449 27.0933 27.3726 27.298 27.3802C27.5028 27.3878 27.6966 27.4747 27.8386 27.6224V27.6326ZM27.5464 24.0148C27.5464 23.8079 27.6286 23.6095 27.7749 23.4632C27.9212 23.317 28.1195 23.2348 28.3264 23.2348V23.8013C28.3248 23.8691 28.3154 23.9364 28.2985 24.0021L28.1486 24.2942C28.0754 24.3834 27.9836 24.4553 27.8795 24.5049C27.7754 24.5545 27.6617 24.5806 27.5464 24.5813V24.0148ZM11.0985 19.9498C11.0985 19.6957 11.1137 19.4416 11.134 19.1876L11.4745 19.528H12.5568C12.6551 19.5279 12.7526 19.5473 12.8433 19.5853C12.934 19.6232 13.0163 19.6789 13.0852 19.7491L13.8982 20.5621H14.2133C14.3784 20.5621 14.5367 20.6276 14.6534 20.7444C14.7701 20.8611 14.8357 21.0194 14.8357 21.1845V21.9797L12.3205 24.4924C11.5165 23.1118 11.0939 21.5423 11.0959 19.9447L11.0985 19.9498ZM20.387 14.7949C20.4782 14.7053 20.6009 14.6552 20.7287 14.6552C20.8565 14.6552 20.9792 14.7053 21.0704 14.7949C21.0257 14.8401 20.9725 14.876 20.9139 14.9005C20.8552 14.9251 20.7923 14.9377 20.7287 14.9377C20.6651 14.9377 20.6022 14.9251 20.5435 14.9005C20.4848 14.876 20.4316 14.8401 20.387 14.7949ZM11.5964 16.9798C11.9756 15.8888 12.5603 14.8806 13.319 14.0098C13.4578 14.0236 13.5866 14.0884 13.6804 14.1916C13.7743 14.2949 13.8265 14.4292 13.8271 14.5687V14.7618L11.5964 16.9925V16.9798ZM21.4007 13.9844C21.5226 13.9844 21.6396 14.0328 21.7258 14.1191C21.8121 14.2053 21.8605 14.3223 21.8605 14.4442V15.2318C21.7967 15.2322 21.7335 15.2199 21.6744 15.1956C21.6154 15.1713 21.5618 15.1356 21.5166 15.0905C21.4715 15.0453 21.4358 14.9917 21.4115 14.9327C21.3873 14.8737 21.3749 14.8104 21.3753 14.7466V13.9844H21.4007ZM17.8921 13.926C17.9499 13.868 18.0186 13.822 18.0943 13.7906C18.1699 13.7592 18.251 13.743 18.3329 13.743C18.4148 13.743 18.4959 13.7592 18.5715 13.7906C18.6472 13.822 18.7159 13.868 18.7737 13.926C18.7159 13.984 18.6472 14.03 18.5715 14.0614C18.4959 14.0928 18.4148 14.1089 18.3329 14.1089C18.251 14.1089 18.1699 14.0928 18.0943 14.0614C18.0186 14.03 17.9499 13.984 17.8921 13.926ZM25.1557 12.4016H25.204C26.2526 13.0982 27.1448 14.0056 27.8236 15.0658C28.5025 16.1261 28.9532 17.3161 29.147 18.56H28.71L28.1232 17.9732L27.8691 18.2272L29.0708 19.4264L28.7405 19.7592C28.5663 19.9324 28.3307 20.0295 28.085 20.0295C27.8394 20.0295 27.6038 19.9324 27.4296 19.7592L26.4743 18.8014L26.1669 19.1088L27.7624 20.7043C27.8185 20.7601 27.8631 20.8264 27.8935 20.8994C27.9239 20.9724 27.9396 21.0508 27.9396 21.1299C27.9396 21.209 27.9239 21.2873 27.8935 21.3604C27.8631 21.4334 27.8185 21.4997 27.7624 21.5554L26.8554 22.465V25.1301L25.6689 26.3166H25.2497C24.9991 26.3166 24.7587 26.217 24.5814 26.0397C24.4042 25.8625 24.3046 25.6221 24.3046 25.3714V24.0275L24.0378 23.7734C23.9183 23.6535 23.8236 23.5113 23.7591 23.3548C23.6945 23.1983 23.6615 23.0306 23.6618 22.8613V21.6901H22.1552L20.8849 20.4198V19.0478L22.1552 17.7775H23.2172C23.4658 17.778 23.7041 17.8766 23.8803 18.0519L24.1547 18.3263H25.8315L26.4946 17.6632L25.8925 17.0611L25.5978 16.7664H25.0109L24.6349 17.117H23.6974L23.0521 16.4717H22.5236L21.7233 17.272L21.5201 17.0687C21.3957 16.9439 21.3258 16.7749 21.3258 16.5987C21.3258 16.4225 21.3957 16.2535 21.5201 16.1287L21.9088 15.74H22.4652V15.1912L23.0013 14.6551H24.3503V14.1267L24.9931 13.4839L24.6425 13.1308L23.6974 14.0682L23.6313 14.0022C23.5781 13.9495 23.5358 13.8868 23.507 13.8177C23.4782 13.7485 23.4633 13.6744 23.4633 13.5995C23.4633 13.5246 23.4782 13.4504 23.507 13.3813C23.5358 13.3122 23.5781 13.2495 23.6313 13.1968L24.4291 12.3991L25.1557 12.4016ZM14.8738 12.6048C15.7459 11.9748 16.7232 11.505 17.76 11.2177C17.8809 11.3453 17.9482 11.5144 17.948 11.6902V12.5617L15.9561 14.556L15.5268 14.1267C15.4186 14.0186 15.3329 13.8903 15.2745 13.749C15.216 13.6078 15.1861 13.4564 15.1863 13.3035V12.9224L14.8738 12.6048Z' fill='%23003E6F'/%3e%3c/svg%3e";

/**
 * Logotype component
 * @description Render the logotype of the application in SVG format
 * @returns {JSX.Element}
 */
function LogotypeStaticComponent(properties) {
  // Render Logotype SVG
  const renderSVG = () => {
    return jsx("img", {
      src: properties.variant === 'icon' ? img$5 : img$6,
      alt: BrandConstants.name
    });
  };
  // Render Logotype Link
  const renderLink = () => {
    return jsx(LinkComponent, {
      url: LogotypeConstants.PATH,
      children: renderSVG()
    });
  };
  return jsx("div", {
    className: LogotypeConstants.CLASSNAME,
    children: renderLink()
  });
}

/**
 * Logotype component
 * @description Render the logotype of the application in SVG format
 * @returns {JSX.Element}
 */
function LogotypeComponent(properties = {
  variant: LogotypeVariants.TEXT
}) {
  return properties.variant === 'animated' ? jsx(LogotypeAnimatedComponent, Object.assign({}, properties)) : jsx(LogotypeStaticComponent, Object.assign({}, properties));
}

const CounterConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'CounterComponent'
};

/**
 * Counter component
 * @description A component that renders a counter with a value and text to the right
 * @param {CounterProperties} properties
 * @returns A counter component
 */
function CounterComponent(properties) {
  // Classnames definition
  const classNames = [
  // Base classname
  CounterConstants.BASE_CLASSNAME, ...(properties.size ? [`${CounterConstants.BASE_CLASSNAME}--${properties === null || properties === void 0 ? void 0 : properties.size}`] : [])].join(' ');
  return jsxs("div", Object.assign({
    className: classNames
  }, {
    children: [jsxs("em", {
      children: [properties.icon && jsx(IconComponent, {
        name: properties.icon,
        size: 32
      }), properties.count]
    }), jsx("span", {
      children: properties.text && jsx("b", {
        children: properties.text
      })
    })]
  }));
}

const SpaceConstants = {
  CLASSNAME: 'SpaceComponent'
};

/**
 * Space component
 * @description Component to render space between elements
 * @returns {JSX.Element} A space component
 */
function SpaceComponent(props) {
  return jsx("hr", {
    className: SpaceConstants.CLASSNAME,
    style: {
      width: props.size || 16,
      height: props.size || 16
    }
  });
}

const SearchConstants = {
  CLASSNAME: 'SearchComponent',
  DEFAULTVALUE: '',
  ICONS: {
    SEARCH: IconNames.SEARCH,
    CLEAN: IconNames.CLEAN
  },
  KEYS: {
    ENTER: 'Enter'
  }
};

/**
 * Search component
 * @description This is the search to make semantic form search
 * @param {SearchProperties} properties
 * @returns {JSX.Element} Search Component
 */
function SearchComponent(properties) {
  /**
   * State for the search input value with the initial value passed as defaultValue property
   */
  const [value, setValue] = useState(properties.defaultValue || SearchConstants.DEFAULTVALUE);
  // Handle the keyDown of the search
  const onKeyDown = event => {
    var _a;
    // Detect Key Enter
    if (event.key === SearchConstants.KEYS.ENTER) {
      // Call the function of onChange
      (_a = properties.onSubmit) === null || _a === void 0 ? void 0 : _a.call(properties, value);
    }
  };
  // Handle the change of the search
  const onChange = event => {
    // Set the value of the search
    setValue(event.target.value);
  };
  // Close Component
  const renderClose = () => {
    if (value) {
      return jsx(IconComponent, {
        name: SearchConstants.ICONS.CLEAN,
        onClick: () => setValue(SearchConstants.DEFAULTVALUE)
      });
    }
  };
  // Execute Run Callback when the value change
  useEffect(() => {
    var _a;
    (_a = properties.onChange) === null || _a === void 0 ? void 0 : _a.call(properties, value);
  }, [value]);
  // Render of Input Search
  const renderInput = () => {
    return jsx("input", {
      type: "text",
      value: value,
      onKeyDown: onKeyDown,
      onChange: onChange,
      placeholder: properties === null || properties === void 0 ? void 0 : properties.placeholder
    });
  };
  // Render of Controls of Search
  const renderControls = () => {
    return jsx(Fragment, {
      children: renderClose() || null
    });
  };
  // Generate class
  const classNames = [SearchConstants.CLASSNAME, ...((properties === null || properties === void 0 ? void 0 : properties.variant) ? [properties === null || properties === void 0 ? void 0 : properties.variant] : [])].join(' ');
  return jsx("div", Object.assign({
    className: classNames
  }, {
    children: jsxs("div", Object.assign({
      className: "box"
    }, {
      children: [renderInput(), renderControls()]
    }))
  }));
}

/**
 * Constants for the tooltip component
 */
const TooltipConstants = {
  CLASSNAME: 'TooltipComponent' // Default class name to apply to the component.
};

/**
 * Tooltip component
 * @description Rendering conditionally with tooltip
 * @param {TooltipProperties} properties
 * @returns A tooltip component
 */
function TooltipComponent(properties) {
  // Status of children rendering
  const [show, setShow] = useState(false);
  // Clone of actor to add onClick event
  const Actor = /*#__PURE__*/cloneElement(properties.actor, {
    onMouseEnter: () => setTimeout(() => setShow(true), 500),
    onMouseLeave: () => setShow(false)
  });
  const classNames = [
  // Base classname
  TooltipConstants.CLASSNAME].join(' ');
  return jsxs("div", Object.assign({
    className: classNames
  }, {
    children: [Actor, show && jsx("span", {
      children: properties.children
    })]
  }));
}

const getCookie = name => {
  if (typeof window !== 'undefined') {
    const value = document.cookie.split(';').find(cookie => cookie.includes(name));
    return value ? value.split('=')[1] : '';
  }
  return '';
};
const setCookie = (name, value, daysToExpire = 365) => {
  if (typeof window !== 'undefined') {
    const date = new Date();
    date.setDate(date.getDate() + daysToExpire);
    document.cookie = `${name}=${value};expires=${date.toUTCString};domain=${process.env['CT_DOMAIN'] || 'localhost'};path=/`;
  }
};

const DrawerConstants = {
  DRAWER_CONTAINER_CLASSNAME: 'DrawerContainer',
  DRAWER_CLASSNAME: 'DrawerComponent',
  OVERLAY_CLASSNAME: 'DrawerOverlay',
  OPEN: 'open' // The open class name to apply to the component.
};

/**
 * Drawer Component
 * @description A drawer component to be used in the navigation component
 * @param {DrawerProperties} properties
 * @returns A drawer component
 */
function DrawerComponent(properties) {
  /**
   * Class names definition of Navigation Component
   */
  const classNames = [DrawerConstants.DRAWER_CLASSNAME, ...(properties.open ? [DrawerConstants.OPEN] : ['']), ...(properties.className ? [properties.className] : ['']) // Classname when className is passed as a property
  ].join(' ');
  return jsxs("span", Object.assign({
    className: DrawerConstants.DRAWER_CONTAINER_CLASSNAME
  }, {
    children: [properties.open && jsx("div", {
      className: DrawerConstants.OVERLAY_CLASSNAME,
      onClick: properties.onClose
    }), jsx("div", Object.assign({
      className: classNames
    }, {
      children: properties.children
    }))]
  }));
}

/**
 * Bubble constants
 */
const BubbleConstants = {
  BASE_CLASSNAME: 'BubbleComponent'
};

/**
 * Bubble component
 * @description A component that renders a bubble with content inside and receives a variant property
 *              to define the style
 * @param {BubbleProperties} properties
 * @returns A bubble component
 */
function BubbleComponent(properties) {
  // Class names definition for the bubble component based on the properties provided
  const classNames = [
  // Default class
  BubbleConstants.BASE_CLASSNAME,
  // Custom class passed as property
  ...(properties.variant ? [properties.variant] : [])].join(' ');
  return jsx("span", Object.assign({
    className: classNames
  }, {
    children: properties.children
  }));
}

/**
 * List component
 * @description A component that renders items in a list
 * @param {ListProperties} properties
 * @returns A list component
 */
function ListComponent(properties) {
  const renderItem = (child, index = 1) => {
    return jsx("li", {
      children: child
    }, index);
  };
  // If one children, convert in array
  const children = Array.isArray(properties.children) ? properties.children : [properties.children];
  return jsx("ul", Object.assign({
    title: properties.title,
    ref: properties.optionsRef
  }, {
    children: children.map((child, index) => {
      return renderItem(child, index);
    })
  }));
}

/**
 * Constants for the menu component
 */
const MenuConstants = {
  BASE_CLASSNAME: 'MenuComponent',
  OPEN: 'open',
  SHOW_ARROW: 'showArrow',
  OPEN_LEFT_CLASSNAME: 'open-to-left',
  OPEN_RIGHT_CLASSNAME: 'open-to-right',
  HEIGHT_OFFSET: 48 // Height offset to calculate the position of the options
};

// Default properties for the component
const defaultProps = {
  showArrow: true // Show arrow by default
};
/**
 * Menu component
 * @component Menu
 * @description Component to render an anchor component with a list of options
 * @param {MenuProperties} properties
 * @returns A menu component
 */
function MenuComponent(properties) {
  const {
    width
  } = useWindowSize();
  // State hook to handle the open of the menu
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  /**
   * Ref to the options list of the select
   */
  const optionsRef = useRef(null);
  /**
   * State handler for the height of the options list
   */
  const [optionsWidth, setOptionsWidth] = useState(0);
  /**
   * State handler for the position of the select
   */
  const [position, setPosition] = useState(0);
  useEffect(() => {
    if (optionsRef.current && containerRef.current) {
      setPosition(containerRef.current.getBoundingClientRect().x);
      setOptionsWidth(optionsRef.current.offsetWidth);
    }
  }, [width, properties.open]);
  function onClickOutside() {
    setOpen(false);
    properties.onClickOutside && properties.onClickOutside();
  }
  // This side effect will listen for clicks outside the menu and close it
  useEffect(() => {
    const handleClickOutside = event => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [onClickOutside]);
  // Class names definition for the menu component based on the properties provided
  const classNames = [MenuConstants.BASE_CLASSNAME, ...(properties.open ? [MenuConstants.OPEN] : []), ...(properties.showArrow ? [MenuConstants.SHOW_ARROW] : []), ...(position + optionsWidth + MenuConstants.HEIGHT_OFFSET >= width ? [MenuConstants.OPEN_LEFT_CLASSNAME] : [MenuConstants.OPEN_RIGHT_CLASSNAME]) // Class assined when is open
  ].join(' ');
  return jsxs("div", Object.assign({
    ref: containerRef,
    className: classNames,
    onMouseEnter: () => properties.onMouseEnter ? properties.onMouseEnter() : setOpen(!open),
    onMouseLeave: properties.onMouseLeave
  }, {
    children: [properties.anchor, jsx("div", {
      children: properties.open && jsx(ListComponent, Object.assign({
        optionsRef: optionsRef
      }, {
        children: properties.children
      }))
    })]
  }));
}
// Assign default properties to the component
MenuComponent.defaultProps = defaultProps;

/**
 * Render all items of the menu passed as parameter.
 *
 * @params {NavigationMenuItem[]} menu
 * @returns An array of JSX elements
 */
function NavigationMenuComponent(properties) {
  /**
   * Render a single menu item as a link or as a simple text.
   * Works for both nested and non-nested menus.
   *
   * @param {NavigationMenuItem} menuItem
   */
  const renderMenuItem = menuItem => {
    // The item content is a combination of icon and label.
    // In this case we need to check if the icon is a string or a React element.
    const itemContent = jsxs("div", Object.assign({
      style: {
        position: 'relative'
      }
    }, {
      children: [(menuItem === null || menuItem === void 0 ? void 0 : menuItem.count) && jsx("div", {
        children: jsx(BubbleComponent, Object.assign({
          variant: "info"
        }, {
          children: menuItem.count
        }))
      }), menuItem.icon && ! /*#__PURE__*/isValidElement(menuItem.icon) ? jsx(IconComponent, {
        name: menuItem.icon
      }) : menuItem.icon, menuItem.label && jsx(TextComponent, {
        children: menuItem.label
      })]
    }));
    return menuItem.link ? jsx(LinkComponent, Object.assign({
      url: menuItem.link
    }, {
      children: itemContent
    })) : itemContent;
  };
  const renderNestedMenu = menuItem => {
    return menuItem.map(child => ! /*#__PURE__*/isValidElement(child) ? renderMenuItem(child) : child);
  };
  // Function to handle close menu event
  const handleClose = item => {
    item && properties.onOpenMenu && properties.onOpenMenu(prevState => Object.assign(Object.assign({}, prevState), {
      [item]: prevState[item] > 0 ? prevState[item] - 1 : 0
    }));
  };
  // Function to handle open menu event
  const handleOpen = item => {
    item && properties.onOpenMenu && properties.onOpenMenu(prevState => Object.assign(Object.assign({}, prevState), {
      [item]: prevState[item] ? prevState[item] + 1 : 1
    }));
  };
  // If there is any menu item open, close it.
  // This function is used when the user clicks outside the menu.
  const forceClose = item => {
    var _a;
    item && ((_a = properties.openMenu) === null || _a === void 0 ? void 0 : _a[item]) > 0 && properties.onOpenMenu && properties.onOpenMenu({});
  };
  /**
   * Render all items of the menu passed as parameter.
   *
   * @param {NavigationMenuItem[]} menu
   */
  const renderMenu = menu => {
    if (!menu) return [];
    // Check if the menu is defined and do the magic.
    return menu.map(menuItem => {
      var _a, _b, _c;
      // Check if the menu item has children and render them accordingly.
      if (menuItem.children) return jsx("li", {
        children: properties.isMobile ? jsx(AccordionComponent, Object.assign({
          title: menuItem === null || menuItem === void 0 ? void 0 : menuItem.label
        }, {
          children: renderNestedMenu(menuItem.children)
        })) : jsx(MenuComponent, Object.assign({
          open: properties.openMenu && ((_a = menuItem === null || menuItem === void 0 ? void 0 : menuItem.id) === null || _a === void 0 ? void 0 : _a.toString()) ? ((_b = properties.openMenu) === null || _b === void 0 ? void 0 : _b[(_c = menuItem === null || menuItem === void 0 ? void 0 : menuItem.id) === null || _c === void 0 ? void 0 : _c.toString()]) > 0 : false,
          onClickOutside: () => {
            var _a;
            return forceClose((_a = menuItem === null || menuItem === void 0 ? void 0 : menuItem.id) === null || _a === void 0 ? void 0 : _a.toString());
          },
          onMouseEnter: () => {
            var _a;
            return handleOpen((_a = menuItem.id) === null || _a === void 0 ? void 0 : _a.toString());
          },
          onMouseLeave: () => setTimeout(() => {
            var _a;
            return handleClose((_a = menuItem.id) === null || _a === void 0 ? void 0 : _a.toString());
          }, 150),
          anchor: renderMenuItem(menuItem),
          showArrow: menuItem.showArrow
        }, {
          children: renderNestedMenu(menuItem.children)
        }))
      }, menuItem.id);
      // No children, no problem.
      return jsx("li", {
        children: renderMenuItem(menuItem)
      }, menuItem.label);
    });
  };
  return jsx("ul", {
    children: renderMenu(properties.menu)
  });
}

const langCookie = process.env['CT_LANGUAGE_COOKIE'];
function MobileNavigationComponent(properties) {
  var _a, _b, _c, _d;
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openToolbox, setOpenToolbox] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  useEffect(() => {
    var _a;
    if (typeof window !== 'undefined') {
      setSelectedLanguage(((_a = getCookie(langCookie)) === null || _a === void 0 ? void 0 : _a.toLocaleUpperCase()) || '');
    }
  }, []);
  const buttonProps = {
    size: 'small',
    variant: 'flat'
  };
  // This state hook will handle the open of the menu. It will be an array of strings representing the id of every opened item
  const [openMenu, setOpenMenu] = useState({});
  // Right Controls of Phone Version
  const renderRightControls = () => {
    return properties.actuator ? jsx("div", {
      children: jsx(NavigationMenuComponent
      // Get only the first two elements of the actuator
      , {
        // Get only the first two elements of the actuator
        menu: properties.actuator.slice(0, 2),
        openMenu: openMenu,
        onOpenMenu: setOpenMenu
      })
    }) : jsxs("div", {
      children: [jsx(ButtonComponent, Object.assign({
        icon: IconNames.BAG,
        onClick: () => setOpenDrawer(!openDrawer)
      }, buttonProps)), jsx(ButtonComponent, Object.assign({
        icon: IconNames.USER,
        onClick: () => setOpenDrawer(!openDrawer)
      }, buttonProps))]
    });
  };
  // Left Controls of Phone Version
  const renderLeftControls = () => {
    return jsxs("div", {
      children: [jsx(ButtonComponent, Object.assign({
        icon: IconNames.MENU,
        onClick: () => setOpenDrawer(!openDrawer)
      }, buttonProps)), jsx(ButtonComponent, Object.assign({
        icon: IconNames.SEARCH,
        onClick: () => setOpenToolbox(!openToolbox)
      }, buttonProps))]
    });
  };
  const localizationMenu = (properties === null || properties === void 0 ? void 0 : properties.actuator) && ((_c = (_b = (_a = properties === null || properties === void 0 ? void 0 : properties.actuator) === null || _a === void 0 ? void 0 : _a.find(({
    id
  }) => id === 'location')) === null || _b === void 0 ? void 0 : _b.children) === null || _c === void 0 ? void 0 : _c[0]) || jsx("div", {});
  const handleClose = () => {
    setOpenDrawer(false);
  };
  return jsxs(Fragment, {
    children: [renderLeftControls(), jsx(SpaceComponent, {}), jsx(LogotypeComponent, {
      variant: LogotypeVariants.ICON
    }), jsx(SpaceComponent, {}), renderRightControls(), openToolbox && jsx("div", Object.assign({
      className: "ToolboxContainer"
    }, {
      children: (_d = properties.toolbox) === null || _d === void 0 ? void 0 : _d.map(element => jsx(element.type, Object.assign({}, element.props)))
    })), jsxs(DrawerComponent, Object.assign({
      open: openDrawer,
      onClose: handleClose
    }, {
      children: [jsx(LogotypeComponent, {}), jsxs("div", {
        children: [(properties === null || properties === void 0 ? void 0 : properties.menu) && jsx(properties.renderMenu, {
          menu: properties.menu,
          isMobile: true
        }), localizationMenu && jsxs("ul", {
          children: [jsx("li", Object.assign({
            style: {
              paddingBottom: 16
            }
          }, {
            children: jsx(AccordionComponent, Object.assign({
              title: selectedLanguage
            }, {
              children: localizationMenu
            }))
          }), 'location'), jsx("p", {})]
        })]
      })]
    }))]
  });
}

const MeasuresConstants = {
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200
};

const NavigationConstants = {
  CLASSNAME: 'NavigationComponent' // Default class name to apply to the component.
};

/**
 * Navigation component
 * @description Set of components to build the navigation header
 *
 * @property {JSX.Element[]} toolbox
 * @property {NavigationMenuItem[]} menu
 * @property {NavigationMenuItem} actuator;
 * @property {'default' | 'dark' | 'transparent' | 'tinted'} variant
 *
 * @returns A navigation component
 */
function NavigationComponent(properties) {
  const {
    width
  } = useWindowSize();
  const navRef = useRef(null);
  const [navWidth, setNavWidth] = useState(0);
  useEffect(() => {
    if (navRef.current) {
      setNavWidth(navRef.current.offsetWidth);
    }
  }, [width]);
  // Render Toolbox (usually for permanent tools like search)
  const renderElements = elements => {
    return elements && jsx("div", {
      children: elements.map(element => element)
    });
  };
  // This state hook will handle the open of the menu. It will be an array of strings representing the id of every opened item
  const [openMenu, setOpenMenu] = useState({});
  // Render Navigation for large screens
  const renderNavigationBar = () => {
    return jsxs(Fragment, {
      children: [jsxs("div", {
        children: [jsx(LogotypeComponent, {
          variant: 'text'
        }), renderElements(properties.toolbox)]
      }), jsxs("div", Object.assign({
        style: {
          marginLeft: 'auto'
        }
      }, {
        children: [jsx(NavigationMenuComponent, {
          menu: properties.menu,
          openMenu: openMenu,
          onOpenMenu: setOpenMenu
        }), properties.actuator && jsx(NavigationMenuComponent, {
          menu: properties.actuator,
          openMenu: openMenu,
          onOpenMenu: setOpenMenu
        })]
      }))]
    });
  };
  /**
   * Class names definition of Navigation Component
   */
  const classNames = [NavigationConstants.CLASSNAME, ...(properties.variant ? [properties.variant] : []) // Classname when variant is passed as a property
  ].join(' ');
  const isMobile = navWidth < MeasuresConstants.XL;
  // Render navigation bar
  return jsx("nav", Object.assign({
    ref: navRef,
    className: classNames
  }, {
    children: isMobile ? jsx(MobileNavigationComponent, Object.assign({
      renderMenu: NavigationMenuComponent
    }, properties)) : renderNavigationBar()
  }));
}

/**
 * Constants for the Part component
 */
const PartConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'PartComponent'
};

/**
 * Part component
 * @description A component that renders a simple part of the application
 * @param {PartProperties} properties
 * @returns A part component
 */
function PartComponent(properties) {
  return jsx("div", Object.assign({
    className: PartConstants.BASE_CLASSNAME
  }, {
    children: properties.children
  }));
}

/**
 * Constants for the modal component
 */
const ModalConstants = {
  BASE_CLASSNAME: 'ModalComponent'
};

/**
 * Modal component
 * @description Component to render a modal
 * @param {ModalProperties} properties
 * @returns A modal component
 */
function ModalComponent(properties) {
  useEffect(() => {
    if (properties.open) {
      // Add overflow to body
      document.body.style.overflow = 'hidden';
    }
    return () => {
      // Remove overflow to body
      document.body.style.overflow = 'auto';
    };
  }, [properties.open]);
  const classNames = [ModalConstants.BASE_CLASSNAME, ...(properties.position ? [`${ModalConstants.BASE_CLASSNAME}--${properties.position}`] : [])].join(' ');
  return properties.open ? jsx("div", Object.assign({
    className: classNames
  }, {
    children: jsxs("div", {
      children: [jsxs("div", {
        children: [properties.title, jsx(IconComponent, {
          name: IconNames.CLOSE,
          onClick: properties.onClose
        })]
      }), properties.children]
    })
  })) : null;
}

/**
 * Constants for the Row component
 */
const RowConstants = {
  BASE_CLASSNAME: 'RowComponent',
  WRAP_CLASSNAME: 'wrap' // Class name for the component when wrap is passed as a property
};

/**
 * Row component
 * @component
 * @description A component that renders items horizontally
 * @param properties
 * @returns A row component
 */
function RowComponent(properties) {
  /**
   * Class names definition for the row component based on the properties provided
   */
  const classNames = [
  // Default class
  RowConstants.BASE_CLASSNAME,
  // Class when an alignment is passed as a property
  ...(properties.align ? [properties.align] : []),
  // Class when wrap is passed as a property
  ...(properties.wrap ? [RowConstants.WRAP_CLASSNAME] : [])].join(' ');
  return jsx("div", Object.assign({
    className: classNames
  }, {
    children: properties.children
  }));
}

/**
 * Constants for the carrousel component
 */
const CarrouselConstants = {
  BASE_CLASSNAME: 'CarrouselComponent' // Default class name to apply to the component.
};

/**
 * Carrousel component
 * @description A component that renders items in a carrousel with horizontal scrolling
 * @param {CarrouselProperties} properties
 * @returns A carrousel component
 */
function CarrouselComponent(properties) {
  const contentRef = useRef(null);
  const [position, setPosition] = useState(0);
  const [width, setWidth] = useState(0);
  // If one children, convert in array
  const children = Array.isArray(properties.children) ? properties.children : [properties.children];
  useEffect(() => {
    var _a, _b;
    const scrollWidth = ((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) || 0;
    const clientWidth = ((_b = contentRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0;
    setWidth(scrollWidth - clientWidth);
  }, [contentRef.current]);
  return jsxs("div", Object.assign({
    className: CarrouselConstants.BASE_CLASSNAME
  }, {
    children: [jsx("button", {
      className: position > 0 ? 'active' : undefined,
      onClick: () => {
        var _a, _b;
        // Get first element of contentRef and get width
        const width = ((_b = (_a = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _a === void 0 ? void 0 : _a.firstElementChild) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0;
        if (contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) {
          // Scroll slow
          contentRef.current.scrollLeft -= width * 2 - 100;
        }
      }
    }), jsx("ul", Object.assign({
      ref: contentRef,
      onScroll: event => setPosition(event.currentTarget.scrollLeft)
    }, {
      children: children.map((child, index) => {
        return jsx("li", {
          children: child
        }, index);
      })
    })), jsx("button", {
      className: width > 0 && position < width - 20 ? 'active' : undefined,
      onClick: () => {
        var _a, _b;
        if (contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) {
          // Get width of first element
          const width = ((_b = (_a = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _a === void 0 ? void 0 : _a.firstElementChild) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0;
          contentRef.current.scrollLeft += width * 2 - 100;
        }
      }
    })]
  }));
}

const BackgroundConstants = {
  CLASS: 'BackgroundComponent'
};

/**
 * Background component
 * @description A component that renders a background image
 * @param {BackgroundProperties} properties
 * @returns A background component
 */
function BackgroundComponent(properties) {
  /**
   * Class names definition for the background component based on the properties provided
   */
  const classNames = [
  // Default class
  BackgroundConstants.CLASS].join(' ');
  return jsx("div", {
    className: classNames,
    style: {
      backgroundImage: `url(${properties === null || properties === void 0 ? void 0 : properties.image})`
    }
  });
}

const CheckboxConstants = {
  CLASSNAME: 'CheckboxComponent'
};

/**
 * Checkbox component that supports text and icon
 *
 * @param properties checkbox properties
 * @returns A checkbox component
 */
function CheckboxComponent(properties) {
  const [checked, setChecked] = useState(properties.checked || false);
  useEffect(() => {
    if (properties.onChange) {
      properties.onChange(properties.checked || false);
    }
  }, []);
  return jsxs(TextComponent, Object.assign({
    variant: "label"
  }, {
    children: [jsx("input", {
      type: "checkbox",
      className: CheckboxConstants.CLASSNAME,
      checked: properties.checked || checked,
      id: properties.id,
      onChange: event => {
        // Get the value of the input entered by the user (string by default) and convert it to a number
        let inputValue = event.target.checked;
        if (properties.onChange) {
          // Set value in parent component (for make request body)
          properties.onChange(inputValue);
        } else {
          // Set value in component state
          setChecked(inputValue);
        }
      }
    }), properties.image ? jsx("img", {
      src: properties.image,
      alt: properties.text
    }) : null, properties.text]
  }));
}

const RadioConstants = {
  CLASSNAME: 'RadioComponent'
};

/**
 * Radio component
 * @description A simple radio component
 * @param properties radio properties
 * @returns A radio component
 */
function RadioComponent(properties) {
  return jsxs(TextComponent, Object.assign({
    variant: "label"
  }, {
    children: [jsx("input", {
      type: "radio",
      className: RadioConstants.CLASSNAME,
      id: properties.id,
      name: properties.name,
      value: properties.value,
      onChange: properties.onChange
    }), properties.text]
  }));
}

const AvatarConstants = {
  BASE_CLASSNAME: 'AvatarComponent'
};

/**
 * Avatar component
 *
 * @description An component that displays a circular, square or rounded image
 * @param {AvatarProperties} properties
 * @returns An avatar component
 */
function AvatarComponent(properties) {
  // Class names definition for the avatar component based on the properties provided
  const classNames = [
  // Default class
  AvatarConstants.BASE_CLASSNAME,
  // Class depending on the variant passed as a property
  ...(properties.variant ? [properties.variant] : [])].join(' ');
  return jsx("img", {
    className: classNames,
    src: properties.image,
    alt: properties.alt,
    width: properties.size || 48,
    height: properties.size || 48
  });
}

var img$4 = "data:image/svg+xml,%3csvg width='43' height='30' viewBox='0 0 43 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='0.5' width='42.5' height='30' rx='5' fill='white'/%3e%3crect x='1' y='0.5' width='41.5' height='29' rx='4.5' stroke='black' stroke-opacity='0.06'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.5717 19.4097V15.7414H22.465C23.2408 15.7414 23.8956 15.4814 24.4295 14.9687L24.5576 14.8388C25.5327 13.7773 25.4686 12.1236 24.4295 11.1416C23.9099 10.6217 23.1981 10.34 22.465 10.3545H19.4258V19.4097H20.5717ZM20.5718 14.6291V11.4663H22.4939C22.9068 11.4663 23.2983 11.6252 23.5902 11.914C24.2095 12.5206 24.2237 13.5315 23.6258 14.1598C23.3339 14.4703 22.921 14.6436 22.4939 14.6291H20.5718ZM29.9029 13.6977C29.4118 13.2428 28.7428 13.0117 27.8958 13.0117C26.8068 13.0117 25.9882 13.4161 25.4473 14.2176L26.458 14.8603C26.8281 14.3115 27.3335 14.0371 27.974 14.0371C28.3798 14.0371 28.7712 14.1888 29.0773 14.4632C29.3762 14.7231 29.547 15.0986 29.547 15.4958V15.763C29.1057 15.5174 28.5506 15.3875 27.8673 15.3875C27.0701 15.3875 26.4295 15.5752 25.9526 15.9579C25.4758 16.3406 25.2338 16.8461 25.2338 17.4888C25.2195 18.0737 25.4687 18.6297 25.9099 19.0052C26.3584 19.4096 26.9278 19.6118 27.5968 19.6118C28.3869 19.6118 29.0132 19.258 29.4901 18.5503H29.5399V19.4096H30.636V15.5896C30.636 14.7881 30.394 14.1527 29.9029 13.6977ZM26.7927 18.2687C26.5578 18.0954 26.4154 17.8138 26.4154 17.5105C26.4154 17.1711 26.572 16.8895 26.8781 16.6656C27.1914 16.4418 27.5829 16.3262 28.0456 16.3262C28.6863 16.319 29.1846 16.4634 29.5405 16.7523C29.5405 17.2433 29.3483 17.6694 28.971 18.0304C28.6293 18.377 28.1666 18.572 27.6825 18.572C27.3622 18.5792 27.049 18.4709 26.7927 18.2687ZM33.0988 22.1321L36.928 13.2141H35.6825L33.9102 17.6622H33.8888L32.0738 13.2141H30.8282L33.3408 19.0126L31.9172 22.1321H33.0988Z' fill='%233C4043'/%3e%3cpath d='M16.6155 14.9473C16.6155 14.5935 16.5871 14.2397 16.5301 13.8931H11.6973V15.8933H14.466C14.3521 16.536 13.982 17.1137 13.4411 17.4747V18.7745H15.0924C16.0604 17.8719 16.6155 16.536 16.6155 14.9473Z' fill='%23003E6F'/%3e%3cpath d='M11.6977 20.0309C13.0785 20.0309 14.2458 19.5687 15.0928 18.7744L13.4415 17.4746C12.9789 17.7923 12.3881 17.9729 11.6977 17.9729C10.3596 17.9729 9.22791 17.0558 8.8222 15.8282H7.12109V17.1713C7.98944 18.926 9.76173 20.0309 11.6977 20.0309Z' fill='%2334A853'/%3e%3cpath d='M8.82259 15.8283C8.60903 15.1856 8.60903 14.4851 8.82259 13.8352V12.4993H7.12121C6.38798 13.9652 6.38798 15.6983 7.12121 17.1642L8.82259 15.8283Z' fill='%23FBBC04'/%3e%3cpath d='M11.6977 11.6905C12.4308 11.6761 13.1355 11.9577 13.6622 12.4704L15.1284 10.9829C14.196 10.1019 12.9718 9.61807 11.6977 9.63252C9.76173 9.63252 7.98944 10.7446 7.12109 12.4993L8.8222 13.8424C9.22791 12.6076 10.3596 11.6905 11.6977 11.6905Z' fill='%23EA4335'/%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg width='43' height='30' viewBox='0 0 43 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='0.5' width='42.5' height='30' rx='5' fill='white'/%3e%3crect x='1' y='0.5' width='41.5' height='29' rx='4.5' stroke='black' stroke-opacity='0.06'/%3e%3cpath d='M18 28.75L41.75 21.5625V25C41.75 27.0711 40.0711 28.75 38 28.75H18Z' fill='%23FD6020'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M37.2421 11.3885C38.5487 11.3885 39.2674 11.993 39.2674 13.1347C39.3327 14.0077 38.7447 14.7465 37.9607 14.8808L39.7247 17.3657H38.3527L36.8501 14.948H36.7195V17.3657H35.6088V11.3885H37.2421ZM36.7195 14.142H37.0461C37.7647 14.142 38.0914 13.8062 38.0914 13.2017C38.0914 12.6645 37.7647 12.3287 37.0461 12.3287H36.7195V14.142ZM31.7543 17.3657H34.8902V16.3583H32.8649V14.7465H34.8249V13.7391H32.8649V12.3959H34.8902V11.3885H31.7543V17.3657ZM28.4877 15.4181L26.9851 11.3885H25.8092L28.2264 17.5H28.8144L31.2316 11.3885H30.0557L28.4877 15.4181ZM15.2256 14.4107C15.2256 16.0897 16.5322 17.5 18.1655 17.5C18.6881 17.5 19.1455 17.3657 19.6028 17.1642V15.821C19.2761 16.224 18.8188 16.4926 18.2962 16.4926C17.2509 16.4926 16.4016 15.6867 16.4016 14.6122V14.4779C16.3362 13.4033 17.1855 12.4631 18.2308 12.3959C18.7535 12.3959 19.2761 12.6646 19.6028 13.0675V11.7244C19.2108 11.4557 18.6881 11.3886 18.2308 11.3886C16.5322 11.2542 15.2256 12.6646 15.2256 14.4107ZM13.2003 13.672C12.547 13.4033 12.351 13.269 12.351 12.9332C12.4164 12.5303 12.743 12.1945 13.135 12.2616C13.4617 12.2616 13.7883 12.4631 14.0496 12.7317L14.6376 11.9258C14.1803 11.5229 13.5923 11.2542 13.0043 11.2542C12.0897 11.1871 11.3057 11.9258 11.2404 12.8661V12.9332C11.2404 13.7391 11.5671 14.2092 12.6124 14.545C12.8737 14.6122 13.135 14.7465 13.3963 14.8808C13.5923 15.0151 13.723 15.2166 13.723 15.4852C13.723 15.9554 13.331 16.3583 12.939 16.3583H12.8737C12.351 16.3583 11.8937 16.0225 11.6977 15.5524L10.9791 16.2911C11.3711 17.0299 12.155 17.4328 12.939 17.4328C13.9843 17.5 14.8336 16.6941 14.8989 15.6196V15.4181C14.8336 14.6122 14.507 14.2092 13.2003 13.672ZM9.41113 17.3657H10.5218V11.3885H9.41113V17.3657ZM4.25 11.3885H5.88327H6.20993C7.77787 11.4557 9.01916 12.7989 8.95382 14.4107C8.95382 15.2838 8.56184 16.0897 7.90853 16.6941C7.32055 17.1642 6.60191 17.4328 5.88327 17.3657H4.25V11.3885ZM5.68727 16.3582C6.20991 16.4254 6.79789 16.2239 7.18988 15.8881C7.58186 15.4852 7.77785 14.9479 7.77785 14.3435C7.77785 13.8062 7.58186 13.2689 7.18988 12.866C6.79789 12.5302 6.20991 12.3287 5.68727 12.3959H5.36061V16.3582H5.68727Z' fill='%23021120'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M22.9349 11.25C21.3016 11.25 19.9297 12.5932 19.9297 14.3393C19.9297 16.0183 21.2363 17.4286 22.9349 17.4958C24.6335 17.5629 25.9401 16.1526 26.0055 14.4065C25.9401 12.6603 24.6335 11.25 22.9349 11.25V11.25Z' fill='%23FD6020'/%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg width='43' height='30' viewBox='0 0 43 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='42.5' height='30' rx='5' fill='white'/%3e%3crect x='0.5' y='0.5' width='41.5' height='29' rx='4.5' stroke='black' stroke-opacity='0.06'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.4378 19.8229H10.8631L8.93244 12.2406C8.84081 11.8918 8.64623 11.5835 8.36002 11.4381C7.64573 11.0729 6.85864 10.7823 6 10.6357V10.3438H10.1476C10.72 10.3438 11.1494 10.7823 11.2209 11.2915L12.2227 16.7609L14.7961 10.3438H17.2992L13.4378 19.8229ZM18.7303 19.8229H16.2987L18.301 10.3438H20.7325L18.7303 19.8229ZM23.8784 12.9699C23.9499 12.4593 24.3793 12.1674 24.8801 12.1674C25.6672 12.0941 26.5246 12.2407 27.2401 12.6047L27.6695 10.5638C26.9539 10.2718 26.1668 10.1252 25.4526 10.1252C23.0925 10.1252 21.3753 11.4383 21.3753 13.2605C21.3753 14.6468 22.5917 15.3748 23.4503 15.8133C24.3793 16.2505 24.737 16.5424 24.6655 16.9797C24.6655 17.6356 23.9499 17.9275 23.2357 17.9275C22.377 17.9275 21.5184 17.7088 20.7325 17.3436L20.3032 19.3858C21.1619 19.7498 22.0908 19.8964 22.9494 19.8964C25.5957 19.9684 27.2401 18.6566 27.2401 16.6878C27.2401 14.2083 23.8784 14.063 23.8784 12.9699ZM35.75 19.8229L33.8193 10.3438H31.7455C31.3162 10.3438 30.8869 10.6357 30.7438 11.0729L27.1686 19.8229H29.6717L30.1713 18.4379H33.2469L33.5331 19.8229H35.75ZM32.1033 12.8965L32.8176 16.4691H30.8153L32.1033 12.8965Z' fill='%23003E6F'/%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3csvg width='43' height='30' viewBox='0 0 43 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='0.5' width='42.5' height='30' rx='5' fill='white'/%3e%3crect x='1' y='0.5' width='41.5' height='29' rx='4.5' stroke='black' stroke-opacity='0.06'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.7678 23.0602L19.0437 21.2488L18.4291 21.234H15.4941L17.5338 7.867C17.5402 7.82652 17.5607 7.78895 17.5907 7.76222C17.6208 7.73549 17.6593 7.72083 17.6995 7.72083H22.6482C24.2912 7.72083 25.425 8.07412 26.0168 8.77155C26.2944 9.09872 26.4711 9.44072 26.5567 9.81692C26.6464 10.2118 26.6479 10.6834 26.5604 11.2588L26.554 11.3007V11.6694L26.8316 11.8319C27.0652 11.9601 27.251 12.1067 27.3934 12.2746C27.6308 12.5544 27.7843 12.91 27.8492 13.3314C27.9163 13.7649 27.8941 14.2808 27.7843 14.8649C27.6577 15.5367 27.453 16.1219 27.1765 16.6006C26.9223 17.0417 26.5984 17.4077 26.2137 17.6911C25.8465 17.9606 25.4102 18.1651 24.9169 18.296C24.4388 18.4246 23.8938 18.4895 23.2961 18.4895H22.9109C22.6356 18.4895 22.3681 18.592 22.1582 18.7758C21.9476 18.9633 21.8084 19.2197 21.7656 19.4999L21.7365 19.6631L21.249 22.8559L21.227 22.973C21.2211 23.0101 21.211 23.0286 21.1962 23.0411C21.1831 23.0526 21.1642 23.0602 21.1457 23.0602H18.7678' fill='%23003E6F'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M27.0941 11.3433C27.0795 11.4409 27.0625 11.5406 27.0436 11.6431C26.391 15.1064 24.1582 16.3028 21.3066 16.3028H19.8546C19.5059 16.3028 19.2119 16.5645 19.1577 16.9201L18.2038 23.1741C18.1685 23.4077 18.3426 23.618 18.5704 23.618H21.1457C21.4505 23.618 21.7096 23.3891 21.7576 23.0782L21.7829 22.943L22.2677 19.7628L22.2989 19.5883C22.3464 19.2764 22.606 19.0473 22.9109 19.0473H23.296C25.791 19.0473 27.7442 18.0004 28.3151 14.9706C28.5534 13.705 28.4301 12.6481 27.799 11.9049C27.6081 11.6808 27.3712 11.4948 27.0941 11.3433' fill='%23298FC2'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M26.412 11.062C26.3123 11.0319 26.2094 11.0047 26.1039 10.9801C25.9978 10.9561 25.8892 10.9349 25.7773 10.9163C25.3858 10.8509 24.9568 10.8199 24.4974 10.8199H20.6186C20.523 10.8199 20.4322 10.8422 20.3511 10.8825C20.1721 10.9714 20.0393 11.1465 20.0071 11.3607L19.1818 16.7627L19.1582 16.9201C19.2124 16.5646 19.5064 16.3029 19.8551 16.3029H21.3071C24.1587 16.3029 26.3915 15.1059 27.0441 11.6432C27.0636 11.5407 27.08 11.4409 27.0946 11.3433C26.9295 11.2528 26.7507 11.1753 26.5582 11.1093C26.5106 11.093 26.4615 11.0773 26.412 11.062' fill='%23003E6F'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.0068 11.3608C20.039 11.1465 20.1719 10.9714 20.3508 10.8831C20.4326 10.8427 20.5227 10.8204 20.6183 10.8204H24.4971C24.9566 10.8204 25.3856 10.8515 25.777 10.9169C25.8889 10.9354 25.9975 10.9568 26.1036 10.9808C26.2091 11.0052 26.312 11.0325 26.4117 11.0625C26.4613 11.0777 26.5103 11.0936 26.5583 11.1094C26.7509 11.1753 26.9299 11.2534 27.0949 11.3434C27.2891 10.0635 27.0933 9.19213 26.4239 8.40306C25.6857 7.53425 24.3536 7.16248 22.649 7.16248H17.7001C17.3519 7.16248 17.0549 7.42412 17.0011 7.78032L14.9398 21.2848C14.8992 21.552 15.0986 21.793 15.3592 21.793H18.4145L20.0068 11.3608' fill='%23003E6F'/%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg width='43' height='30' viewBox='0 0 43 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='42.5' height='30' rx='5' fill='white'/%3e%3crect x='0.5' y='0.5' width='41.5' height='29' rx='4.5' stroke='black' stroke-opacity='0.06'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M26.9716 23.0375C31.6527 23.0375 35.4474 19.2879 35.4474 14.6625C35.4474 10.0371 31.6527 6.28748 26.9716 6.28748C24.8736 6.28748 22.9537 7.04061 21.4737 8.28818C19.9936 7.04065 18.0738 6.28754 15.9759 6.28754C11.2948 6.28754 7.5 10.0372 7.5 14.6625C7.5 19.2879 11.2948 23.0375 15.9759 23.0375C18.0738 23.0375 19.9937 22.2844 21.4738 21.0368C22.9538 22.2844 24.8737 23.0375 26.9716 23.0375Z' fill='%23ED0006'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.4736 21.0368C23.2961 19.5006 24.4517 17.2149 24.4517 14.6624C24.4517 12.11 23.2961 9.8242 21.4736 8.28807C22.9537 7.04053 24.8736 6.28741 26.9715 6.28741C31.6526 6.28741 35.4473 10.037 35.4473 14.6624C35.4473 19.2878 31.6526 23.0374 26.9715 23.0374C24.8736 23.0374 22.9537 22.2843 21.4736 21.0368Z' fill='%23F9A000'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.4741 21.0367C23.2965 19.5006 24.452 17.2148 24.452 14.6624C24.452 12.11 23.2965 9.82425 21.4741 8.28812C19.6517 9.82425 18.4961 12.11 18.4961 14.6624C18.4961 17.2148 19.6517 19.5006 21.4741 21.0367Z' fill='%23FF5E00'/%3e%3c/svg%3e";

const PaymentsConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'PaymentsComponent',
  // Methods to use for payment
  METHODS: {
    GOOGLE: 'Google',
    PAYPAL: 'Paypal',
    VISA: 'Visa',
    MASTER_CARD: 'Mastercard',
    DISCOVER: 'Discover'
  }
};

/**
 * Payments component
 * @description A component that renders a payments items list passed as properties
 * @param {PaymentsProperties} properties
 * @returns A payments component
 */
function PaymentComponent(properties) {
  /**
   * A function that returns the icon of the payment method
   * @param method
   * @returns The icon of the payment method passed as parameter
   */
  const getIcon = method => {
    // Inmediate return of the icon based on the method
    switch (method) {
      case PaymentsConstants.METHODS.DISCOVER:
        return img$3;
      case PaymentsConstants.METHODS.GOOGLE:
        return img$4;
      case PaymentsConstants.METHODS.MASTER_CARD:
        return img;
      case PaymentsConstants.METHODS.PAYPAL:
        return img$1;
      case PaymentsConstants.METHODS.VISA:
        return img$2;
      default:
        return undefined;
    }
  };
  return jsx("ul", Object.assign({
    className: PaymentsConstants.BASE_CLASSNAME
  }, {
    children:
    // Map the payment methods passed as properties
    properties.options.map(option => jsx("li", {
      children: jsx("img", {
        src: getIcon(option),
        alt: option
      })
    }, option))
  }));
}

/**
 * Blockquote component
 * @description A component that displays a blockquote
 * @param {BlockquoteProperties} properties
 * @returns A blockquote component
 */
function BlockquoteComponent(properties) {
  return jsx("blockquote", Object.assign({
    className: properties.className
  }, {
    children: properties.children
  }));
}

const HeroConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'HeroComponent'
};

/**
 * Hero component
 * @description A component that displays a hero screen
 * @param {HeroProperties} properties
 * @returns A hero component
 */
function HeroComponent(properties) {
  const classes = [HeroConstants.BASE_CLASSNAME, ...(properties.complement ? ['haveComplement'] : [])].join(' ');
  return jsx("div", Object.assign({
    className: classes,
    style: {
      backgroundImage: `url(${properties.backgroundImage})`
    }
  }, {
    children: jsxs("div", Object.assign({
      style: {
        background: `${properties.backgroundGradientColor}`
      }
    }, {
      children: [jsxs("div", Object.assign({
        className: "message"
      }, {
        children: [jsxs("div", Object.assign({
          className: "texts"
        }, {
          children: [properties.subTitle && jsx("h2", {
            children: properties.subTitle
          }), properties.title && jsx(TextComponent, Object.assign({
            variant: "h1"
          }, {
            children: properties.title
          })), properties.text && jsx(TextComponent, {
            children: properties.text
          }), properties.buttonText && jsx("button", Object.assign({
            onClick: () => {
              var _a;
              return (_a = properties.onClickButonHandler) === null || _a === void 0 ? void 0 : _a.call(properties);
            }
          }, {
            children: properties.buttonText
          }))]
        })), properties.lateral && jsx("div", Object.assign({
          className: "lateral"
        }, {
          children: properties.lateral
        })), properties.complement && jsx("div", Object.assign({
          className: "complement"
        }, {
          children: properties.complement
        }))]
      })), properties.buttons && jsx("div", Object.assign({
        className: "buttons"
      }, {
        children: properties.buttons
      }))]
    }))
  }));
}

// Direction
var GalleryDirections;
(function (GalleryDirections) {
  GalleryDirections["LEFT"] = "left";
  GalleryDirections["RIGHT"] = "right";
})(GalleryDirections || (GalleryDirections = {}));
var GallerySizes;
(function (GallerySizes) {
  GallerySizes["CONTAIN"] = "contain";
  GallerySizes["COVER"] = "cover";
  GallerySizes["NONE"] = "none";
  GallerySizes["IMAGE"] = "image";
})(GallerySizes || (GallerySizes = {}));

const GalleryConstants = {
  CLASSNAME: 'GalleryComponent',
  ACTIVE: 'active',
  LIMIT: 4,
  ICONS: {
    // Icons of Gallery
    MORE: 'las la-plus',
    LEFT: 'las la-angle-left',
    RIGHT: 'las la-angle-right' // Right angle
  },

  DIRECTION: {
    LEFT: 'left',
    RIGHT: 'right' // Right direction
  }
};

/**
 * Thumbnails Component of Gallery
 * @description A component that renders a list of thumbnails selectables
 * @param properties: ThumbnailProperties
 * @returns JSX.Element
 */
function ThumbnailsComponent(properties) {
  var _a, _b;
  // Count images to show in button of more images
  const countImages = ((_a = properties === null || properties === void 0 ? void 0 : properties.images) === null || _a === void 0 ? void 0 : _a.length) - 1;
  // Render left or right count of overflowed images
  function renderMore(count) {
    return count > 0 && jsxs("b", {
      children: [jsx("i", {
        className: GalleryConstants.ICONS.MORE
      }), count]
    });
  }
  return jsx("ul", Object.assign({
    style: {
      width: countImages + 1 < properties.limit ? 'fit-content' : 'auto'
    }
  }, {
    children: (_b = properties === null || properties === void 0 ? void 0 : properties.images) === null || _b === void 0 ? void 0 : _b.map((imageUrl, index) => {
      // Count images overflow to the right
      const rightCount = (properties === null || properties === void 0 ? void 0 : properties.selected) && (properties === null || properties === void 0 ? void 0 : properties.selected) > properties.limit ? countImages - (properties === null || properties === void 0 ? void 0 : properties.selected) : countImages - properties.limit;
      // Count images overflow to the left
      const leftCount = (properties === null || properties === void 0 ? void 0 : properties.selected) && properties.selected > properties.limit ? properties.selected - properties.limit : 0;
      if (properties.selected) {
        if (properties.selected > properties.limit && index < leftCount || index + rightCount > countImages) return null;
      } else {
        if (!properties.selected && index > properties.limit) return null;
      }
      // Active class for selected image
      const thumbnail = {
        className: index === properties.selected ? GalleryConstants.ACTIVE : undefined,
        style: {
          backgroundImage: `url(${imageUrl})`
        },
        moreLeft: index === leftCount,
        moreRight: index === properties.limit + leftCount
      };
      return jsxs("li", Object.assign({
        className: thumbnail.className,
        onClick: () => properties.onSelect(index),
        style: {
          width: (properties === null || properties === void 0 ? void 0 : properties.previewWidth) || 'auto'
        }
      }, {
        children: [
        // Render more images if toggle is false
        thumbnail.moreLeft && renderMore(leftCount), jsx("span", {
          className: properties.objectFit,
          style: thumbnail.style
        }),
        // Render more images if toggle is false
        thumbnail.moreRight && renderMore(rightCount)]
      }), index);
    })
  }));
}

/**
 * Visor Component of Gallery
 * @description A component that renders a visor of selected image
 * @param properties: VisorProperties
 * @returns JSX.Element
 */
function VisorComponent(properties) {
  var _a, _b;
  const imageSelected = (_a = properties === null || properties === void 0 ? void 0 : properties.images) === null || _a === void 0 ? void 0 : _a[properties.selected];
  const renderImage = () => {
    return jsx("img", {
      className: [properties.direction, (properties === null || properties === void 0 ? void 0 : properties.objectFit) || GallerySizes.COVER].join(' '),
      style: {
        height: (properties === null || properties === void 0 ? void 0 : properties.objectFit) !== GallerySizes.IMAGE ? properties === null || properties === void 0 ? void 0 : properties.height : undefined
      },
      src: typeof imageSelected === 'string' ? imageSelected : imageSelected === null || imageSelected === void 0 ? void 0 : imageSelected.source,
      alt: typeof imageSelected === 'string' ? undefined : imageSelected === null || imageSelected === void 0 ? void 0 : imageSelected.name
    });
  };
  return jsxs("div", {
    children: [properties.selected > 0 && jsx("i", {
      className: GalleryConstants.ICONS.LEFT,
      onClick: () => properties.onSelect(properties.selected - 1)
    }), renderImage(), properties.selected < ((_b = properties === null || properties === void 0 ? void 0 : properties.images) === null || _b === void 0 ? void 0 : _b.length) - 1 && jsx("i", {
      className: GalleryConstants.ICONS.RIGHT,
      onClick: () => properties.onSelect(properties.selected + 1)
    })]
  }, properties.selected);
}

/**
 * Gallery component
 *
 * @component Gallery
 *
 * @description A component that renders a gallery of images
 *
 * @typedef {GalleryProperties} properties
 * @property {(number | string)} [width] - The width of the gallery
 * @property {(number | string)} [height] - The height of the gallery
 * @property {('cover' | 'contain' | 'fill' | 'none' | 'scale-down')} [objectFit] - Mode of how the image should be resized to fit the container
 * @property {GalleryImages[]} images - The images to be displayed
 * @property {number} limit - The number of images to show visible in preview list
 * @property {function} [onSelect] - A callback function to allow a custom behaviour when an image is selected
 * @property {(number | string)} previewWidth - Define a width for each preview image if the amount of previews do not exceed the limit.
 *
 * @returns An image with a preview list at the bottom
 */
function GalleryComponent(properties) {
  // Active index for set the selected image
  const [selected, setSelected] = useState(0);
  // Toggle for show more images
  const [toggle, setToggle] = useState(false);
  // Direction for change image
  const [direction, setDirection] = useState(GalleryDirections.LEFT);
  /**
   * Select image to show in gallery
   * @param index
   * @returns void
   */
  const onSelect = index => {
    var _a, _b;
    // The index of image is the button of show more images
    if (index === (properties.limit || GalleryConstants.LIMIT) && !toggle) {
      // Injected callback
      (_a = properties === null || properties === void 0 ? void 0 : properties.onToggle) === null || _a === void 0 ? void 0 : _a.call(properties);
      setToggle(true);
    }
    // Injected callback
    (_b = properties === null || properties === void 0 ? void 0 : properties.onSelect) === null || _b === void 0 ? void 0 : _b.call(properties);
    // Set direction
    setDirection(index > selected ? GalleryDirections.RIGHT : GalleryDirections.LEFT);
    // Set selected active index
    setSelected(index);
  };
  return jsxs("div", Object.assign({
    className: GalleryConstants.CLASSNAME,
    style: {
      width: properties.width || undefined
    }
  }, {
    children: [jsx(VisorComponent, {
      direction: direction,
      images: properties === null || properties === void 0 ? void 0 : properties.images,
      onSelect: onSelect,
      height: properties === null || properties === void 0 ? void 0 : properties.height,
      selected: selected,
      objectFit: (properties === null || properties === void 0 ? void 0 : properties.objectFit) || GallerySizes.COVER
    }), jsx(ThumbnailsComponent, {
      images: properties === null || properties === void 0 ? void 0 : properties.images,
      limit: (properties === null || properties === void 0 ? void 0 : properties.limit) || GalleryConstants.LIMIT,
      onSelect: onSelect,
      onToggle: setToggle,
      selected: selected,
      toggle: toggle,
      objectFit: (properties === null || properties === void 0 ? void 0 : properties.objectFit) || GallerySizes.COVER,
      previewWidth: properties === null || properties === void 0 ? void 0 : properties.previewWidth
    })]
  }));
}

function formatPrice(total) {
  let str = total.toLocaleString('en', {
    useGrouping: false,
    minimumFractionDigits: 2,
    style: 'currency',
    currency: 'USD'
  });
  str = str.replace(/\$/i, '');
  str = str.replace(/\./i, ',');
  str = `${str} $`;
  return str;
}

const RangeConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'RangeComponent',
  // Input text type
  TEXT: 'text',
  // Input range type
  RANGE: 'range'
};

/**
 * Range component
 * @component
 * @description A component that renders a range slider with two values min and max
 * @param {RangeProperties} properties
 * @returns A range component
 */
function RangeComponent(properties) {
  // Define the default and selected min value by the user
  const [selectedMinRange, setSelectedMinRange] = useState(properties.selectedMinRange);
  // Define the default and selected max value by the user
  const [selectedMaxRange, setSelectedMaxRange] = useState(properties.selectedMaxRange);
  // Callbacks for update the state of min and max selected values by the user
  const onChangeSelectedMinRange = event => {
    const value = Number(event.target.value);
    if (value <= selectedMaxRange) {
      setSelectedMinRange(value);
    }
  };
  const onChangeSelectedMaxRange = event => {
    const value = Number(event.target.value);
    if (value >= selectedMinRange) {
      setSelectedMaxRange(value);
    }
  };
  // Define min and max values for the range slider
  const minProgress = selectedMinRange / properties.toRange * 100 + '%';
  const maxProgress = Math.abs(selectedMaxRange / properties.toRange * 100 - 100) + '%';
  useEffect(() => {
    var _a;
    // Sending the selected values to injected callback
    (_a = properties.onChangeSelectedValues) === null || _a === void 0 ? void 0 : _a.call(properties, {
      selectedMinRange,
      selectedMaxRange
    });
  }, [selectedMinRange, selectedMaxRange]);
  return jsxs("div", Object.assign({
    className: RangeConstants.BASE_CLASSNAME
  }, {
    children: [jsxs("div", {
      children: [jsx("div", {
        style: {
          left: minProgress,
          right: maxProgress
        }
      }), jsx("input", {
        type: RangeConstants.RANGE,
        step: properties.step,
        min: properties.fromRange,
        max: properties.toRange,
        value: selectedMinRange,
        onChange: onChangeSelectedMinRange
      }), jsx("input", {
        type: RangeConstants.RANGE,
        step: properties.step,
        min: properties.fromRange,
        max: properties.toRange,
        value: selectedMaxRange,
        onChange: onChangeSelectedMaxRange
      })]
    }), jsxs("div", {
      children: [jsx("input", {
        type: RangeConstants.TEXT,
        value: formatPrice(selectedMinRange),
        disabled: true
      }), jsx("input", {
        type: RangeConstants.TEXT,
        value: formatPrice(selectedMaxRange),
        disabled: true
      })]
    })]
  }));
}

/**
 * Summary component
 * @description A component that renders a summary with a title, a description and a button to show more content
 * @param {SummaryProperties} properties
 * @returns A summary component
 */
function SummaryComponent(properties) {
  return jsxs("div", Object.assign({
    className: PartConstants.BASE_CLASSNAME
  }, {
    children: [jsx(TextComponent, Object.assign({
      variant: 'h2'
    }, {
      children: properties.title
    })), jsx(TextComponent, Object.assign({
      variant: 'p'
    }, {
      children: properties.text
    })), jsx(ButtonComponent, Object.assign({
      variant: 'secondary',
      onClick: properties.onClick
    }, {
      children: properties.moreText
    }))]
  }));
}

/**
 * Constants for the details component
 */
const DetailsConstants = {
  BASE_CLASSNAME: 'DetailsComponent',
  BACKGROUND_IMAGE_GRADIENT: 'linear-gradient(to bottom, rgba(2, 17, 32, 0), rgba(2, 17, 32, 0.7))' // Background image gradient
};

/**
 * Constants for Category component
 */
const CategoryConstants = {
  BASE_CLASSNAME: 'CategoryComponent' // Default class name to be added to the component
};

/**
 * Categorycomponent
 * @description A component that renders a category
 * @param properties
 * @returns A categorycomponent
 */
function CategoryComponent(properties) {
  return jsxs("div", Object.assign({
    className: CategoryConstants.BASE_CLASSNAME
  }, {
    children: [jsxs("div", {
      children: [jsx("i", {
        style: {
          backgroundColor: properties.color
        }
      }), jsx(TextComponent, Object.assign({
        variant: "strong"
      }, {
        children: properties.text
      }))]
    }), properties.flag ? jsx("img", {
      src: properties.flag
    }) : null]
  }));
}

/**
 * Price component
 *
 * @param properties
 * @returns A price component
 */
function PriceComponent(properties) {
  return jsxs("div", Object.assign({
    className: "PriceComponent"
  }, {
    children: [jsx(TextComponent, Object.assign({
      variant: "strong"
    }, {
      children: properties.value
    })), jsx(TooltipComponent, Object.assign({
      actor: jsxs("div", {
        children: [properties.donut || jsx("img", {
          src: "https://pbs.twimg.com/profile_images/1229438253889134592/M4tbDUrt_400x400.png"
        }), jsx(TextComponent, {
          children: properties.counter
        })]
      })
    }, {
      children: properties.children
    }))]
  }));
}

/**
 * Details component
 * @description A component that renders the details of a product
 * @param {DetailsProperties} properties
 * @returns A details component
 */
function DetailsComponent(properties) {
  /**
   * Define background image with gradient
   */
  const background = `${DetailsConstants.BACKGROUND_IMAGE_GRADIENT}, url(${properties.background})`;
  return jsxs("div", Object.assign({
    className: DetailsConstants.BASE_CLASSNAME,
    onClick: properties.onClick,
    style: {
      backgroundImage: background
    }
  }, {
    children: [jsx(CategoryComponent, {
      flag: properties.flag,
      color: properties.color,
      text: properties.title
    }), jsx(TextComponent, Object.assign({
      variant: "p"
    }, {
      children: properties.description
    })), jsx(PriceComponent, Object.assign({
      donut: properties.donut,
      value: properties.price,
      counter: properties.counter
    }, {
      children: properties.goals
    }))]
  }));
}

const SwitchComponentConstants = {
  CLASSNAME: 'SwitchComponent',
  INPUT: 'checkbox',
  LABEL: 'label'
};

/**
 * SwitchComponent
 * @description A component that renders a checkbox input as a switch.
 * @param {SwitchComponentProperties} properties
 * @returns A switch component
 */
function SwitchComponent(properties) {
  /**
   * State hook to handle input id in order to set relation between
   * label and input. The id is randomly created if is not received
   * from properties.
   */
  const [inputId] = useState(properties.id || Math.random().toString(36).substring(7));
  return jsx("div", Object.assign({
    className: SwitchComponentConstants.CLASSNAME
  }, {
    children: jsxs(TextComponent, Object.assign({
      variant: 'label',
      for: inputId
    }, {
      children: [jsx("b", {
        children: properties.text
      }), jsx("input", {
        id: inputId,
        name: inputId,
        type: SwitchComponentConstants.INPUT,
        checked: properties.checked,
        onChange: properties.onCheck
      })]
    }))
  }));
}

const LoremConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'LoremComponent',
  // Default text
  CHARACTER: '█'
};

/**
 * Lorem component
 * @description A component that renders a lorem tag based on the variant property
 * @param {LoremProperties} properties
 * @returns A lorem component
 */
function LoremComponent(properties) {
  /**
   * Definition of parent tag based on the variant property
   */
  const Parent = properties.variant === 'error' ? 'label' : properties.variant || 'p';
  /**
   * Class names definition for the lorem component based on the properties provided
   */
  const classNames = [
  // Default class
  LoremConstants.BASE_CLASSNAME, ...(properties.variant ? [properties.variant] : [])].join(' ');
  // Create array with empty N elements
  const array = Array.from(Array(properties.words).keys());
  const randomRepetitions = [true, false, false, false, true, false, true, true];
  const textRandom = array.map(() => {
    // Get random randomRepetitions
    const random = randomRepetitions[Math.floor(Math.random() * randomRepetitions.length)];
    // Text long or small
    const text = random ? 6 : 3;
    // Random number between 1 and 6
    const randomNumber = Math.floor(Math.random() * text) + 1;
    return LoremConstants.CHARACTER.repeat(randomNumber);
  }).join(' ');
  return jsx(Parent, Object.assign({
    className: classNames,
    style: {
      width: properties.width,
      padding: properties.padding
    }
  }, {
    children: textRandom
  }));
}

function MainLayout(properties) {
  return jsx("main", Object.assign({
    className: "MainLayout"
  }, {
    children: properties.children
  }));
}

function AsideLayout(properties) {
  return jsx("aside", Object.assign({
    className: "AsideLayout"
  }, {
    children: properties.children
  }));
}

function FooterLayout(properties) {
  return jsx("footer", Object.assign({
    className: "FooterLayout"
  }, {
    children: properties.children
  }));
}

function SectionLayout(properties) {
  return jsx("section", Object.assign({
    className: "SectionLayout"
  }, {
    children: properties.children
  }));
}

function NavLayout(properties) {
  return jsx("nav", Object.assign({
    className: "NavLayout"
  }, {
    children: properties.children
  }));
}

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails = fails$m;
var whitespaces = whitespaces$3;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $ = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

const countryKey = process.env['CT_COUNTRY_COOKIE'];
/**
 *
 * @param properties
 * @returns
 */
function CountrySelector(properties) {
  // The state hook for the selected country
  const [selectedCountry, setSelectedCountry] = useState({
    label: properties.currentCountry || ''
  });
  /**
   * Get the flag emoji from the country code
   *
   * @param countryCode The country code
   * @returns The flag emoji
   */
  function getFlagEmoji(countryCode) {
    if (!countryCode) return '';
    const codePoints = countryCode.trim().toUpperCase().split('').map(char => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  }
  /**
   * Helper function to find a country by its code
   *
   * @param country The country code
   * @returns
   */
  const findCountry = country => (properties === null || properties === void 0 ? void 0 : properties.countries) && properties.countries.find(ctry => ctry.value.toLowerCase() === country.toLowerCase());
  /**
   * This function is called when the user selects a country from the dropdown
   *
   * @param country The value of the selected country (normally a string representing the country code)
   */
  const handleCountryChange = country => {
    setCookie(countryKey, country);
    properties.onCountryChange && properties.onCountryChange(country);
    const userCountry = findCountry(country);
    if (!!userCountry) {
      setSelectedCountry({
        label: attachFlag(userCountry)
      });
    }
  };
  /**
   *  This function is just attach the flag emoji in front of the country label
   *
   * @param country The country object
   * @returns The country label with the flag emoji
   */
  const attachFlag = country => `${getFlagEmoji(country === null || country === void 0 ? void 0 : country.value)}  ${country === null || country === void 0 ? void 0 : country.label}`;
  useEffect(() => {
    const hasLanguageCookie = !!getCookie(countryKey);
    if (!hasLanguageCookie) {
      const [, countryCode] = navigator.language.split('-');
      handleCountryChange(countryCode);
    } else {
      handleCountryChange(getCookie(countryKey));
    }
  }, []);
  return jsx(AutocompleteComponent, {
    options: !!properties.countries ? properties.countries.map(country => ({
      label: attachFlag(country),
      value: country === null || country === void 0 ? void 0 : country.value
    })) : [],
    value: selectedCountry || getCookie(countryKey),
    onChange: handleCountryChange
  });
}

const CurrencySelectorConstants = {
  DEFAULT_LOCALE: 'en-US',
  DEFAULT_CURRENCY: 'USD'
};

const currencyKey = process.env['CT_CURRENCY_COOKIE'];
function CurrencySelector(properties) {
  const [selectedCurrency, setSelectedCurrency] = useState(properties.currentCurrency || '');
  const getCurrencySymbol = useCallback(currency => {
    try {
      const currencySymbol = new Intl.NumberFormat(CurrencySelectorConstants.DEFAULT_LOCALE, {
        style: 'currency',
        currency
      }).formatToParts()[0].value;
      return currencySymbol;
    } catch (error) {
      return '$';
    }
  }, []);
  /**
   *
   * @param currency
   */
  const handleCurrencyChange = currency => {
    setCookie(currencyKey, currency);
    setSelectedCurrency(currency);
    properties.onCurrencyChange && properties.onCurrencyChange(currency);
  };
  useEffect(() => {
    const hasCurrencyCookie = !!getCookie(currencyKey);
    if (!hasCurrencyCookie) {
      handleCurrencyChange(CurrencySelectorConstants.DEFAULT_CURRENCY);
    } else {
      handleCurrencyChange(getCookie(currencyKey));
    }
  }, []);
  const currencies = useMemo(() => {
    var _a;
    if (properties.currencies) {
      return (_a = properties.currencies) === null || _a === void 0 ? void 0 : _a.map(({
        label,
        value
      }) => ({
        label: `${label} - ${getCurrencySymbol(label)}`,
        value
      }));
    }
    return [];
  }, [properties.currencies]);
  return jsx(SelectComponent, {
    placeholder: `${selectedCurrency} - ${getCurrencySymbol(selectedCurrency)}`,
    options: currencies,
    onChange: handleCurrencyChange
  });
}

const langKey = process.env['CT_LANGUAGE_COOKIE'];
function LanguageSelector(properties) {
  var _a;
  const [selectedLanguage, setSelectedLanguage] = useState(properties.currentLanguage || '');
  const handleLanguageChange = language => {
    setCookie(langKey, language);
    setSelectedLanguage(language);
    if (properties.onLanguageChange) {
      properties.onLanguageChange(language);
    }
  };
  useEffect(() => {
    const hasLanguageCookie = !!getCookie(langKey);
    if (!hasLanguageCookie) {
      const [languageCode] = navigator.language.split('-');
      handleLanguageChange(languageCode);
    } else {
      handleLanguageChange(getCookie(langKey));
    }
  }, []);
  return jsx(SelectComponent, {
    placeholder: properties.languages && ((_a = properties.languages.find(language => language.value === selectedLanguage)) === null || _a === void 0 ? void 0 : _a.label) || '',
    options: properties.languages,
    onChange: handleLanguageChange
  });
}

const LocationMenuConstants = {
  BASE_CLASSNAME: 'LocationMenu'
};

function LocationMenu(properties) {
  return jsxs("div", Object.assign({
    className: LocationMenuConstants.BASE_CLASSNAME
  }, {
    children: [jsx(TextComponent, Object.assign({
      variant: "h3"
    }, {
      children: properties.headerMenuTitle
    })), jsxs(BoxComponent, {
      children: [jsx(CountrySelector, {
        countries: properties.countries,
        currentCountry: properties.currentCountry,
        onCountryChange: properties.onCountryChange
      }), jsx(LanguageSelector, {
        languages: properties.languages,
        currentLanguage: properties.currentLanguage,
        onLanguageChange: properties.onLanguageChange
      }), jsx(CurrencySelector, {
        currencies: properties.currencies,
        currentCurrency: properties.currentCurrency,
        onCurrencyChange: properties.onCurrencyChange
      })]
    })]
  }));
}

function HeaderComponent(properties) {
  const navigationProperties = {
    toolbox: [jsx(SearchComponent, {
      placeholder: properties.searchPlaceholder || 'Search...',
      onSubmit: properties.onSearch
    }, "search")],
    menu: properties.menu,
    actuator: [...(properties.actuator ? properties.actuator : []), {
      id: 'location',
      label: '',
      children: [jsx(LocationMenu, {
        headerMenuTitle: "Location",
        countries: [{
          label: 'España',
          value: 'es'
        }, {
          label: 'Estados unidos',
          value: 'us'
        }],
        languages: [{
          label: 'Español',
          value: 'es'
        }, {
          label: 'English',
          value: 'en'
        }],
        currencies: [{
          label: 'USD',
          value: 'USD'
        }, {
          label: 'EUR',
          value: 'EUR'
        }],
        onCountryChange: () => console.log('country'),
        onLanguageChange: () => console.log('language'),
        onCurrencyChange: () => console.log('currency')
      }, "location-menu")]
    }]
  };
  return jsxs("header", Object.assign({
    className: "HeaderComponent"
  }, {
    children: [jsx(NavigationComponent, Object.assign({}, navigationProperties)), properties.children]
  }));
}

const CartMenuConstants = {
  BASE_CLASSNAME: 'CartMenu'
};

function CartItemComponent(properties) {
  const {
    data
  } = properties;
  const total = useMemo(() => {
    return parseFloat(data.project_price) * data.amount;
  }, []);
  return jsxs("div", Object.assign({
    className: 'CartItemComponent'
  }, {
    children: [jsx(ImageComponent, {
      src: data.project_thumbnail
    }), jsxs(BoxComponent, {
      children: [jsxs(BoxComponent, Object.assign({
        direction: 'horizontal',
        space: 'between'
      }, {
        children: [jsx(TextComponent, {
          children: data.project_name
        }), jsx(IconComponent, {
          name: IconNames.NEXT,
          size: 14
        })]
      })), jsxs(BoxComponent, Object.assign({
        direction: 'horizontal',
        space: 'between'
      }, {
        children: [jsxs(TextComponent, {
          children: [data.project_price, " ", data.project_currency_token, " X ", data.amount]
        }), jsxs(TextComponent, {
          children: [total.toFixed(2), " ", data.project_currency_token]
        })]
      }))]
    })]
  }));
}

function CartMenu(properties) {
  const [subTotal, setSubTotal] = useState(0);
  const calculateSubTotal = () => {
    var _a;
    if (properties.items) {
      const itemsPrices = (_a = properties.items) === null || _a === void 0 ? void 0 : _a.reduce((accumulator, item) => accumulator + item.amount * parseFloat(item.project_price), 0);
      setSubTotal(itemsPrices);
    }
  };
  const calculateVat = () => {
    return subTotal * (properties.vat || 0.21);
  };
  const calculateTotal = () => {
    return subTotal + subTotal * (properties.vat || 0.21);
  };
  useEffect(() => {
    calculateSubTotal();
    calculateVat();
    calculateTotal();
  }, [properties.items]);
  return jsx("div", Object.assign({
    className: CartMenuConstants.BASE_CLASSNAME
  }, {
    children: (properties === null || properties === void 0 ? void 0 : properties.items) && properties.items.length > 0 ? jsxs(BoxComponent, {
      children: [properties.items.map(item => {
        return jsx(CartItemComponent, {
          data: item
        }, item.id);
      }), jsxs(ColumnComponent, {
        children: [jsxs(BoxComponent, Object.assign({
          space: "between",
          direction: "horizontal"
        }, {
          children: [jsx(TextComponent, {
            children: "Subtotal"
          }), jsx(TextComponent, {
            children: subTotal.toFixed(2)
          })]
        })), jsxs(BoxComponent, Object.assign({
          space: "between",
          direction: "horizontal"
        }, {
          children: [jsx(TextComponent, {
            children: "VAT"
          }), jsx(TextComponent, {
            children: calculateVat().toFixed(2)
          })]
        }))]
      }), jsxs(BoxComponent, Object.assign({
        id: "total-container",
        space: "between",
        direction: "horizontal"
      }, {
        children: [jsx(TextComponent, Object.assign({
          id: "total"
        }, {
          children: "Total"
        })), jsx(TextComponent, {
          children: calculateTotal().toFixed(2)
        })]
      })), jsxs(RowComponent, {
        children: [jsx(ButtonComponent, Object.assign({
          onClick: properties.onEdit,
          variant: "primary"
        }, {
          children: properties.editText
        })), jsx(ButtonComponent, Object.assign({
          onClick: properties.onBuy,
          variant: "important"
        }, {
          children: properties.buyText
        }))]
      })]
    }) : jsx(TextComponent, Object.assign({
      id: "empty-state-text",
      opacity: 0.6
    }, {
      children: properties.emptyText
    }))
  }));
}

const ImageConstants = {
  CLASS: 'ImageComponent'
};

/**
 * Image component
 * @description A component that renders a image image
 * @param {ImageProperties} properties
 * @returns A image component
 */
function ImageComponent(properties) {
  /**
   * Class names definition for the image component based on the properties provided
   */
  const classNames = [
  // Default class
  ImageConstants.CLASS].join(' ');
  return jsxs("div", Object.assign({
    className: classNames
  }, {
    children: [(properties === null || properties === void 0 ? void 0 : properties.icon) && jsx("span", {
      children: properties === null || properties === void 0 ? void 0 : properties.icon
    }), jsx("img", {
      src: properties === null || properties === void 0 ? void 0 : properties.src
    })]
  }));
}

const CasesMenuConstants = {
  BASE_CLASSNAME: 'CaseStudiesMenu'
};

function CaseStudiesMenu(properties) {
  var _a;
  return jsx("div", Object.assign({
    className: CasesMenuConstants.BASE_CLASSNAME,
    style: {
      height: (_a = properties.height) !== null && _a !== void 0 ? _a : 420
    }
  }, {
    children: properties.cases && jsx(ColumnComponent, Object.assign({
      wrap: true
    }, {
      children: properties.cases.map(item => jsxs(ColumnComponent, Object.assign({
        height: 'auto'
      }, {
        children: [item.link ? jsx(LinkComponent, Object.assign({
          url: item.link
        }, {
          children: jsx(TextComponent, Object.assign({
            variant: "h3"
          }, {
            children: item.label
          }))
        }), item.label) : jsx(TextComponent, Object.assign({
          variant: "h3"
        }, {
          children: item.label
        })), item.children && item.children.map(child => jsxs(LinkComponent, Object.assign({
          url: child.link
        }, {
          children: [child.logo && jsx(ImageComponent, {
            src: child.logo
          }), jsx(TextComponent, {
            children: child.label
          })]
        }), child.label))]
      }), item.label))
    }))
  }));
}

const UserMenuConstants = {
  BASE_CLASSNAME: 'UserMenu'
};

function UserMenu(properties) {
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const getToken = () => {
    if (typeof document === 'undefined') {
      return;
    }
    // Find the cookie with the token name as key
    const token = document.cookie.split(';').find(cookie => cookie.includes(process.env['TOKEN_NAME']));
    setUserLoggedIn(!!token);
  };
  useEffect(() => {
    getToken();
  }, []);
  // Function that implements the default login behaviour
  const onLogin = () => {
    (properties === null || properties === void 0 ? void 0 : properties.onLoginSuccess) && properties.onLoginSuccess();
    const currentUrl = window.location.href;
    const loginUrl = `${properties.loginUrl}?redirect=${currentUrl}`;
    window.location.href = loginUrl;
  };
  const deleteAuthCookie = () => {
    document.cookie = process.env['TOKEN_NAME'] + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  };
  const removeTokenFromCookies = () => {
    try {
      if (typeof window !== 'undefined') {
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem(process.env['TOKEN_NAME']);
      }
      deleteAuthCookie();
    } catch (error) {
      return;
    }
  };
  const onLogout = () => {
    try {
      removeTokenFromCookies();
      properties.onLogoutSuccess && properties.onLogoutSuccess();
      window.location.href = properties.loginUrl;
    } catch (error) {
      console.error(error);
    }
  };
  return jsxs("div", Object.assign({
    className: UserMenuConstants.BASE_CLASSNAME
  }, {
    children: [!userLoggedIn && jsxs("div", {
      children: [jsx(ButtonComponent, Object.assign({
        onClick: onLogin,
        variant: "important"
      }, {
        children: properties.loginText
      })), jsxs(RowComponent, Object.assign({
        wrap: true
      }, {
        children: [jsx(TextComponent, Object.assign({
          opacity: 0.6
        }, {
          children: properties.newClientText
        })), jsx(LinkComponent, Object.assign({
          url: properties.registerUrl
        }, {
          children: properties.registerText
        }))]
      }))]
    }), jsx(TextComponent, Object.assign({
      variant: "h3"
    }, {
      children: properties.headerMenuTitle
    })), properties.options && jsxs("ul", {
      children: [properties.options.map(option => jsxs("li", {
        children: [jsx(LinkComponent, Object.assign({
          url: option.url
        }, {
          children: option.label
        })), option.count && jsx(BubbleComponent, Object.assign({
          variant: "info"
        }, {
          children: option.count
        }))]
      }, option.label)), userLoggedIn && jsx("li", Object.assign({
        onClick: onLogout
      }, {
        children: properties.logoutText
      }), "logout")]
    })]
  }));
}

function CenterLayout(properties) {
  return jsx("div", Object.assign({
    className: "CenterLayout"
  }, {
    children: properties.children
  }));
}

const TeamConstants = {
  BASE_CLASSNAME: 'TeamComponent'
};

/**
 * Team component
 *
 * @description An component that displays a circular, square or rounded image
 * @param {TeamProperties} properties
 * @returns A team component
 */
function TeamComponent(properties) {
  // Class names definition for the team component based on the properties provided
  const classNames = [
  // Default class
  TeamConstants.BASE_CLASSNAME,
  // Class when a direction is provided
  ...(properties.direction === 'vertical' ? ['column'] : ['row'])].join(' ');
  return jsxs("div", Object.assign({
    className: classNames
  }, {
    children: [jsx(AvatarComponent, {
      variant: "circle",
      image: properties.image,
      size: 120
    }), jsxs("div", {
      children: [jsx("b", {
        children: properties.name
      }), jsx(TextComponent, Object.assign({
        variant: "p"
      }, {
        children: properties.job
      })), jsx("img", {
        src: "https://previews.123rf.com/images/kalinavova/kalinavova1603/kalinavova160300021/55215792-los-%C3%A1rboles-del-bosque-de-la-primavera-naturaleza-madera-verde-luz-del-sol-fondos-cielo.jpg",
        width: 20,
        height: 20
      })]
    })]
  }));
}

const MessageConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'MessageComponent'
};

/**
 * Message component
 * @description A component that displays a message screen
 * @param {MessageProperties} properties
 * @returns A message component
 */
function MessageComponent(properties) {
  const renderTitle = () => {
    if (typeof properties.title === 'string') {
      return jsx(ReactMarkdown, {
        children: properties.title
      });
    }
    return properties.title;
  };
  const classes = [MessageConstants.BASE_CLASSNAME, ...(properties.complement ? ['haveComplement'] : [])].join(' ');
  return jsx("div", Object.assign({
    className: classes,
    style: {
      backgroundImage: `url(${properties.backgroundImage})`
    }
  }, {
    children: jsxs("div", Object.assign({
      style: {
        background: `${properties.backgroundGradientColor}`
      }
    }, {
      children: [jsxs("div", Object.assign({
        className: 'message'
      }, {
        children: [properties.icon && jsx(IconComponent, {
          name: properties.icon
        }), properties.title && jsx("h1", {
          children: renderTitle()
        }), properties.subTitle && jsx("p", {
          children: properties.subTitle
        }), properties.lateral && jsx("div", Object.assign({
          className: 'lateral'
        }, {
          children: properties.lateral
        })), properties.complement && jsx("div", Object.assign({
          className: 'complement'
        }, {
          children: properties.complement
        }))]
      })), properties.buttons && jsx("div", Object.assign({
        className: 'buttons'
      }, {
        children: properties.buttons
      }))]
    }))
  }));
}

/**
 * Constants for the collage component
 */
const CollageConstants = {
  BASE_CLASSNAME: 'CollageComponent',
  BACKGROUND_IMAGE_GRADIENT: 'linear-gradient(to bottom, rgba(2, 17, 32, 0), rgba(2, 17, 32, 0.7))' // Background image gradient
};

/**
 *
 * @param properties
 * @returns A collage component
 */
function CollageComponent(properties) {
  return jsx("div", Object.assign({
    className: CollageConstants.BASE_CLASSNAME
  }, {
    children: properties.children
  }));
}

const CoverConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'CoverComponent'
};

/**
 * Cover component
 * @description A component that displays a cover screen
 * @param {CoverProperties} properties
 * @returns A cover component
 */
function CoverComponent(properties) {
  return jsx("div", Object.assign({
    className: CoverConstants.BASE_CLASSNAME,
    style: {
      backgroundImage: `url(${properties.image})`
    }
  }, {
    children: properties.children
  }));
}

/**
 * Definition component
 *
 * @description This is the definition component. A componente that displays an icon, a title and a text
 *
 * @param {DefinitionProperties} properties
 *
 * @returns A definition component
 */
function DefinitionComponent(properties) {
  const renderIcon = () => {
    var _a;
    switch (typeof properties.icon) {
      case 'string':
        return jsx("img", {
          src: properties.icon,
          alt: properties.title
        });
      case 'number':
        return properties.icon;
      case 'object':
        return jsx(IconComponent, {
          name: properties.icon.hasOwnProperty('name') ? (_a = properties.icon) === null || _a === void 0 ? void 0 : _a.name : properties === null || properties === void 0 ? void 0 : properties.icon
        });
      default:
        return null;
    }
  };
  const renderDescription = () => {
    if (typeof properties.description === 'string') {
      return jsx(ReactMarkdown, {
        children: properties.description
      });
    }
    return properties.title;
  };
  return jsxs("div", Object.assign({
    className: "DefinitionComponent"
  }, {
    children: [jsx("span", {
      children: renderIcon()
    }), jsxs("div", {
      children: [jsx(TextComponent, Object.assign({
        variant: "h3"
      }, {
        children: properties.title
      })), renderDescription()]
    })]
  }));
}

const SecureConstants = {
  CLASSNAME: 'SecureComponent'
};

/**
 * Secure component
 * @description Component to render secure information
 * @returns {JSX.Element} A secure component
 */
function SecureComponent() {
  // Render a HTTPS / SSL sign
  return jsxs("div", Object.assign({
    className: SecureConstants.CLASSNAME
  }, {
    children: [jsx(TextComponent, {
      children: "HTTPS / SSL"
    }), jsx(TextComponent, Object.assign({
      variant: 'label'
    }, {
      children: "Secure page"
    }))]
  }));
}

const ResultConstants = {
  // Default class name to apply to the component.
  BASE_CLASSNAME: 'ResultComponent'
};

/**
 * Result component
 * @component
 * @description A component that displays a result screen
 * @param {ResultProperties} properties
 * @returns A result component
 */
function ResultComponent(properties) {
  return jsxs("div", Object.assign({
    className: ResultConstants.BASE_CLASSNAME
  }, {
    children: [properties.pie ? properties.pie : null, jsxs("span", {
      children: [jsx(TextComponent, Object.assign({
        variant: 'p',
        opacity: 0.6
      }, {
        children: properties.description
      })), properties.children]
    })]
  }));
}

function Facebook(properties) {
  return jsx("svg", Object.assign({
    width: properties.size || 24,
    height: properties.size || 24,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M17.5 2.625H3.5C3.01613 2.625 2.625 3.017 2.625 3.5V17.5C2.625 17.983 3.01613 18.375 3.5 18.375H11.0381V12.285H8.99238V9.90062H11.0381V8.15062C11.0381 6.11625 12.2806 5.00763 14.1006 5.00763C14.7122 5.00588 15.3247 5.03737 15.9337 5.10125V7.21875H14.6781C13.6911 7.21875 13.4986 7.6895 13.4986 8.37812V9.89625H15.8585L15.5523 12.2806H13.4977V18.375H17.5C17.9839 18.375 18.375 17.983 18.375 17.5V3.5C18.375 3.017 17.9839 2.625 17.5 2.625Z",
      fill: properties.color || '#777E8B'
    })
  }));
}

function Instagram(properties) {
  return jsxs("svg", Object.assign({
    width: properties.size || 24,
    height: properties.size || 24,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      d: "M18.3288 7.26688C18.3192 6.6045 18.1967 5.94738 17.9622 5.32788C17.5518 4.27 16.7162 3.4335 15.6583 3.024C15.0467 2.79388 14.4001 2.6705 13.7456 2.6565C12.9038 2.61888 12.6369 2.60838 10.5002 2.60838C8.36343 2.60838 8.08956 2.60838 7.25393 2.6565C6.60031 2.6705 5.95368 2.79388 5.34206 3.024C4.28418 3.4335 3.44768 4.27 3.03818 5.32788C2.80806 5.9395 2.68381 6.58613 2.67156 7.23975C2.63393 8.08238 2.62256 8.34925 2.62256 10.486C2.62256 12.6228 2.62256 12.8958 2.67156 13.7323C2.68468 14.3868 2.80806 15.0325 3.03818 15.6459C3.44856 16.7029 4.28418 17.5394 5.34293 17.9489C5.95193 18.1869 6.59856 18.3216 7.25481 18.3426C8.09743 18.3802 8.36431 18.3916 10.5011 18.3916C12.6378 18.3916 12.9117 18.3916 13.7473 18.3426C14.4009 18.3295 15.0476 18.2061 15.6601 17.976C16.7179 17.5656 17.5536 16.7291 17.9639 15.6721C18.1941 15.0596 18.3174 14.4139 18.3306 13.7585C18.3682 12.9167 18.3796 12.6499 18.3796 10.5123C18.3778 8.3755 18.3778 8.10425 18.3288 7.26688ZM10.4949 14.5267C8.26018 14.5267 6.44981 12.7164 6.44981 10.4816C6.44981 8.24688 8.26018 6.4365 10.4949 6.4365C12.7279 6.4365 14.5401 8.24688 14.5401 10.4816C14.5401 12.7164 12.7279 14.5267 10.4949 14.5267ZM14.7011 7.23012C14.1787 7.23012 13.7578 6.80838 13.7578 6.28688C13.7578 5.76538 14.1787 5.34363 14.7011 5.34363C15.2217 5.34363 15.6434 5.76538 15.6434 6.28688C15.6434 6.80838 15.2217 7.23012 14.7011 7.23012Z",
      fill: "#777E8B"
    }), jsx("path", {
      d: "M10.4948 13.1093C11.946 13.1093 13.1224 11.9328 13.1224 10.4816C13.1224 9.03043 11.946 7.854 10.4948 7.854C9.04362 7.854 7.86719 9.03043 7.86719 10.4816C7.86719 11.9328 9.04362 13.1093 10.4948 13.1093Z",
      fill: properties.color || '#777E8B'
    })]
  }));
}

function Twitter(properties) {
  return jsx("svg", Object.assign({
    width: properties.size || 24,
    height: properties.size || 24,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M17.1789 6.99737C17.1902 7.1505 17.1902 7.30275 17.1902 7.455C17.1902 12.1144 13.6439 17.4834 7.16275 17.4834C5.166 17.4834 3.311 16.905 1.75 15.9005C2.0335 15.9329 2.3065 15.9442 2.60137 15.9442C4.249 15.9442 5.76537 15.3877 6.97725 14.4384C5.42762 14.406 4.12912 13.391 3.68112 11.9945C3.899 12.0269 4.11775 12.0487 4.347 12.0487C4.66287 12.0487 4.9805 12.005 5.27537 11.9289C3.65925 11.6016 2.44912 10.1832 2.44912 8.47V8.42625C2.919 8.68787 3.46412 8.8515 4.04162 8.87337C3.09225 8.24162 2.47012 7.161 2.47012 5.93862C2.47012 5.28412 2.64425 4.68387 2.94962 4.16062C4.68475 6.29825 7.29312 7.69562 10.2174 7.84875C10.1631 7.58625 10.1299 7.31412 10.1299 7.04112C10.1299 5.09862 11.7014 3.51662 13.6544 3.51662C14.6694 3.51662 15.5855 3.94187 16.2295 4.62962C17.0257 4.4765 17.7887 4.18162 18.466 3.77825C18.2044 4.59637 17.647 5.28412 16.9164 5.72075C17.626 5.64375 18.3137 5.44775 18.9455 5.17475C18.466 5.873 17.8666 6.49512 17.1789 6.99737Z",
      fill: properties.color || '#777E8B'
    })
  }));
}

function Linkedin(properties) {
  return jsx("svg", Object.assign({
    width: properties.size || 24,
    height: properties.size || 24,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M17.5 2.625H3.5C3.01613 2.625 2.625 3.017 2.625 3.5V17.5C2.625 17.983 3.01613 18.375 3.5 18.375H17.5C17.9839 18.375 18.375 17.983 18.375 17.5V3.5C18.375 3.017 17.9839 2.625 17.5 2.625ZM7.29662 16.0449H4.95862V8.52862H7.29662V16.0449ZM6.12762 7.50225C5.37862 7.50225 4.77312 6.895 4.77312 6.14775C4.77312 5.4005 5.37775 4.79325 6.12762 4.79325C6.87487 4.79325 7.48212 5.39963 7.48212 6.14775C7.48212 6.89588 6.87487 7.50225 6.12762 7.50225ZM16.0457 16.0449H13.7104V12.39C13.7104 11.5185 13.6946 10.3976 12.4959 10.3976C11.2796 10.3976 11.095 11.3479 11.095 12.3288V16.0457H8.76137V8.5295H11.0014V9.55675H11.0337C11.3444 8.96612 12.1074 8.34312 13.2422 8.34312C15.6082 8.34312 16.0449 9.89887 16.0449 11.9236V16.0449H16.0457Z",
      fill: properties.color || '#777E8B'
    })
  }));
}

function Youtube(properties) {
  return jsx("svg", Object.assign({
    width: properties.size || 24,
    height: properties.size || 24,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M18.8939 6.30262C18.6927 5.55187 18.102 4.9595 17.3522 4.75737C15.9819 4.38112 10.5 4.375 10.5 4.375C10.5 4.375 5.01904 4.36887 3.64792 4.7285C2.91292 4.92887 2.30567 5.53437 2.10267 6.28425C1.74129 7.6545 1.73779 10.4965 1.73779 10.4965C1.73779 10.4965 1.73429 13.3525 2.09304 14.7087C2.29429 15.4586 2.88492 16.051 3.63567 16.2531C5.01992 16.6294 10.4869 16.6355 10.4869 16.6355C10.4869 16.6355 15.9688 16.6416 17.339 16.2829C18.088 16.0816 18.6813 15.4901 18.8852 14.7402C19.2474 13.3709 19.25 10.5297 19.25 10.5297C19.25 10.5297 19.2675 7.67287 18.8939 6.30262ZM8.74654 13.1294L8.75092 7.87937L13.307 10.5087L8.74654 13.1294Z",
      fill: properties.color || '#777E8B'
    })
  }));
}

/**
 * Social component
 * @description Render the social networks logos passed by properties
 * @param {SocialProperties} properties
 * @returns {JSX.Element} A social component
 */
function SocialComponent(properties) {
  /** Render logo depending on network */
  const renderLogo = network => {
    switch (network) {
      case 'facebook':
        return jsx(Facebook, {});
      case 'instagram':
        return jsx(Instagram, {});
      case 'twitter':
        return jsx(Twitter, {});
      case 'linkedin':
        return jsx(Linkedin, {});
      case 'youtube':
        return jsx(Youtube, {});
      default:
        return null;
    }
  };
  return jsx(Fragment, {
    children: properties.networks.map(network => jsx("a", Object.assign({
      href: network.link
    }, {
      children: renderLogo(network.name)
    }), network.name))
  });
}

function LoaderComponent() {
  return jsx("div", Object.assign({
    className: "LoaderComponent"
  }, {
    children: jsxs("div", {
      children: [jsx("i", {}), jsx("i", {}), jsx("i", {}), jsx("i", {})]
    })
  }));
}

/**
 * Constants for the Grid component
 */
const GridConstants = {
  BASE_CLASSNAME: 'GridComponent' // Default class name to apply to the component.
};

/**
 * Grid component
 * @description A component that renders items in a grid
 * @param {GridProperties} properties
 * @returns A grid component
 */
function GridComponent(properties) {
  return jsx("div", Object.assign({
    className: GridConstants.BASE_CLASSNAME
  }, {
    children: properties.children
  }));
}

/**
 * Constants defining the Fieldset component
 */
const FieldsetConstants = {
  BASE_CLASSNAME: 'FieldsetComponent',
  LABEL: 'label' // Label for the fieldset
};

/**
 * Fieldset Component
 * @description An simple fieldset component to surround a group of inputs that also has a label
 * @param {FieldsetProperties} properties
 * @returns A fieldset component
 */
function FieldsetComponent(properties) {
  return jsxs("fieldset", Object.assign({
    className: FieldsetConstants.BASE_CLASSNAME
  }, {
    children: [jsx(TextComponent, Object.assign({
      variant: FieldsetConstants.LABEL
    }, {
      children: properties.label
    })), jsx("div", {
      children: properties.children
    })]
  }));
}

export { AccordionComponent as Accordion, AsideLayout as Aside, AutocompleteComponent as Autocomplete, AvatarComponent as Avatar, BackgroundComponent as Background, BlockquoteComponent as Blockquote, BlurComponent as Blur, BoxComponent as Box, BreadcrumbsComponent as Breadcrumbs, BubbleComponent as Bubble, ButtonComponent as Button, CardComponent as Card, CarrouselComponent as Carrousel, CenterLayout as Center, CheckboxComponent as Checkbox, CollageComponent as Collage, ColumnComponent as Column, CounterComponent as Counter, CoverComponent as Cover, DefinitionComponent as Definition, DetailsComponent as Details, DonutChart as Donut, DrawerComponent as Drawer, EditorComponent as Editor, FieldsetComponent as Fieldset, FooterLayout as Footer, GalleryComponent as Gallery, GridComponent as Grid, NavigationComponent as Header, CartMenu as HeaderCartMenu, CaseStudiesMenu as HeaderCasesMenu, HeaderComponent as HeaderLayout, LocationMenu as HeaderLocatioMenu, UserMenu as HeaderUserMenu, HeroComponent as Hero, HolderComponent as Holder, IconComponent as Icon, IconNames as Icons, ImageComponent as Image, LinkComponent as Link, ListComponent as List, LoaderComponent as Loader, LogotypeComponent as Logotype, LoremComponent as Lorem, MainLayout as Main, MessageComponent as Message, MeterComponent as Meter, ModalComponent as Modal, NavLayout as Nav, NavigationComponent as Navigation, NumberComponent as Number, PartComponent as Part, PaymentComponent as Payments, PieComponent as Pie, RadioComponent as Radio, RangeComponent as Range, ResultComponent as Result, RowComponent as Row, SearchComponent as Search, SectionLayout as Section, SecureComponent as Secure, SelectComponent as Select, SocialComponent as Social, SpaceComponent as Space, SummaryComponent as Summary, SwitchComponent as Switch, TeamComponent as Team, TextComponent as Text, TooltipComponent as Tooltip, WidgetComponent as Widget, ZoneComponent as Zone };
